function numeralFemaleEnding(condition) {
    return condition + "-ші";
}

function numeralMaleEnding(condition) {
    return condition + "-ші";
}

function numeralNeuterEnding(condition) {
    return condition + "-ші";
}

function plural(count, parameters) {
    if (count === 1) {
        return parameters[0];
    }
    return parameters[1];
}

function signed(condition) {
    if (condition === 0) {
        return '0';
    }

    const num = Number.parseFloat(condition.toFixed(2));

    if (condition > 0) {
        return '+' + num.toString();
    }

    return num.toString();
}

function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}

const sl_b1 = (match, outcome) => 'Нәтижесі';
const sl_c1 = (match, outcome) => 'Фора';
const sl_d1 = (match, outcome) => 'Тоталы';
const sl_e1 = (match, outcome) => `Кім ${outcome.condition} ұпайды бірінші болып алады?`;
const sl_f1 = (match, outcome) => `Кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const sl_g1 = (match, outcome) => `${match.homeTeam} тура ${outcome.condition} ұпаймен жеңеді`;
const sl_h1 = (match, outcome) => `${match.awayTeam} туура ${outcome.condition} ұпаймен жеңеді`;
const sl_i1 = (match, outcome) => `Тотал: ${match.homeTeam}`;
const sl_j1 = (match, outcome) => `Тотал: ${match.awayTeam}`;
const sl_k1 = (match, outcome) => `${match.homeTeam} туура ${outcome.condition} ұпаймен жеңеді`;
const sl_l1 = (match, outcome) => 'Победа';
const sl_m1 = (match, outcome) => 'Тотал';
const sl_n1 = (match, outcome) => 'Дәл тоталы';
const sl_o1 = (match, outcome) => `${match.homeTeam} Айырмашылықпен жеңіс`;
const sl_p1 = (match, outcome) => `${match.awayTeam} Айырмашылықпен жеңіс`;
const sl_q1 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])}`;
const sl_r1 = (match, outcome) => 'Ұпай айырмашылығы';
const sl_s1 = (match, outcome) => 'Разница очков';
const sl_t1 = (match, outcome) => 'Нәтиже';
const sl_u1 = (match, outcome) => `Тотал: ${match.homeTeam}`;
const sl_v1 = (match, outcome) => `Тотал: ${match.awayTeam}`;
const sl_w1 = (match, outcome) => 'Первый в матче';
const sl_x1 = (match, outcome) => 'Результат';
const sl_y1 = (match, outcome) => 'Точный тотал';
const sl_z1 = (match, outcome) => `${match.homeTeam} Победа с разницей`;
const sl_a2 = (match, outcome) => `${match.awayTeam} Победа с разницей`;
const sl_b2 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])}`;
const sl_c2 = (match, outcome) => 'Сколько команд забьет?';
const sl_d2 = (match, outcome) => 'Точный счет';
const sl_e2 = (match, outcome) => `Жеңіс және сеттің тоталы ${outcome.condition}`;
const sl_f2 = (match, outcome) => 'Жұп/тақ болуы';
const sl_g2 = (match, outcome) => `${match.homeTeam} айырмашылықпен жеңеді`;
const sl_h2 = (match, outcome) => `${match.awayTeam} айырмашылықпен жеңеді`;
const sl_i2 = (match, outcome) => `${match.homeTeam} Дәл тоталы`;
const sl_j2 = (match, outcome) => `${match.awayTeam} Дәл тоталы`;
const sl_k2 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко?`;
const sl_l2 = (match, outcome) => 'Победа с разницей';
const sl_m2 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['убийство', 'убийства', 'убийств'])}`;
const sl_n2 = (match, outcome) => 'First Blood';
const sl_o2 = (match, outcome) => `${match.homeTeam} жеңіспен жеңеді`;
const sl_p2 = (match, outcome) => `${match.awayTeam} жеңіспен жеңеді`;
const sl_q2 = (match, outcome) => `${match.homeTeam} тек соғады ма?`;
const sl_r2 = (match, outcome) => `${match.awayTeam} тек соғады ма?`;
const sl_s2 = (match, outcome) => 'Дәл есебі';
const sl_t2 = (match, outcome) => 'Қанша команда соғады';
const sl_u2 = (match, outcome) => `Неше гол салады ${match.homeTeam}?`;
const sl_v2 = (match, outcome) => `Неше гол салады ${match.awayTeam}?`;
const sl_w2 = (match, outcome) => 'Өтелген уақыт';
const sl_x2 = (match, outcome) => `Еуропалылық фора ${europeanHandicapCondition(outcome.condition)}`;
const sl_y2 = (match, outcome) => `Кім ${numeralMaleEnding(outcome.condition)} гол салады?`;
const sl_z2 = (match, outcome) => `Қалған уақыты (текущий счет ${outcome.condition}:${outcome.conditionTwo})`;
const sl_a3 = (match, outcome) => 'Қосарлы нәтиже';
const sl_b3 = (match, outcome) => 'Әр жалаушадан';
const sl_c3 = (match, outcome) => 'За симуляцию';
const sl_d3 = (match, outcome) => 'За снятую футболку';
const sl_e3 = (match, outcome) => 'Дәл есеп';
const sl_f3 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam}`;
const sl_g3 = (match, outcome) => `Салынған пенальти тоталы: ${match.awayTeam}`;
const sl_h3 = (match, outcome) => `Салынған пенальти тоталы: ${match.homeTeam}`;
const sl_i3 = (match, outcome) => 'Салынған пенальти тоталы';
const sl_j3 = (match, outcome) => 'Салынбаған пенальти тоталы';
const sl_k3 = (match, outcome) => `Сколько голов забьет ${match.homeTeam}?`;
const sl_l3 = (match, outcome) => `Сколько голов забьет ${match.awayTeam}?`;
const sl_m3 = (match, outcome) => 'Кім бірінші болып шар соғады?';
const sl_n3 = (match, outcome) => `Бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const sl_o3 = (match, outcome) => 'Кандай түсті шар бірінші болып салынады?';
const sl_p3 = (match, outcome) => `${match.awayTeam} тура ${outcome.condition} ұпаймен жеңеді`;
const sl_q3 = (match, outcome) => 'Чет/Нечет тотала';
const sl_r3 = (match, outcome) => `${outcome.condition} геймде болобу?`;
const sl_s3 = (match, outcome) => 'Брейктердің тоталы';
const sl_t3 = (match, outcome) => `Бірінші болып кім ${outcome.condition} геймді алады`;
const sl_u3 = (match, outcome) => `Жеңіс және тоталы ${outcome.condition}`;
const sl_v3 = (match, outcome) => 'Тай-брейк бола ма?';
const sl_w3 = (match, outcome) => 'Тай-брейкте кім жеңеді?';
const sl_x3 = (match, outcome) => 'Тай-брейктің дәл тоталы';
const sl_y3 = (match, outcome) => 'Тай-брейктің дәл есебі';
const sl_z3 = (match, outcome) => 'Тай-брейктің тоталы';
const sl_a4 = (match, outcome) => `Брейктердің тоталы: ${match.homeTeam}`;
const sl_b4 = (match, outcome) => `Брейктердің тоталы: ${match.awayTeam}`;
const sl_c4 = (match, outcome) => `әлдекім қатарынан ${outcome.condition} гейм ұтады ма?`;
const sl_d4 = (match, outcome) => `${match.homeTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const sl_e4 = (match, outcome) => `${match.awayTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const sl_f4 = (match, outcome) => 'Кім көп брейк жасайды';
const sl_g4 = (match, outcome) => 'Брейктерден фора';
const sl_h4 = (match, outcome) => `Победа и тотал ${outcome.condition}`;
const sl_i4 = (match, outcome) => 'Чет/Нечет';

const bo_b1 = (match, outcome) => 'Фора';
const bo_c1 = (match, outcome) => 'Матч тоталы';
const bo_d1 = (match, outcome) => `Тотал: ${match.homeTeam}`;
const bo_e1 = (match, outcome) => `Тотал: ${match.awayTeam}`;
const bo_f1 = (match, outcome) => 'Матч тоталының жұп/тақ болуы';
const bo_g1 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam}`;
const bo_h1 = (match, outcome) => `${outcome.teamOne} - ${outcome.teamTwo}`;
const bo_i1 = (match, outcome) => `${outcome.teamOne}`;
const bo_j1 = (match, outcome) => 'Бірінші сеттегі фора';
const bo_k1 = (match, outcome) => 'Екінші сеттегі фора';
const bo_l1 = (match, outcome) => 'Үшінші сеттегі фора';
const bo_m1 = (match, outcome) => 'Бірінші сеттің тоталы';
const bo_n1 = (match, outcome) => 'Екінші сеттің тоталы';
const bo_o1 = (match, outcome) => 'Үшінші сеттің тоталы';
const bo_p1 = (match, outcome) => 'Матчтағы сеттер тоталы';
const bo_q1 = (match, outcome) => 'Матч есебі';
const bo_r1 = (match, outcome) => 'Бірінші сет нәтижесі';
const bo_s1 = (match, outcome) => 'Екінші сет нәтижесі';
const bo_t1 = (match, outcome) => 'Үшінші сет нәтижесі';
const bo_u1 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші сетте`;
const bo_v1 = (match, outcome) => `Тотал: ${match.homeTeam} екінші сетте`;
const bo_w1 = (match, outcome) => `Тотал: ${match.homeTeam} үшінші сетте`;
const bo_x1 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші сетте`;
const bo_y1 = (match, outcome) => `Тотал: ${match.awayTeam} екінші сетте`;
const bo_z1 = (match, outcome) => `Тотал: ${match.awayTeam} үшінші сетте`;
const bo_a2 = (match, outcome) => `${match.homeTeam} бірінші сетте тура ${outcome.condition} ұпаймен жеңеді`;
const bo_b2 = (match, outcome) => `${match.homeTeam} екінші сетте туура ${outcome.condition} ұпаймен жеңеді`;
const bo_c2 = (match, outcome) => `${match.homeTeam} үшінші сетте туура ${outcome.condition} ұпаймен жеңеді`;
const bo_d2 = (match, outcome) => `${match.awayTeam} бірінші сетте туура ${outcome.condition} ұпаймен жеңеді`;
const bo_e2 = (match, outcome) => `${match.awayTeam} екінші сетте туура ${outcome.condition} ұпаймен жеңеді`;
const bo_f2 = (match, outcome) => `${match.awayTeam} үшінші сетте туура ${outcome.condition} ұпаймен жеңеді`;
const bo_g2 = (match, outcome) => `Бірінші сетте кім ${outcome.condition} ұпайды бірінші болып алады?`;
const bo_h2 = (match, outcome) => `Екінші сетте кім ${outcome.condition} ұпайды бірінші болып алады?`;
const bo_i2 = (match, outcome) => `Үшінші сетте кім ${outcome.condition} ұпайды бірінші болып алады?`;
const bo_j2 = (match, outcome) => `Бірінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_k2 = (match, outcome) => `Екінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_l2 = (match, outcome) => `Үшінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_m2 = (match, outcome) => 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс';
const bo_n2 = (match, outcome) => 'Екінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс';
const bo_o2 = (match, outcome) => 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс';
const bo_p2 = (match, outcome) => 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі фора';
const bo_q2 = (match, outcome) => 'Екінші сеттің 10 ұпайына дейін шағын сеттегі фора';
const bo_r2 = (match, outcome) => 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі фора';
const bo_s2 = (match, outcome) => 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі тотал';
const bo_t2 = (match, outcome) => 'Екінші сеттің 10 ұпайына дейін шағын сеттегі тотал';
const bo_u2 = (match, outcome) => 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі тотал';
const bo_v2 = (match, outcome) => 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс';
const bo_w2 = (match, outcome) => 'Екінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс';
const bo_x2 = (match, outcome) => 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс';
const bo_y2 = (match, outcome) => 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі фора';
const bo_z2 = (match, outcome) => 'Екінші сеттің 15 ұпайына дейін шағын сеттегі фора';
const bo_a3 = (match, outcome) => 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі фора';
const bo_b3 = (match, outcome) => 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі тотал';
const bo_c3 = (match, outcome) => 'Екінші сеттің 15 ұпайына дейін шағын сеттегі тотал';
const bo_d3 = (match, outcome) => 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі тотал';
const bo_e3 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші таймда`;
const bo_f3 = (match, outcome) => 'Бірінші таймдағы фора';
const bo_g3 = (match, outcome) => 'Бірінші тайм нәтижесі';
const bo_h3 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші таймда`;
const bo_i3 = (match, outcome) => `Кім ${numeralMaleEnding(outcome.condition)} гол соғады?`;
const bo_j3 = (match, outcome) => 'Қосарлы нәтиже';
const bo_k3 = (match, outcome) => 'Бірінші таймның тоталы';
const bo_l3 = (match, outcome) => `Жеңіс және матч тоталы ${outcome.condition}`;
const bo_m3 = (match, outcome) => `${match.homeTeam} тура ${outcome.condition} голмен жеңеді`;
const bo_n3 = (match, outcome) => `${match.awayTeam} тура ${outcome.condition} голмен жеңеді`;
const bo_o3 = (match, outcome) => 'Матчтың дәл тоталы';
const bo_p3 = (match, outcome) => 'Қанша команда соғады';
const bo_q3 = (match, outcome) => 'Дәл есеп';
const bo_r3 = (match, outcome) => 'Азиялық фора';
const bo_s3 = (match, outcome) => 'Бірінші ширектегі фора';
const bo_t3 = (match, outcome) => 'Екінші ширектегі фора';
const bo_u3 = (match, outcome) => 'Үшінші ширектегі фора';
const bo_v3 = (match, outcome) => 'Төртінші ширектегі фора';
const bo_w3 = (match, outcome) => 'Бірінші ширектiң тоталы';
const bo_x3 = (match, outcome) => 'Екінші ширектің тоталы';
const bo_y3 = (match, outcome) => 'Үшінші ширектің тоталы';
const bo_z3 = (match, outcome) => 'Төртінші ширектің тоталы';
const bo_a4 = (match, outcome) => 'Бірінші ширек нәтижесі';
const bo_b4 = (match, outcome) => 'Екінші ширек нәтижесі';
const bo_c4 = (match, outcome) => 'Үшінші ширек нәтижесі';
const bo_d4 = (match, outcome) => 'Төртінші ширек нәтижесі';
const bo_e4 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші ширекте`;
const bo_f4 = (match, outcome) => `Тотал: ${match.homeTeam} екінші ширекте`;
const bo_g4 = (match, outcome) => `Тотал: ${match.homeTeam} үшінші ширекте`;
const bo_h4 = (match, outcome) => `Тотал: ${match.homeTeam} төртінші ширекте`;
const bo_i4 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші ширекте`;
const bo_j4 = (match, outcome) => `Тотал: ${match.awayTeam} екінші ширекте`;
const bo_k4 = (match, outcome) => `Тотал: ${match.awayTeam} үшінші ширекте`;
const bo_l4 = (match, outcome) => `Тотал: ${match.awayTeam} төртінші ширекте`;
const bo_m4 = (match, outcome) => 'Бірінші жартының тоталы';
const bo_n4 = (match, outcome) => 'Екінші жартыдағы нәтиже';
const bo_o4 = (match, outcome) => 'Екінші жартының тоталы';
const bo_p4 = (match, outcome) => 'Бірінші жартыдағы фора';
const bo_q4 = (match, outcome) => 'Екінші жартыдағы фора';
const bo_r4 = (match, outcome) => 'Бірінші жартыдағы нәтиже';
const bo_s4 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші жартыда`;
const bo_t4 = (match, outcome) => `Тотал: ${match.homeTeam} екiншi жартыда`;
const bo_u4 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші жартыда`;
const bo_v4 = (match, outcome) => `Тотал: ${match.awayTeam} екiншi жартыда`;
const bo_w4 = (match, outcome) => `Бірінші ширекте кім бірінші болып ${outcome.condition} ұпай жинайды`;
const bo_x4 = (match, outcome) => `Екінші ширекте кім бірінші болып ${outcome.condition} ұпай жинайды`;
const bo_y4 = (match, outcome) => `Үшінші ширекте кім бірінші болып ${outcome.condition} ұпай жинайды`;
const bo_z4 = (match, outcome) => `Төртінші ширекте кім бірінші болып ${outcome.condition} ұпай жинайды`;
const bo_a5 = (match, outcome) => 'Бірінші ширектің дәл тоталы';
const bo_b5 = (match, outcome) => 'Екінші ширектің дәл тоталы';
const bo_c5 = (match, outcome) => 'Үшінші ширектің дәл тоталы';
const bo_d5 = (match, outcome) => 'Төртінші ширектің дәл тоталы';
const bo_e5 = (match, outcome) => `${match.homeTeam} айырмашылықпен жеңеді`;
const bo_f5 = (match, outcome) => `${match.awayTeam} айырмашылықпен жеңеді`;
const bo_g5 = (match, outcome) => 'Өту';
const bo_h5 = (match, outcome) => `${match.homeTeam} барлық ширекте жеңеді`;
const bo_i5 = (match, outcome) => `${match.awayTeam} барлық ширекте жеңеді`;
const bo_j5 = (match, outcome) => `${match.homeTeam} екі жартылықта жеңеді`;
const bo_k5 = (match, outcome) => `${match.awayTeam} екі жартылықта жеңеді`;
const bo_l5 = (match, outcome) => 'Ең нәтижелі жартылық';
const bo_m5 = (match, outcome) => 'Ең нәтижелі ширек';
const bo_n5 = (match, outcome) => 'Ең нәтижелі ширектің тоталы';
const bo_o5 = (match, outcome) => 'Ең нәтижесіз ширектің тоталы';
const bo_p5 = (match, outcome) => `${match.homeTeam} бірінші ширекте және матчта жеңеді`;
const bo_q5 = (match, outcome) => `${match.awayTeam} бірінші ширекте және матчта жеңеді`;
const bo_r5 = (match, outcome) => `${match.homeTeam} бірінші жартылықта және матчта жеңеді`;
const bo_s5 = (match, outcome) => `${match.awayTeam} бірінші жартылықта және матчта жеңеді`;
const bo_t5 = (match, outcome) => 'Овертайм бола ма';
const bo_u5 = (match, outcome) => 'Айырмашылықпен жеңіс';
const bo_v5 = (match, outcome) => 'Бірінші ширекте айырмашылықпен жеңіс';
const bo_w5 = (match, outcome) => 'Екінші ширекте айырмашылықпен жеңіс';
const bo_x5 = (match, outcome) => 'Үшінші ширекте айырмашылықпен жеңіс';
const bo_y5 = (match, outcome) => 'Төртінші ширекте айырмашылықпен жеңіс';
const bo_z5 = (match, outcome) => `Тотал: ${outcome.playerName} (${match.homeTeam})`;
const bo_a6 = (match, outcome) => `Тотал: ${outcome.playerName} (${match.awayTeam})`;
const bo_b6 = (match, outcome) => 'Тотал: 3-ұпайлық лақтырулар';
const bo_c6 = (match, outcome) => 'Тотал: 2-ұпайлық лақтырулар';
const bo_d6 = (match, outcome) => `Тотал: ${match.homeTeam} 3-ұпайлық лақтырулар`;
const bo_e6 = (match, outcome) => `Тотал: ${match.awayTeam} 3-ұпайлық лақтырулар`;
const bo_f6 = (match, outcome) => `Тотал: ${match.homeTeam} 2-ұпайлық лақтырулар`;
const bo_g6 = (match, outcome) => `Тотал: ${match.awayTeam} 2-ұпайлық лақтырулар`;
const bo_h6 = (match, outcome) => 'Фора 3-ұпайлық лақтырулар';
const bo_i6 = (match, outcome) => 'Фора 2-ұпайлық лақтырулар';
const bo_j6 = (match, outcome) => 'Нәтиже по 3-ұпайлық лақтырулар';
const bo_k6 = (match, outcome) => '2-ұпайлық лақтырулар бойынша нәтиже';
const bo_l6 = (match, outcome) => 'Ең нәтижесіз ширек';
const bo_m6 = (match, outcome) => 'Матчта доп беру тоталы';
const bo_n6 = (match, outcome) => `Матчта ${match.homeTeam} доп беру тоталы`;
const bo_o6 = (match, outcome) => `Матчта ${match.awayTeam} доп беру тоталы`;
const bo_p6 = (match, outcome) => 'Матчта доп берулерден фора';
const bo_q6 = (match, outcome) => 'Матчта доп берулерден жеңіс';
const bo_r6 = (match, outcome) => 'Матчтағы бірінші 2-ұпайлық лақтыру';
const bo_s6 = (match, outcome) => 'Матчтағы бірінші 3-ұпайлық лақтыру';
const bo_t6 = (match, outcome) => 'Матчтағы бірінші айыппұл доп';
const bo_u6 = (match, outcome) => 'Қайсысы ертерек болады';
const bo_v6 = (match, outcome) => 'Ширектегі ең көп ұпай саны';
const bo_w6 = (match, outcome) => `Матчта кім бірінші болып ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} ұпай алады`;
const bo_x6 = (match, outcome) => 'Матчта трипл-дабл тоталы';
const bo_y6 = (match, outcome) => 'Матчта дабл-дабл тоталы';
const bo_z6 = (match, outcome) => `Бірінші ширекте кім бірінші болып ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} ұпай алады`;
const bo_a7 = (match, outcome) => `Екінші ширекте кім бірінші болып ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} ұпай алады`;
const bo_b7 = (match, outcome) => `Үшінші ширекте кім біріншіболып ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} ұпай алады`;
const bo_c7 = (match, outcome) => `Төртінші ширекте кім бірінші болып ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} ұпай алады`;
const bo_d7 = (match, outcome) => 'Матчтағы ұпай айырмашылығы';
const bo_e7 = (match, outcome) => 'Бірінші ширектегі ұпай айырмашылығы';
const bo_f7 = (match, outcome) => 'Екінші ширектегі ұпай айырмашылығы';
const bo_g7 = (match, outcome) => 'Үшінші ширектегі ұпай айырмашылығы';
const bo_h7 = (match, outcome) => 'Төртінші ширектегі ұпай айырмашылығы';
const bo_i7 = (match, outcome) => 'Бірінші жартылықта фора';
const bo_j7 = (match, outcome) => 'Екінші жартылықта фора';
const bo_k7 = (match, outcome) => 'Бірінші жартылық нәтижесі';
const bo_l7 = (match, outcome) => 'Екінші жартылық нәтижесі';
const bo_m7 = (match, outcome) => 'Бірінші жартылықтың тоталы';
const bo_n7 = (match, outcome) => 'Екінші жартылықтың тоталы';
const bo_o7 = (match, outcome) => 'Бірінші жартылықтың нақты тоталы';
const bo_p7 = (match, outcome) => 'Овертайм болады ма';
const bo_q7 = (match, outcome) => 'Бірінші жартылықта айырмашылықпен жеңіс';
const bo_r7 = (match, outcome) => 'Екінші жартылықта айырмашылықпен жеңіс';
const bo_s7 = (match, outcome) => `Кім бірінші жартылықта бірінші болып ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} алады`;
const bo_t7 = (match, outcome) => `Кім екінші жартылықта бірінші болып ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} алады`;
const bo_u7 = (match, outcome) => 'Матчтың нақты тоталы';
const bo_v7 = (match, outcome) => `Кім матчта бірінші болып${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} алады`;
const bo_w7 = (match, outcome) => 'Ең нәтижелі жартылықтың тоталы';
const bo_x7 = (match, outcome) => 'Ең нәтижесіз жартылықтың тоталы';
const bo_y7 = (match, outcome) => `${match.homeTeam} жартылықтың екеуін де жеңеді`;
const bo_z7 = (match, outcome) => `${match.awayTeam} жартылықтың екеуін де жеңеді`;
const bo_a8 = (match, outcome) => `${match.homeTeam} бірінші жартылықты және матчты жеңеді`;
const bo_b8 = (match, outcome) => `${match.awayTeam} бірінші жартылықты және матчты жеңеді`;
const bo_c8 = (match, outcome) => 'Тотал: 3-ұпайлық лақтыру';
const bo_d8 = (match, outcome) => 'Тотал: 2-ұпайлық лақтыру';
const bo_e8 = (match, outcome) => 'Фора 3-ұпайлық лақтыру';
const bo_f8 = (match, outcome) => 'Фора 2-ұпайлық лақтыру';
const bo_g8 = (match, outcome) => '3-ұпайлық лақтыру бойынша нәтиже';
const bo_h8 = (match, outcome) => '2-ұпайлық лақтыру бойынша нәтиже';
const bo_i8 = (match, outcome) => 'Матч тоталының жұп/тағы';
const bo_j8 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші жартылықта`;
const bo_k8 = (match, outcome) => `Тотал: ${match.homeTeam} екінші жартылықта`;
const bo_l8 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші жартылықта`;
const bo_m8 = (match, outcome) => `Тотал: ${match.awayTeam} екінші жартылықта`;
const bo_n8 = (match, outcome) => 'Бірінші кезеңнiң тоталы';
const bo_o8 = (match, outcome) => 'Екінші кезеңнiң тоталы';
const bo_p8 = (match, outcome) => 'Үшінші кезеңнiң тоталы';
const bo_q8 = (match, outcome) => 'Бірінші кезең нәтижесі';
const bo_r8 = (match, outcome) => 'Екінші кезең нәтижесі';
const bo_s8 = (match, outcome) => 'Үшінші кезең нәтижесі';
const bo_t8 = (match, outcome) => 'Пенальтиді ескерумен жеңіс';
const bo_u8 = (match, outcome) => '1айырмашылықпен жеңіс';
const bo_v8 = (match, outcome) => '2 1айырмашылықпен жеңіс';
const bo_w8 = (match, outcome) => 'Бірінші кезеңде неше команда соғады?';
const bo_x8 = (match, outcome) => 'Екінші кезеңде неше команда соғады?';
const bo_y8 = (match, outcome) => 'Үшінші кезеңде неше команда соғады?';
const bo_z8 = (match, outcome) => 'Кезең-Матч';
const bo_a9 = (match, outcome) => 'Овертайм тоталы';
const bo_b9 = (match, outcome) => 'Оветайм нәтижесі';
const bo_c9 = (match, outcome) => 'Овертаймдағы фора';
const bo_d9 = (match, outcome) => 'Бірінші кезеңдегі фора';
const bo_e9 = (match, outcome) => 'Екінші кезеңдегі фора';
const bo_f9 = (match, outcome) => 'Үшінші кезеңдегі фора';
const bo_g9 = (match, outcome) => 'Бірінші кезеңнің нақты есебі';
const bo_h9 = (match, outcome) => 'Екінші кезеңнің нақты есебі';
const bo_i9 = (match, outcome) => 'Үшінші кезеңнің нақты есебі';
const bo_j9 = (match, outcome) => `Кім ${numeralMaleEnding(outcome.condition)} голды салады?`;
const bo_k9 = (match, outcome) => 'Матчта партиялар бойынша фора';
const bo_l9 = (match, outcome) => 'Бірінші сеттің дәл тоталы';
const bo_m9 = (match, outcome) => 'Екінші сеттің дәл тоталы';
const bo_n9 = (match, outcome) => 'Үшінші сеттің дәл тоталы';
const bo_o9 = (match, outcome) => `${match.homeTeam} бірінші сетте айырмашылықпен жеңеді`;
const bo_p9 = (match, outcome) => `${match.homeTeam} екінші сетте айырмашылықпен жеңеді`;
const bo_q9 = (match, outcome) => `${match.homeTeam} үшінші сетте айырмашылықпен жеңеді`;
const bo_r9 = (match, outcome) => `${match.awayTeam} бірінші сетте айырмашылықпен жеңеді`;
const bo_s9 = (match, outcome) => `${match.awayTeam} екінші сетте айырмашылықпен жеңеді`;
const bo_t9 = (match, outcome) => `${match.awayTeam} үшінші сетте айырмашылықпен жеңеді`;
const bo_u9 = (match, outcome) => 'Бірінші сеттің жұп/тақ болуы';
const bo_v9 = (match, outcome) => 'Екінші сеттің жұп/тақ болуы';
const bo_w9 = (match, outcome) => 'Үшінші сеттің жұп/тақ болуы';
const bo_x9 = (match, outcome) => `Жеңіс және бірінші сеттің тоталы ${outcome.condition}`;
const bo_y9 = (match, outcome) => `Жеңіс және екінші сеттің тоталы ${outcome.condition}`;
const bo_z9 = (match, outcome) => `Жеңіс және үшінші сеттің тоталы ${outcome.condition}`;
const bo_a10 = (match, outcome) => 'Шағын сетте бірінші сеттің 10 ұпайына дейін жеңіс';
const bo_b10 = (match, outcome) => 'Шағын сетте екінші сеттің 10 ұпайына дейін жеңіс';
const bo_c10 = (match, outcome) => 'Шағын сетте бірінші сеттің 10 ұпайына дейін фора';
const bo_d10 = (match, outcome) => 'Шағын сетте екінші сеттің 10 ұпайына дейін фора';
const bo_e10 = (match, outcome) => 'Шағын сетте бірінші сеттің 10 ұпайына дейін тотал';
const bo_f10 = (match, outcome) => 'Шағын сетте екінші сеттің 10 ұпайына дейін тотал';
const bo_g10 = (match, outcome) => 'Шағын сетте екінші сеттің 15 ұпайына дейін жеңіс';
const bo_h10 = (match, outcome) => 'Шағын сетте бірінші сеттің 15 ұпайына дейін фора';
const bo_i10 = (match, outcome) => 'Шағын сетте екінші сеттің 15 ұпайына дейін фора';
const bo_j10 = (match, outcome) => 'Шағын сетте бірінші сеттің 15 ұпайына дейін тотал';
const bo_k10 = (match, outcome) => 'Шағын сетте екінші сеттің 15 ұпайына дейін тотал';
const bo_l10 = (match, outcome) => `Бірінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай жеңеді`;
const bo_m10 = (match, outcome) => `Екінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай жеңеді`;
const bo_n10 = (match, outcome) => `Үшінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай жеңеді`;
const bo_o10 = (match, outcome) => 'Бірінші сетте айырмашылықпен жеңіс';
const bo_p10 = (match, outcome) => 'Екінші сетте айырмашылықпен жеңіс';
const bo_q10 = (match, outcome) => 'Үшінші сетте айырмашылықпен жеңіс';
const bo_r10 = (match, outcome) => 'Тотал: Бірінші атыс шебіде';
const bo_s10 = (match, outcome) => 'Тотал: Екінші атыс шебіде';
const bo_t10 = (match, outcome) => 'Тотал: Үшінші атыс шебіде';
const bo_u10 = (match, outcome) => 'Тотал: Төртінші атыс шебіде';
const bo_v10 = (match, outcome) => 'Тотал: Бесінші атыс шебіде';
const bo_w10 = (match, outcome) => 'Тотал: Алтыншы атыс шебіде';
const bo_x10 = (match, outcome) => 'Тотал: Жетінші атыс шебіде';
const bo_y10 = (match, outcome) => 'Тотал: Сегізінші атыс шебіде';
const bo_z10 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші атыс шебіде`;
const bo_a11 = (match, outcome) => `Тотал: ${match.homeTeam} екінші атыс шебіде`;
const bo_b11 = (match, outcome) => `Тотал: ${match.homeTeam} үшінші атыс шебіде`;
const bo_c11 = (match, outcome) => `Тотал: ${match.homeTeam} төртінші атыс шебіде`;
const bo_d11 = (match, outcome) => `Тотал: ${match.homeTeam} бесінші атыс шебіде`;
const bo_e11 = (match, outcome) => `Тотал: ${match.homeTeam} алтыншы атыс шебіде`;
const bo_f11 = (match, outcome) => `Тотал: ${match.homeTeam} жетінші атыс шебіде`;
const bo_g11 = (match, outcome) => `Тотал: ${match.homeTeam} сегізінші атыс шебіде`;
const bo_h11 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші атыс шебіде`;
const bo_i11 = (match, outcome) => `Тотал: ${match.awayTeam} екінші атыс шебіде`;
const bo_j11 = (match, outcome) => `Тотал: ${match.awayTeam} үшінші атыс шебіде`;
const bo_k11 = (match, outcome) => `Тотал: ${match.awayTeam} төртінші атыс шебіде`;
const bo_l11 = (match, outcome) => `Тотал: ${match.awayTeam} бесінші атыс шебіде`;
const bo_m11 = (match, outcome) => `Тотал: ${match.awayTeam} алтыншы атыс шебіде`;
const bo_n11 = (match, outcome) => `Тотал: ${match.awayTeam} жетінші атыс шебіде`;
const bo_o11 = (match, outcome) => `Тотал: ${match.awayTeam} сегізінші атыс шебіде`;
const bo_p11 = (match, outcome) => 'Фора: Бірінші атыс шебіде';
const bo_q11 = (match, outcome) => 'Фора: Екінші атыс шебіде';
const bo_r11 = (match, outcome) => 'Фора: Үшінші атыс шебіде';
const bo_s11 = (match, outcome) => 'Фора: Төртінші атыс шебіде';
const bo_t11 = (match, outcome) => 'Фора: Бесінші атыс шебіде';
const bo_u11 = (match, outcome) => 'Фора: Алтыншы атыс шебіде';
const bo_v11 = (match, outcome) => 'Фора: Жетінші атыс шебіде';
const bo_w11 = (match, outcome) => 'Фора: Сегізінші атыс шебіде';
const bo_x11 = (match, outcome) => 'Нәтиже: Бірінші атыс шебіде';
const bo_y11 = (match, outcome) => 'Нәтиже: Екінші атыс шебіде';
const bo_z11 = (match, outcome) => 'Нәтиже: Үшінші атыс шебіде';
const bo_a12 = (match, outcome) => 'Нәтиже: Төртінші атыс шебіде';
const bo_b12 = (match, outcome) => 'Нәтиже: Бесінші атыс шебіде';
const bo_c12 = (match, outcome) => 'Нәтиже: Алтыншы атыс шебіде';
const bo_d12 = (match, outcome) => 'Нәтиже: Жетінші атыс шебіде';
const bo_e12 = (match, outcome) => 'Нәтиже: Сегізінші атыс шебіде';
const bo_f12 = (match, outcome) => 'Дәл тоталы: Бірінші атыс шебіде';
const bo_g12 = (match, outcome) => 'Дәл тоталы: Екінші атыс шебіде';
const bo_h12 = (match, outcome) => 'Дәл тоталы: Үшінші атыс шебіде';
const bo_i12 = (match, outcome) => 'Дәл тоталы: Төртінші атыс шебіде';
const bo_j12 = (match, outcome) => 'Дәл тоталы: Бесінші атыс шебіде';
const bo_k12 = (match, outcome) => 'Дәл тоталы: Алтыншы атыс шебіде';
const bo_l12 = (match, outcome) => 'Дәл тоталы: Жетінші атыс шебіде';
const bo_m12 = (match, outcome) => 'Дәл тоталы: Сегізінші атыс шебіде';
const bo_n12 = (match, outcome) => 'Мерзімнен бұрын женіс болады ма?';
const bo_o12 = (match, outcome) => 'Жекпе-жекте жеңу тәсілі';
const bo_p12 = (match, outcome) => 'Жекпе-жекте жеңу';
const bo_q12 = (match, outcome) => 'Тотал';
const bo_r12 = (match, outcome) => `Кім ${outcome.condition} раундты жеңеді?`;
const bo_s12 = (match, outcome) => 'FirstBlood';
const bo_t12 = (match, outcome) => `FirstBlood ${outcome.condition} раундта`;
const bo_u12 = (match, outcome) => `${outcome.condition} картаны кім жеңеді?`;
const bo_v12 = (match, outcome) => `FirstBlood ${outcome.condition} картада`;
const bo_w12 = (match, outcome) => `Кім бірінші болып 1-інші картада ${outcome.condition} өлтіру жинайды`;
const bo_x12 = (match, outcome) => `Кім бірінші болып 2-нші картада ${outcome.condition} өлтіру жинайды`;
const bo_y12 = (match, outcome) => `Кім бірінші болып 3-інші картада ${outcome.condition} өлтіру жинайды`;
const bo_z12 = (match, outcome) => `Кім бірінші болып 4-інші картада ${outcome.condition} өлтіру жинайды`;
const bo_a13 = (match, outcome) => `Кім бірінші болып 5-інші картада ${outcome.condition} өлтіру жинайды`;
const bo_b13 = (match, outcome) => 'Матчта нәтиже';
const bo_c13 = (match, outcome) => '1-інші картада жеңіс';
const bo_d13 = (match, outcome) => '2-нші картада жеңіс';
const bo_e13 = (match, outcome) => '3-інші картада жеңіс';
const bo_f13 = (match, outcome) => '4-інші картада жеңіс';
const bo_g13 = (match, outcome) => '5-інші картада жеңіс';
const bo_h13 = (match, outcome) => 'First blood бірінші картада';
const bo_i13 = (match, outcome) => 'First blood екінші картада';
const bo_j13 = (match, outcome) => 'First blood үшінші картада';
const bo_k13 = (match, outcome) => 'First blood төртінші картада';
const bo_l13 = (match, outcome) => 'First blood бесінші картада';
const bo_m13 = (match, outcome) => 'Буллиттерді ескерумен жеңіс';
const bo_n13 = (match, outcome) => `${match.homeTeam} екі таймда да ұтады`;
const bo_o13 = (match, outcome) => `${match.awayTeam} екі таймда да ұтады`;
const bo_p13 = (match, outcome) => `${outcome.conditionTwo} және одан көп гол соғатын командалар (олардың тоталы)`;
const bo_q13 = (match, outcome) => 'Еі нәтижелі команда (оның тоталы)';
const bo_r13 = (match, outcome) => 'Ең нәтижелі тайм (тотал)';
const bo_s13 = (match, outcome) => `Екі тайм да салыстырғанда ${outcome.condition} аз`;
const bo_t13 = (match, outcome) => `Екі тайм да салыстырғанда ${outcome.condition} көп`;
const bo_u13 = (match, outcome) => 'Бірінші таймның жұп/тақ болуы';
const bo_v13 = (match, outcome) => 'Екінші таймның жұп/тақ болуы';
const bo_w13 = (match, outcome) => `Бірінші таймда ${match.homeTeam} неше гол салады?`;
const bo_x13 = (match, outcome) => `Екінші таймда ${match.homeTeam} неше гол салады?`;
const bo_y13 = (match, outcome) => `Бірінші таймда ${match.awayTeam} неше гол салады?`;
const bo_z13 = (match, outcome) => `Екінші таймда ${match.awayTeam} неше гол салады?`;
const bo_a14 = (match, outcome) => `Матчта ${match.homeTeam} неше гол салады?`;
const bo_b14 = (match, outcome) => `Матчта ${match.awayTeam} неше гол салады?`;
const bo_c14 = (match, outcome) => 'Ең нәтижесіз  команда (оның тоталы)';
const bo_d14 = (match, outcome) => `${match.homeTeam} тек бірінші таймда соғады ма?`;
const bo_e14 = (match, outcome) => `${match.awayTeam} тек бірінші таймда соғады ма?`;
const bo_f14 = (match, outcome) => `${match.homeTeam} тек екінші таймда соғады ма?`;
const bo_g14 = (match, outcome) => `${match.awayTeam} тек екінші таймда соғады ма?`;
const bo_h14 = (match, outcome) => 'Қанша команда бірінші таймда соғады';
const bo_i14 = (match, outcome) => 'Қанша команда екінші таймда соғады';
const bo_j14 = (match, outcome) => `Қанша команда ${outcome.condition} аса соғады`;
const bo_k14 = (match, outcome) => 'Бірінші гол қалай салынады?';
const bo_l14 = (match, outcome) => 'Келесі айналымға шығу';
const bo_m14 = (match, outcome) => 'Кім алаң ортасынан бастайды?';
const bo_n14 = (match, outcome) => 'Екі гол қатарынан бір командамен салынады';
const bo_o14 = (match, outcome) => `${match.homeTeam} ерікті жеңіске жетеді`;
const bo_p14 = (match, outcome) => `Кім ${numeralFemaleEnding(outcome.condition)} СК алады`;
const bo_q14 = (match, outcome) => `${match.awayTeam} ерікті жеңіске жетеді`;
const bo_r14 = (match, outcome) => 'Матчта бірінші болып не орын алады?';
const bo_s14 = (match, outcome) => 'Дубль';
const bo_t14 = (match, outcome) => 'Хет-трик';
const bo_u14 = (match, outcome) => `Кім ${numeralMaleEnding(outcome.condition)} бұрыштаманы береді?`;
const bo_v14 = (match, outcome) => `Тура ${outcome.conditionTwo} соққан командалар (олардың тоталы)`;
const bo_w14 = (match, outcome) => `Матчта тура ${outcome.condition} гол салады ма`;
const bo_x14 = (match, outcome) => 'Соңғы голды кім салады?';
const bo_y14 = (match, outcome) => 'Автогол';
const bo_z14 = (match, outcome) => 'Ауыстыруға шыққан ойыншы салады ма?';
const bo_a15 = (match, outcome) => 'Соңғы гол уақыты';
const bo_b15 = (match, outcome) => 'Кубок иегері';
const bo_c15 = (match, outcome) => 'Суперкубок иегері';
const bo_d15 = (match, outcome) => `Қай таймда ${numeralMaleEnding(outcome.condition)} гол гол салынады?`;
const bo_e15 = (match, outcome) => '1-ден 15 минут аралығында қосарлы нәтиже';
const bo_f15 = (match, outcome) => '16-дан 30 минут аралығында қосарлы нәтиже';
const bo_g15 = (match, outcome) => '31 минуттан үзіліске дейін қосарлы нәтиже';
const bo_h15 = (match, outcome) => '46-дан 60 минут аралығында қосарлы нәтиже';
const bo_i15 = (match, outcome) => '61-ден 75 минут аралығында қосарлы нәтиже';
const bo_j15 = (match, outcome) => '76 минуттан НУ соңына дейін қосарлы нәтиже';
const bo_k15 = (match, outcome) => `${match.homeTeam} ${numeralMaleEnding(outcome.condition)} пенальтиді соғады ма?`;
const bo_l15 = (match, outcome) => `${match.awayTeam} ${numeralMaleEnding(outcome.condition)} пенальтиді соғады ма?`;
const bo_m15 = (match, outcome) => `${match.homeTeam} өзінің ${numeralMaleEnding(outcome.condition)} голын соғады`;
const bo_n15 = (match, outcome) => `${match.awayTeam} өзінің ${numeralMaleEnding(outcome.condition)} голын соғады`;
const bo_o15 = (match, outcome) => 'Бірінші таймдағы бұрыштамалар тоталы';
const bo_p15 = (match, outcome) => 'Бірінші таймдағы СК тоталы';
const bo_q15 = (match, outcome) => 'Матчтағы бұрыштамалар бойынша фора';
const bo_r15 = (match, outcome) => 'Бірінші таймдағы бұрыштамалар бойынша фора';
const bo_s15 = (match, outcome) => 'СК бойынша фора';
const bo_t15 = (match, outcome) => 'Бірінші таймда СК бойынша фора';
const bo_u15 = (match, outcome) => 'Бұрыштамалар бойынша матч нәтижесі';
const bo_v15 = (match, outcome) => 'Бұрыштамалар бойынша бірінші тайм нәтижесі';
const bo_w15 = (match, outcome) => 'СК бойынша матч нәтижесі';
const bo_x15 = (match, outcome) => 'СК бойынша бірінші тайм нәтижесі';
const bo_y15 = (match, outcome) => `Кім бірінші болып ${outcome.condition} ${plural(outcome.condition, ['гол'])} салады`;
const bo_z15 = (match, outcome) => ` ${numeralMaleEnding(outcome.condition)} пенальти салынады ма`;
const bo_a16 = (match, outcome) => 'Ауттар';
const bo_b16 = (match, outcome) => 'Тайм-Матч';
const bo_c16 = (match, outcome) => 'Матч тоталы (Азия)';
const bo_d16 = (match, outcome) => 'Бұрыштамалар тоталы';
const bo_e16 = (match, outcome) => 'Матч қалай аяқталады?';
const bo_f16 = (match, outcome) => 'Пенальти (тотал)';
const bo_g16 = (match, outcome) => 'Қызыл карточкалар тоталы';
const bo_h16 = (match, outcome) => 'Бірінші гол уақыты';
const bo_i16 = (match, outcome) => 'Минут голдар жиынтығы';
const bo_j16 = (match, outcome) => 'Екінші таймның тоталы';
const bo_k16 = (match, outcome) => 'Екінші таймдағы фора';
const bo_l16 = (match, outcome) => 'Қақпаның жақтауына соғу';
const bo_m16 = (match, outcome) => 'Сары карточкалар тоталы';
const bo_n16 = (match, outcome) => 'Екінші тайм нәтижесі';
const bo_o16 = (match, outcome) => '1-ден 15 минут аралығында матчтағы фора';
const bo_p16 = (match, outcome) => '16-дан 30 минут аралығында матчтағы фора';
const bo_q16 = (match, outcome) => '31 минуттан үзіліске дейін матчтағы фора';
const bo_r16 = (match, outcome) => '46-дан 60 минут аралығында матчтағы фора';
const bo_s16 = (match, outcome) => '61-ден 75 минут аралығында матчтағы фора';
const bo_t16 = (match, outcome) => '76 минуттан НУ соңына дейін матчтағы фора';
const bo_u16 = (match, outcome) => `${match.homeTeam} голдар`;
const bo_v16 = (match, outcome) => `${match.awayTeam} голдар`;
const bo_w16 = (match, outcome) => 'Ауыстырулар тоталы';
const bo_x16 = (match, outcome) => '1-ден 15 минут аралығындағы матч тоталы';
const bo_y16 = (match, outcome) => '16-дан 30 минут аралығындағы матч тоталы';
const bo_z16 = (match, outcome) => '31-ден минут үзіліске дейін аралығындағы матч тоталы';
const bo_a17 = (match, outcome) => '46-дан 60 минут аралығындағы матч тоталы';
const bo_b17 = (match, outcome) => '61-ден 75 минут аралығындағы матч тоталы';
const bo_c17 = (match, outcome) => '76 минуттан НУ соңына дейін матч тоталы';
const bo_d17 = (match, outcome) => `Тотал: ${match.homeTeam} матчтағы 1-ден 15 минут аралығында`;
const bo_e17 = (match, outcome) => `Тотал: ${match.homeTeam} матчтағы 16-дан 30 минут аралығында`;
const bo_f17 = (match, outcome) => `Тотал: ${match.homeTeam} матчтағы 31 минуттан үзіліске дейін`;
const bo_g17 = (match, outcome) => `Тотал: ${match.homeTeam} матчтағы 46-дан 60 минут аралығында`;
const bo_h17 = (match, outcome) => `Тотал: ${match.homeTeam} матчтағы 61-ден 75 минут аралығында`;
const bo_i17 = (match, outcome) => `Тотал: ${match.homeTeam} матчтағы 76 минуттан НУ соңына дейін`;
const bo_j17 = (match, outcome) => `Тотал: ${match.awayTeam} матчтағы 1-ден 15 минут аралығында`;
const bo_k17 = (match, outcome) => `Тотал: ${match.awayTeam} матчтағы 16-дан 30 минут аралығында`;
const bo_l17 = (match, outcome) => `Тотал: ${match.awayTeam} матчтағы 31 минуттан үзіліске дейін`;
const bo_m17 = (match, outcome) => `Тотал: ${match.awayTeam} матчтағы 46-дан 60 минут аралығында`;
const bo_n17 = (match, outcome) => `Тотал: ${match.awayTeam} матчтағы 61-ден 75 минут аралығында`;
const bo_o17 = (match, outcome) => `Тотал: ${match.awayTeam} матчтағы 76 минуттан НУ соңына дейін`;
const bo_p17 = (match, outcome) => 'Бірінші таймның дәл тоталы';
const bo_q17 = (match, outcome) => 'Екінші таймның дәл тоталы';
const bo_r17 = (match, outcome) => `${match.homeTeam} ұтады және өткізбейді`;
const bo_s17 = (match, outcome) => `${match.awayTeam} ұтады және өткізбейді`;
const bo_t17 = (match, outcome) => `${match.homeTeam} тура ${outcome.condition} гол соғады`;
const bo_u17 = (match, outcome) => `${match.awayTeam} тура ${outcome.condition} гол соғады`;
const bo_v17 = (match, outcome) => 'Бірінші таймның дәл есебі';
const bo_w17 = (match, outcome) => 'Екінші таймның дәл есебі';
const bo_x17 = (match, outcome) => 'Салынбаған пенальти';
const bo_y17 = (match, outcome) => `Екі команда ${outcome.condition} салыстырғанда аз салады`;
const bo_z17 = (match, outcome) => `Екі команда ${outcome.condition} салыстырғанда көп салады`;
const bo_a18 = (match, outcome) => 'Таймдарды (голдарды) салыстыру';
const bo_b18 = (match, outcome) => '1-ден 15 минут аралығында матчтағы жеңіс';
const bo_c18 = (match, outcome) => '16-дан 30 минут аралығында матчтағы жеңіс';
const bo_d18 = (match, outcome) => '31 минуттан үзіліске дейін матчтағы жеңіс';
const bo_e18 = (match, outcome) => '46-дан 60 минут аралығында матчтағы жеңіс';
const bo_f18 = (match, outcome) => '61-ден 75 минут аралығында матчтағы жеңіс';
const bo_g18 = (match, outcome) => '76 минуттан НУ соңына дейін матчтағы жеңіс';
const bo_h18 = (match, outcome) => `${match.homeTeam} таймдардың бірінде жеңеді`;
const bo_i18 = (match, outcome) => `${match.awayTeam} таймдардың бірінде жеңеді`;
const bo_j18 = (match, outcome) => `${outcome.conditionTwo} - ${outcome.conditionThree} голға дейін соққан командалар (олардың тоталы)`;
const bo_k18 = (match, outcome) => `Тотал: ${match.homeTeam} екінші таймда`;
const bo_l18 = (match, outcome) => `Тотал: ${match.awayTeam} екінші таймда`;
const bo_m18 = (match, outcome) => ` ${outcome.playerName} (${match.homeTeam}) гол салады ма?`;
const bo_n18 = (match, outcome) => `${outcome.playerName} (${match.awayTeam}) гол салады ма?`;
const bo_o18 = (match, outcome) => 'Матч нәтижесі';
const bo_p18 = (match, outcome) => 'Матч форасы';
const bo_q18 = (match, outcome) => 'Қожайындар тоталы';
const bo_r18 = (match, outcome) => 'Қонақтар тоталы';
const bo_s18 = (match, outcome) => 'Ең нәтижелі матч тоталы';
const bo_t18 = (match, outcome) => 'Ең нәтижесіз матч тоталы';
const bo_u18 = (match, outcome) => 'Голсыз матч тоталы';
const bo_v18 = (match, outcome) => 'Қожайындар жеңістерінің тоталы';
const bo_w18 = (match, outcome) => 'Қонақтар жеңістерінің тоталы';
const bo_x18 = (match, outcome) => 'Тең ойын тоталы';
const bo_y18 = (match, outcome) => 'Қос нәтиже';
const bo_z18 = (match, outcome) => 'Команданың екеуі де салады: 1 тайм/2 тайм';
const bo_a19 = (match, outcome) => `Тотал ${outcome.condition} және екуі де салады`;
const bo_b19 = (match, outcome) => `${match.homeTeam} салады және жеңбейді`;
const bo_c19 = (match, outcome) => `${match.awayTeam} зсалады және жеңбейді`;
const bo_d19 = (match, outcome) => 'Матчта жеңу тәсілі';
const bo_e19 = (match, outcome) => '1-інші таймда өтелген уақыт';
const bo_f19 = (match, outcome) => '2-інші таймда өтелген уақыт';
const bo_g19 = (match, outcome) => 'Матчта штанга/жолақ боалды ма';
const bo_h19 = (match, outcome) => 'Бірінші ауысу уақыты';
const bo_i19 = (match, outcome) => `Қызыл картаны ${match.homeTeam} ойыншысы алады`;
const bo_j19 = (match, outcome) => `Қызыл картаны${match.awayTeam} ойыншысы алады`;
const bo_k19 = (match, outcome) => 'Пенальти мен жою болады ма';
const bo_l19 = (match, outcome) => 'Гол өтелген уақытта';
const bo_m19 = (match, outcome) => 'Алдау үшін Сары Карта';
const bo_n19 = (match, outcome) => 'Шешілген жейде үшін Сары Карта';
const bo_o19 = (match, outcome) => 'Әр жалаушадан бұрыштамалар';
const bo_p19 = (match, outcome) => '3-ші орын кім алады?';
const bo_q19 = (match, outcome) => `Тотал: ${match.awayTeam}  (Қосымша уақыт)`;
const bo_r19 = (match, outcome) => `Тотал: ${match.homeTeam}  (Қосымша уақыт)`;
const bo_s19 = (match, outcome) => 'Қос нәтиже (Қосымша уақыт)';
const bo_t19 = (match, outcome) => 'Дәл есеп (Қосымша уақыт)';
const bo_u19 = (match, outcome) => 'Фора (Қосымша уақыт)';
const bo_v19 = (match, outcome) => 'Тотал  (Қосымша уақыт)';
const bo_w19 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam} (Қосымша уақыт)`;
const bo_x19 = (match, outcome) => `Кім ${numeralMaleEnding(outcome.condition)} гол салады?`;
const bo_y19 = (match, outcome) => 'Бірінші қосымша уақытта фора';
const bo_z19 = (match, outcome) => 'Бірінші қосымша уақыттың тоталы';
const bo_a20 = (match, outcome) => 'Бірінші қосымша уақытта нәтиже';
const bo_b20 = (match, outcome) => 'Екінші қосымша уақытта фора';
const bo_c20 = (match, outcome) => 'Екінші қосымша уақыттың тоталы';
const bo_d20 = (match, outcome) => 'Екінші қосымша уақытта нәтиже';
const bo_e20 = (match, outcome) => 'Пенальти сериясында дәл есеп';
const bo_f20 = (match, outcome) => `салынған пенальти тоталы: ${match.awayTeam} (пенальти сериясы)`;
const bo_g20 = (match, outcome) => `Салынған пенальти тоталы: ${match.homeTeam} (серия пенальти)`;
const bo_h20 = (match, outcome) => 'салынған пенальти тоталы:  (пенальти сериясы)';
const bo_i20 = (match, outcome) => 'Салынбаған пенальти тоталы:  (пенальти сериясы)';
const bo_j20 = (match, outcome) => `Еуропалылық фора ${europeanHandicapCondition(outcome.condition)}`;
const bo_k20 = (match, outcome) => `Еуропалық фора ${europeanHandicapCondition(outcome.condition)} бірінші таймда`;
const bo_l20 = (match, outcome) => `Еуропалық фора ${europeanHandicapCondition(outcome.condition)} 2-ші таймда`;
const bo_m20 = (match, outcome) => `Бірінші таймда кім ${numeralMaleEnding(outcome.condition)} гол салады?`;
const bo_n20 = (match, outcome) => `Матчтың қалған уақыты (ағымдағы есеп ${outcome.condition}:${outcome.conditionTwo})`;
const bo_o20 = (match, outcome) => `Бірінші таймның қалған уақыты (ағымдағы есеп ${outcome.condition}:${outcome.conditionTwo})`;
const bo_p20 = (match, outcome) => `Бірінші таймның бұрыштамалар тоталы: ${match.homeTeam}`;
const bo_q20 = (match, outcome) => `Бірінші таймның бұрыштамалар тоталы: ${match.awayTeam}`;
const bo_r20 = (match, outcome) => `Бұрыштамалар тоталы: ${match.homeTeam}`;
const bo_s20 = (match, outcome) => `Бұрыштамалар тоталы: ${match.awayTeam}`;
const bo_t20 = (match, outcome) => 'Бірінші гол уақыты (мин)';
const bo_u20 = (match, outcome) => 'Бірінші таймның қос нәтижесі';
const bo_v20 = (match, outcome) => 'Екінші таймның қос нәтижесі';
const bo_w20 = (match, outcome) => 'Екеуі де алады ма?';
const bo_x20 = (match, outcome) => `${match.homeTeam} бірінші таймда айырмашылықпен жеңеді`;
const bo_y20 = (match, outcome) => `${match.homeTeam} екінші таймда айырмашылықпен жеңеді`;
const bo_z20 = (match, outcome) => `${match.awayTeam} бірінші таймда айырмашылықпен жеңеді`;
const bo_a21 = (match, outcome) => `${match.awayTeam} екінші таймда айырмашылықпен жеңеді`;
const bo_b21 = (match, outcome) => 'Хет-триктер (олардың тоталы)';
const bo_c21 = (match, outcome) => 'Бірінші кезеңнің тоталы';
const bo_d21 = (match, outcome) => 'Екінші кезеңнің тоталы';
const bo_e21 = (match, outcome) => 'Үшінші кезеңнің тоталы';
const bo_f21 = (match, outcome) => 'Бірінші кезеңнің дәл есебі';
const bo_g21 = (match, outcome) => 'Екінші кезеңнің дәл есебі';
const bo_h21 = (match, outcome) => 'Үшінші кезеңнің дәл есебі';
const bo_i21 = (match, outcome) => 'Бірінші кезеңнің жұп/тақ болуы';
const bo_j21 = (match, outcome) => 'Екінші кезеңнің жұп/тақ болуы';
const bo_k21 = (match, outcome) => 'Үшінші кезеңнің жұп/тақ болуы';
const bo_l21 = (match, outcome) => 'Ең нәтижелі кезең (тотал)';
const bo_m21 = (match, outcome) => 'Ең нәтижесіз кезең (тотал)';
const bo_n21 = (match, outcome) => 'Бірінші кезеңнің дәл тоталы';
const bo_o21 = (match, outcome) => 'Екінші кезеңнің дәл тоталы';
const bo_p21 = (match, outcome) => 'Үшінші кезеңнің дәл тоталы';
const bo_q21 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші кезеңде`;
const bo_r21 = (match, outcome) => `Тотал: ${match.homeTeam} екінші кезеңде`;
const bo_s21 = (match, outcome) => `Тотал: ${match.homeTeam} үшінші кезеңде`;
const bo_t21 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші кезеңде`;
const bo_u21 = (match, outcome) => `Тотал: ${match.awayTeam} екінші кезеңде`;
const bo_v21 = (match, outcome) => `Тотал: ${match.awayTeam} үшінші кезеңде`;
const bo_w21 = (match, outcome) => 'Екі команда да салады';
const bo_x21 = (match, outcome) => 'ОТ ескерумен жеңіс';
const bo_y21 = (match, outcome) => 'Период-Матч';
const bo_z21 = (match, outcome) => `${match.homeTeam} әр кезеңді салады`;
const bo_a22 = (match, outcome) => `${match.awayTeam} әр кезеңде салады`;
const bo_b22 = (match, outcome) => 'Барлық кезеңдерде салады';
const bo_c22 = (match, outcome) => 'бірінші және екінші кезеңді салыстыру';
const bo_d22 = (match, outcome) => 'Бірінші және үшінші кезеңді салыстыру';
const bo_e22 = (match, outcome) => 'Екінші және үшінші кезеңді салыстыру';
const bo_f22 = (match, outcome) => `${match.homeTeam} кезеңдердің біреуінде жеңеді`;
const bo_g22 = (match, outcome) => `${match.awayTeam} кезеңдердің біреуінде жеңеді`;
const bo_h22 = (match, outcome) => 'Кемінде бір кезеңде тең ойын';
const bo_i22 = (match, outcome) => 'Матчта 1-10 минутқа дейін жеңу';
const bo_j22 = (match, outcome) => 'Матчта 11-20 минутқа дейін жеңу';
const bo_k22 = (match, outcome) => 'Матчта 21-30 минутқа дейін жеңу';
const bo_l22 = (match, outcome) => 'Матчта 31-40 минутқа дейін жеңу';
const bo_m22 = (match, outcome) => 'Матчта 41-50 минутқа дейін жеңу';
const bo_n22 = (match, outcome) => 'Матчта 51-60 минутқа дейін жеңу';
const bo_o22 = (match, outcome) => 'Матчта 1-10 минутқа дейін фора';
const bo_p22 = (match, outcome) => 'Матчта 11-20 минутқа дейін фора';
const bo_q22 = (match, outcome) => 'Матчта 21-30 минутқа дейін фора';
const bo_r22 = (match, outcome) => 'Матчта 31-40 минутқа дейін фора';
const bo_s22 = (match, outcome) => 'Матчта 41-50 минутқа дейін фора';
const bo_t22 = (match, outcome) => 'Матчта 51-60 минутқа дейін фора';
const bo_u22 = (match, outcome) => 'Матчта 1-10 минутқа дейін тотал';
const bo_v22 = (match, outcome) => 'Матчта 11-20 минутқа дейін тотал';
const bo_w22 = (match, outcome) => 'Матчта 21-30 минутқа дейін тотал';
const bo_x22 = (match, outcome) => 'Матчта 31-40 минутқа дейін тотал';
const bo_y22 = (match, outcome) => 'Матчта 41-50 минутқа дейін тотал';
const bo_z22 = (match, outcome) => 'Матчта 51-60 минутқа дейін тотал';
const bo_a23 = (match, outcome) => 'Бірінші кезеңді неше команда салады?';
const bo_b23 = (match, outcome) => 'Екінші кезеңді неше команда салады?';
const bo_c23 = (match, outcome) => 'Үшінші кезеңді неше команда салады?';
const bo_d23 = (match, outcome) => `${match.homeTeam} еріктік жеңіске жетеді`;
const bo_e23 = (match, outcome) => `${match.awayTeam} еріктік жеңіске жетеді`;
const bo_f23 = (match, outcome) => 'Чет/Нечет наибольшего выпавшего шара';
const bo_g23 = (match, outcome) => 'Чет/Нечет наименьшего выпавшего шара';
const bo_h23 = (match, outcome) => 'Чет/Нечет первого выпавшего шара';
const bo_i23 = (match, outcome) => 'Чет/Нечет последнего выпавшего шара';
const bo_j23 = (match, outcome) => 'Первый меньше/больше последнего';
const bo_k23 = (match, outcome) => 'Все шары четные';
const bo_l23 = (match, outcome) => 'Все шары нечетные';
const bo_m23 = (match, outcome) => 'Хотя бы два шара с соседними номерами';
const bo_n23 = (match, outcome) => 'Наименьший выпавший шар';
const bo_o23 = (match, outcome) => 'Наибольший выпавший шар';
const bo_p23 = (match, outcome) => 'Сумма выпавших шаров';
const bo_q23 = (match, outcome) => `Хотя бы один из выпавших шаров кратен ${outcome.condition}`;
const bo_r23 = (match, outcome) => 'Разница между наименьшим и наибольшим шарами';
const bo_s23 = (match, outcome) => 'Сумма нечетных шаров';
const bo_t23 = (match, outcome) => 'Сумма четных шаров';
const bo_u23 = (match, outcome) => 'Первый выпавший шар';
const bo_v23 = (match, outcome) => 'Второй выпавший шар';
const bo_w23 = (match, outcome) => 'Третий выпавший шар';
const bo_x23 = (match, outcome) => 'Четвертый выпавший шар';
const bo_y23 = (match, outcome) => 'Пятый выпавший шар';
const bo_z23 = (match, outcome) => 'Шестой выпавший шар';
const bo_a24 = (match, outcome) => 'Седьмой выпавший шар';
const bo_b24 = (match, outcome) => `Хотя бы один шар попадет в интервал от ${outcome.condition} до ${outcome.conditionTwo}`;
const bo_c24 = (match, outcome) => 'Сумма наименьшего и наибольшего шаров';
const bo_d24 = (match, outcome) => 'Ұрыста жеңіске жету';
const bo_e24 = (match, outcome) => 'Мерзімнен ерте жеңіс болады ма?';
const bo_f24 = (match, outcome) => `${match.homeTeam} ауырту/тұншықтыру/ерікті берілу арқылы жеңеді`;
const bo_g24 = (match, outcome) => `${match.awayTeam} ауырту/тұншықтыру/ерікті берілу арқылы жеңеді`;
const bo_h24 = (match, outcome) => `${match.homeTeam}  нокаутпен/техникалық нокаутпен/Дисквалификациямен жеңеді`;
const bo_i24 = (match, outcome) => `${match.awayTeam}  нокаутпен/техникалық нокаутпен/Дисквалификациямен жеңеді`;
const bo_j24 = (match, outcome) => 'Медальдар тоталы';
const bo_k24 = (match, outcome) => 'Жиырма тоғызыншы партияның нәтижесі';
const bo_l24 = (match, outcome) => 'Отызыншы партияның нәтижесі';
const bo_m24 = (match, outcome) => 'Отыз бірінші партияның нәтижесі';
const bo_n24 = (match, outcome) => 'Отыз екінші партияның нәтижесі';
const bo_o24 = (match, outcome) => 'Отыз үшінші партияның нәтижесі';
const bo_p24 = (match, outcome) => 'Отыз төртінші партияның нәтижесі';
const bo_q24 = (match, outcome) => 'Отыз бесінші партияның нәтижесі';
const bo_r24 = (match, outcome) => 'Отыз алтыншы партияның нәтижесі';
const bo_s24 = (match, outcome) => 'Отыз жетінші партияның нәтижесі';
const bo_t24 = (match, outcome) => 'Он сегізінші партияның жұп/тақ болуы';
const bo_u24 = (match, outcome) => 'Он тоғызыншы партияның жұп/тақ болуы';
const bo_v24 = (match, outcome) => 'Жиырмасыншы партияның жұп/тақ болуы';
const bo_w24 = (match, outcome) => 'Жиырма бірінші партияның жұп/тақ болуы';
const bo_x24 = (match, outcome) => 'Жиырма екінші партияның жұп/тақ болуы';
const bo_y24 = (match, outcome) => 'Жиырма үшінші партияның жұп/тақ болуы';
const bo_z24 = (match, outcome) => 'Жиырма төртінші партияның жұп/тақ болуы';
const bo_a25 = (match, outcome) => 'Жиырма бесінші партияның жұп/тақ болуы';
const bo_b25 = (match, outcome) => 'Жиырма алтыншы партияның жұп/тақ болуы';
const bo_c25 = (match, outcome) => 'Жиырма жетінші партияның жұп/тақ болуы';
const bo_d25 = (match, outcome) => 'Жиырма сегізінші партияның жұп/тақ болуы';
const bo_e25 = (match, outcome) => 'Жиырма тоғызыншы партияның жұп/тақ болуы';
const bo_f25 = (match, outcome) => 'Отызыншы партияның жұп/тақ болуы';
const bo_g25 = (match, outcome) => 'Отыз бірінші партияның жұп/тақ болуы';
const bo_h25 = (match, outcome) => 'Отыз екінші партияның жұп/тақ болуы';
const bo_i25 = (match, outcome) => 'Отыз үшінші партияның жұп/тақ болуы';
const bo_j25 = (match, outcome) => 'Отыз төртінші партияның жұп/тақ болуы';
const bo_k25 = (match, outcome) => 'Отыз бесінші партияның жұп/тақ болуы';
const bo_l25 = (match, outcome) => 'Отыз алтыншы партияның жұп/тақ болуы';
const bo_m25 = (match, outcome) => 'Отыз жетінші партияның жұп/тақ болуы';
const bo_n25 = (match, outcome) => 'Бірінші партияда қандай түсті шар бірінші болып салынады?';
const bo_o25 = (match, outcome) => 'Екінші партияда қандай түсті шар бірінші болып салынады?';
const bo_p25 = (match, outcome) => 'Үшінші партияда қандай түсті шар бірінші болып салынады?';
const bo_q25 = (match, outcome) => 'Төртінші партияда қандай түсті шар бірінші болып салынады?';
const bo_r25 = (match, outcome) => 'Бесінші партияда қандай түсті шар бірінші болып салынады?';
const bo_s25 = (match, outcome) => 'Алтыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_t25 = (match, outcome) => 'Жетінші партияда қандай түсті шар бірінші болып салынады?';
const bo_u25 = (match, outcome) => 'Сегізінші партияда қандай түсті шар бірінші болып салынады?';
const bo_v25 = (match, outcome) => 'Тоғызыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_w25 = (match, outcome) => 'Оныншы партияда қандай түсті шар бірінші болып салынады?';
const bo_x25 = (match, outcome) => 'Он бірінші партияда қандай түсті шар бірінші болып салынады?';
const bo_y25 = (match, outcome) => 'Он екінші партияда қандай түсті шар бірінші болып салынады?';
const bo_z25 = (match, outcome) => 'Он үшінші партияда қандай түсті шар бірінші болып салынады?';
const bo_a26 = (match, outcome) => 'Он төртінші партияда қандай түсті шар бірінші болып салынады?';
const bo_b26 = (match, outcome) => 'Он бесінші партияда қандай түсті шар бірінші болып салынады?';
const bo_c26 = (match, outcome) => 'Он алтыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_d26 = (match, outcome) => 'Он жетінші партияда қандай түсті шар бірінші болып салынады?';
const bo_e26 = (match, outcome) => 'Он сегізінші партияда қандай түсті шар бірінші болып салынады?';
const bo_f26 = (match, outcome) => 'Он тоғызыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_g26 = (match, outcome) => 'Жиырмасыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_h26 = (match, outcome) => 'Жиырма бірінші партияда қандай түсті шар бірінші болып салынады?';
const bo_i26 = (match, outcome) => 'Жиырма екінші партияда қандай түсті шар бірінші болып салынады?';
const bo_j26 = (match, outcome) => 'Жиырма үшінші партияда қандай түсті шар бірінші болып салынады?';
const bo_k26 = (match, outcome) => 'Жиырма төртінші партияда қандай түсті шар бірінші болып салынады?';
const bo_l26 = (match, outcome) => 'Жиырма бесінші партияда қандай түсті шар бірінші болып салынады?';
const bo_m26 = (match, outcome) => 'Жиырма алтыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_n26 = (match, outcome) => 'Жиырма жетінші партияда қандай түсті шар бірінші болып салынады?';
const bo_o26 = (match, outcome) => 'Жиырма сегізінші партияда қандай түсті шар бірінші болып салынады?';
const bo_p26 = (match, outcome) => 'Жиырма тоғызыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_q26 = (match, outcome) => 'Отызыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_r26 = (match, outcome) => 'Отыз бірінші партияда қандай түсті шар бірінші болып салынады?';
const bo_s26 = (match, outcome) => 'Отыз екінші партияда қандай түсті шар бірінші болып салынады?';
const bo_t26 = (match, outcome) => 'Отыз үшінші партияда қандай түсті шар бірінші болып салынады?';
const bo_u26 = (match, outcome) => 'Отыз төртінші партияда қандай түсті шар бірінші болып салынады?';
const bo_v26 = (match, outcome) => 'Отыз бесінші партияда қандай түсті шар бірінші болып салынады?';
const bo_w26 = (match, outcome) => 'Отыз алтыншы партияда қандай түсті шар бірінші болып салынады?';
const bo_x26 = (match, outcome) => 'Отыз жетінші партияда қандай түсті шар бірінші болып салынады?';
const bo_y26 = (match, outcome) => 'Бірінші партияның нәтижесі';
const bo_z26 = (match, outcome) => 'Екінші партияның нәтижесі';
const bo_a27 = (match, outcome) => 'Үшінші партияның нәтижесі';
const bo_b27 = (match, outcome) => 'Төртінші партияның нәтижесі';
const bo_c27 = (match, outcome) => 'Бесінші партияның нәтижесі';
const bo_d27 = (match, outcome) => 'Алтыншы партияның нәтижесі';
const bo_e27 = (match, outcome) => 'Жетінші партияның нәтижесі';
const bo_f27 = (match, outcome) => 'Сегізінші партияның нәтижесі';
const bo_g27 = (match, outcome) => 'Тоғызыншы партияның нәтижесі';
const bo_h27 = (match, outcome) => 'Оныншы партияның нәтижесі';
const bo_i27 = (match, outcome) => 'Он бірінші партияның нәтижесі';
const bo_j27 = (match, outcome) => 'Он екінші партияның нәтижесі';
const bo_k27 = (match, outcome) => 'Он үшінші партияның нәтижесі';
const bo_l27 = (match, outcome) => 'Он төртінші партияның нәтижесі';
const bo_m27 = (match, outcome) => 'Он бесінші партияның нәтижесі';
const bo_n27 = (match, outcome) => 'Он алтыншы партияның нәтижесі';
const bo_o27 = (match, outcome) => 'Он жетінші партияның нәтижесі';
const bo_p27 = (match, outcome) => 'Он сегізінші партияның нәтижесі';
const bo_q27 = (match, outcome) => 'Он тоғызыншы партияның нәтижесі';
const bo_r27 = (match, outcome) => 'Жиырмасыншы партияның нәтижесі';
const bo_s27 = (match, outcome) => 'Жиырма бірінші партияның нәтижесі';
const bo_t27 = (match, outcome) => 'Жиырма екінші партияның нәтижесі';
const bo_u27 = (match, outcome) => 'Жиырма үшінші партияның нәтижесі';
const bo_v27 = (match, outcome) => 'Жиырма төртінші партияның нәтижесі';
const bo_w27 = (match, outcome) => 'Жиырма бесінші партияның нәтижесі';
const bo_x27 = (match, outcome) => 'Жиырма алтыншы партияның нәтижесі';
const bo_y27 = (match, outcome) => 'Жиырма жетінші партияның нәтижесі';
const bo_z27 = (match, outcome) => 'Жиырма сегізінші партияның нәтижесі';
const bo_a28 = (match, outcome) => 'Жетінші партияда кім бірінші болып шар соғады?';
const bo_b28 = (match, outcome) => 'Сегізінші партияда кім бірінші болып шар соғады?';
const bo_c28 = (match, outcome) => 'Тоғызыншы партияда кім бірінші болып шар соғады?';
const bo_d28 = (match, outcome) => 'Оныншы партияда кім бірінші болып шар соғады?';
const bo_e28 = (match, outcome) => 'Он бірінші партияда кім бірінші болып шар соғады?';
const bo_f28 = (match, outcome) => 'Он екінші партияда кім бірінші болып шар соғады?';
const bo_g28 = (match, outcome) => 'Он үшінші партияда кім бірінші болып шар соғады?';
const bo_h28 = (match, outcome) => 'Он төртінші партияда кім бірінші болып шар соғады?';
const bo_i28 = (match, outcome) => 'Он бесінші партияда кім бірінші болып шар соғады?';
const bo_j28 = (match, outcome) => 'Он алтыншы партияда кім бірінші болып шар соғады?';
const bo_k28 = (match, outcome) => 'Он жетінші партияда кім бірінші болып шар соғады?';
const bo_l28 = (match, outcome) => 'Он сегізінші партияда кім бірінші болып шар соғады?';
const bo_m28 = (match, outcome) => 'Он тоғызыншы партияда кім бірінші болып шар соғады?';
const bo_n28 = (match, outcome) => 'Жиырмасыншы партияда кім бірінші болып шар соғады?';
const bo_o28 = (match, outcome) => 'Жиырма бірінші партияда кім бірінші болып шар соғады?';
const bo_p28 = (match, outcome) => 'Жиырма екінші партияда кім бірінші болып шар соғады?';
const bo_q28 = (match, outcome) => 'Жиырма үшінші партияда кім бірінші болып шар соғады?';
const bo_r28 = (match, outcome) => 'Жиырма төртінші партияда кім бірінші болып шар соғады?';
const bo_s28 = (match, outcome) => 'Жиырма бесінші партияда кім бірінші болып шар соғады?';
const bo_t28 = (match, outcome) => 'Жиырма алтыншы партияда кім бірінші болып шар соғады?';
const bo_u28 = (match, outcome) => 'Жиырма жетінші партияда кім бірінші болып шар соғады?';
const bo_v28 = (match, outcome) => 'Жиырма сегізінші партияда кім бірінші болып шар соғады?';
const bo_w28 = (match, outcome) => 'Жиырма тоғызыншы партияда кім бірінші болып шар соғады?';
const bo_x28 = (match, outcome) => 'Отызыншы партияда кім бірінші болып шар соғады?';
const bo_y28 = (match, outcome) => 'Отыз бірінші партияда кім бірінші болып шар соғады?';
const bo_z28 = (match, outcome) => 'Отыз екінші партияда кім бірінші болып шар соғады?';
const bo_a29 = (match, outcome) => 'Отыз үшінші партияда кім бірінші болып шар соғады?';
const bo_b29 = (match, outcome) => 'Отыз төртінші партияда кім бірінші болып шар соғады?';
const bo_c29 = (match, outcome) => 'Отыз бесінші партияда кім бірінші болып шар соғады?';
const bo_d29 = (match, outcome) => 'Отыз алтыншы партияда кім бірінші болып шар соғады?';
const bo_e29 = (match, outcome) => 'Отыз жетінші партияда кім бірінші болып шар соғады?';
const bo_f29 = (match, outcome) => `Бірінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_g29 = (match, outcome) => `Екінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_h29 = (match, outcome) => `Үшінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_i29 = (match, outcome) => `Төртінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_j29 = (match, outcome) => `Бесінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_k29 = (match, outcome) => `Алтыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_l29 = (match, outcome) => `Жетінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_m29 = (match, outcome) => `Сегізінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_n29 = (match, outcome) => `Тоғызыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_o29 = (match, outcome) => `Оныншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_p29 = (match, outcome) => `Он бірінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_q29 = (match, outcome) => `Он екінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_r29 = (match, outcome) => `Он үшінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_s29 = (match, outcome) => `Он төртінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_t29 = (match, outcome) => `Он бесінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_u29 = (match, outcome) => `Он алтыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_v29 = (match, outcome) => `Он жетінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_w29 = (match, outcome) => `Он сегізінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_x29 = (match, outcome) => `Он тоғызыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_y29 = (match, outcome) => `Жиырмасыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_z29 = (match, outcome) => `Жиырма бірінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_a30 = (match, outcome) => `Жиырма екінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_b30 = (match, outcome) => `Жиырма үшінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_c30 = (match, outcome) => `Жиырма төртінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_d30 = (match, outcome) => `Жиырма бесінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_e30 = (match, outcome) => `Жиырма алтыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_f30 = (match, outcome) => `Жиырма жетінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_g30 = (match, outcome) => `Жиырма сегізінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_h30 = (match, outcome) => `Жиырма тоғызыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_i30 = (match, outcome) => `Отызыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_j30 = (match, outcome) => `Отыз бірінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_k30 = (match, outcome) => `Отыз екінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_l30 = (match, outcome) => `Отыз үшінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_m30 = (match, outcome) => `Отыз төртінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_n30 = (match, outcome) => `Отыз бесінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_o30 = (match, outcome) => `Отыз алтыншы партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_p30 = (match, outcome) => `Отыз жетінші партияда бірінші болып кім ${outcome.condition} ұпай жинайды?`;
const bo_q30 = (match, outcome) => 'Бірінші партияның жұп/тақ болуы';
const bo_r30 = (match, outcome) => 'Екінші партияның жұп/тақ болуы';
const bo_s30 = (match, outcome) => 'Үшінші партияның жұп/тақ болуы';
const bo_t30 = (match, outcome) => 'Төртінші партияның жұп/тақ болуы';
const bo_u30 = (match, outcome) => 'Бесінші партияның жұп/тақ болуы';
const bo_v30 = (match, outcome) => 'Алтыншы партияның жұп/тақ болуы';
const bo_w30 = (match, outcome) => 'Жетінші партияның жұп/тақ болуы';
const bo_x30 = (match, outcome) => 'Сегізінші партияның жұп/тақ болуы';
const bo_y30 = (match, outcome) => 'Тоғызыншы партияның жұп/тақ болуы';
const bo_z30 = (match, outcome) => 'Оныншы партияның жұп/тақ болуы';
const bo_a31 = (match, outcome) => 'Он бірінші партияның жұп/тақ болуы';
const bo_b31 = (match, outcome) => 'Он екінші партияның жұп/тақ болуы';
const bo_c31 = (match, outcome) => 'Он үшінші партияның жұп/тақ болуы';
const bo_d31 = (match, outcome) => 'Он төртінші партияның жұп/тақ болуы';
const bo_e31 = (match, outcome) => 'Он бесінші партияның жұп/тақ болуы';
const bo_f31 = (match, outcome) => 'Он алтыншы партияның жұп/тақ болуы';
const bo_g31 = (match, outcome) => 'Он жетінші партияның жұп/тақ болуы';
const bo_h31 = (match, outcome) => 'Матчтағы сенчури брейктер тоталы';
const bo_i31 = (match, outcome) => 'Бірінші партиядағы фора';
const bo_j31 = (match, outcome) => 'Екінші партиядағы фора';
const bo_k31 = (match, outcome) => 'Үшінші партиядағы фора';
const bo_l31 = (match, outcome) => 'Төртінші партиядағы фора';
const bo_m31 = (match, outcome) => 'Бесінші партиядағы фора';
const bo_n31 = (match, outcome) => 'Алтыншы партиядағы фора';
const bo_o31 = (match, outcome) => 'Жетінші партиядағы фора';
const bo_p31 = (match, outcome) => 'Сегізінші партиядағы фора';
const bo_q31 = (match, outcome) => 'Тоғызыншы партиядағы фора';
const bo_r31 = (match, outcome) => 'Оныншы партиядағы фора';
const bo_s31 = (match, outcome) => 'Он бірінші партиядағы фора';
const bo_t31 = (match, outcome) => 'Он екінші партиядағы фора';
const bo_u31 = (match, outcome) => 'Он үшінші партиядағы фора';
const bo_v31 = (match, outcome) => 'Он төртінші партиядағы фора';
const bo_w31 = (match, outcome) => 'Он бесінші партиядағы фора';
const bo_x31 = (match, outcome) => 'Он алтыншы партиядағы фора';
const bo_y31 = (match, outcome) => 'Он жетінші партиядағы фора';
const bo_z31 = (match, outcome) => 'Он сегізінші партиядағы фора';
const bo_a32 = (match, outcome) => 'Он тоғызыншы партиядағы фора';
const bo_b32 = (match, outcome) => 'Жиырмасыншы партиядағы фора';
const bo_c32 = (match, outcome) => 'Жиырма бірінші партиядағы фора';
const bo_d32 = (match, outcome) => 'Жиырма екінші партиядағы фора';
const bo_e32 = (match, outcome) => 'Жиырма үшінші партиядағы фора';
const bo_f32 = (match, outcome) => 'Жиырма төртінші партиядағы фора';
const bo_g32 = (match, outcome) => 'Жиырма бесінші партиядағы фора';
const bo_h32 = (match, outcome) => 'Жиырма алтыншы партиядағы фора';
const bo_i32 = (match, outcome) => 'Жиырма жетінші партиядағы фора';
const bo_j32 = (match, outcome) => 'Жиырма сегізінші партиядағы фора';
const bo_k32 = (match, outcome) => 'Жиырма тоғызыншы партиядағы фора';
const bo_l32 = (match, outcome) => 'Отызыншы партиядағы фора';
const bo_m32 = (match, outcome) => 'Отыз бірінші партиядағы фора';
const bo_n32 = (match, outcome) => 'Отыз екінші партиядағы фора';
const bo_o32 = (match, outcome) => 'Отыз үшінші партиядағы фора';
const bo_p32 = (match, outcome) => 'Отыз төртінші партиядағы фора';
const bo_q32 = (match, outcome) => 'Отыз бесінші партиядағы фора';
const bo_r32 = (match, outcome) => 'Отыз алтыншы партиядағы фора';
const bo_s32 = (match, outcome) => 'Отыз жетінші партиядағы фора';
const bo_t32 = (match, outcome) => 'Бірінші партияның тоталы';
const bo_u32 = (match, outcome) => 'Екінші партияның тоталы';
const bo_v32 = (match, outcome) => 'Үшінші партияның тоталы';
const bo_w32 = (match, outcome) => 'Төртінші партияның тоталы';
const bo_x32 = (match, outcome) => 'Бесінші партияның тоталы';
const bo_y32 = (match, outcome) => 'Алтыншы партияның тоталы';
const bo_z32 = (match, outcome) => 'Жетінші партияның тоталы';
const bo_a33 = (match, outcome) => 'Сегізінші партияның тоталы';
const bo_b33 = (match, outcome) => 'Тоғызыншы партияның тоталы';
const bo_c33 = (match, outcome) => 'Оныншы партияның тоталы';
const bo_d33 = (match, outcome) => 'Он бірінші партияның тоталы';
const bo_e33 = (match, outcome) => 'Он екінші партияның тоталы';
const bo_f33 = (match, outcome) => 'Он үшінші партияның тоталы';
const bo_g33 = (match, outcome) => 'Он төртінші партияның тоталы';
const bo_h33 = (match, outcome) => 'Он бесінші партияның тоталы';
const bo_i33 = (match, outcome) => 'Он алтыншы партияның тоталы';
const bo_j33 = (match, outcome) => 'Он жетінші партияның тоталы';
const bo_k33 = (match, outcome) => 'Он сегізінші партияның тоталы';
const bo_l33 = (match, outcome) => 'Он тоғызыншы партияның тоталы';
const bo_m33 = (match, outcome) => 'Жиырмасыншы партияның тоталы';
const bo_n33 = (match, outcome) => 'Жиырма бірінші партияның тоталы';
const bo_o33 = (match, outcome) => 'Жиырма екінші партияның тоталы';
const bo_p33 = (match, outcome) => 'Жиырма үшінші партияның тоталы';
const bo_q33 = (match, outcome) => 'Жиырма төртінші партияның тоталы';
const bo_r33 = (match, outcome) => 'Жиырма бесінші партияның тоталы';
const bo_s33 = (match, outcome) => 'Жиырма алтыншы партияның тоталы';
const bo_t33 = (match, outcome) => 'Жиырма жетінші партияның тоталы';
const bo_u33 = (match, outcome) => 'Жиырма сегізінші партияның тоталы';
const bo_v33 = (match, outcome) => 'Жиырма тоғызыншы партияның тоталы';
const bo_w33 = (match, outcome) => 'Отызыншы партияның тоталы';
const bo_x33 = (match, outcome) => 'Отыз бірінші партияның тоталы';
const bo_y33 = (match, outcome) => 'Отыз екінші партияның тоталы';
const bo_z33 = (match, outcome) => 'Отыз үшінші партияның тоталы';
const bo_a34 = (match, outcome) => 'Отыз төртінші партияның тоталы';
const bo_b34 = (match, outcome) => 'Отыз бесінші партияның тоталы';
const bo_c34 = (match, outcome) => 'Отыз алтыншы партияның тоталы';
const bo_d34 = (match, outcome) => 'Отыз жетінші партияның тоталы';
const bo_e34 = (match, outcome) => 'Бірінші партияда кім бірінші болып шар соғады?';
const bo_f34 = (match, outcome) => 'Екінші партияда кім бірінші болып шар соғады?';
const bo_g34 = (match, outcome) => 'Үшінші партияда кім бірінші болып шар соғады?';
const bo_h34 = (match, outcome) => 'Төртінші партияда кім бірінші болып шар соғады?';
const bo_i34 = (match, outcome) => 'Бесінші партияда кім бірінші болып шар соғады?';
const bo_j34 = (match, outcome) => 'Алтыншы партияда кім бірінші болып шар соғады?';
const bo_k34 = (match, outcome) => 'Матчтағы партиялар тоталы';
const bo_l34 = (match, outcome) => `Тотал: ${match.homeTeam} бірінші партияда`;
const bo_m34 = (match, outcome) => `Тотал: ${match.homeTeam} екінші партияда`;
const bo_n34 = (match, outcome) => `Тотал: ${match.homeTeam} үшінші партияда`;
const bo_o34 = (match, outcome) => `Тотал: ${match.homeTeam} төртінші партияда`;
const bo_p34 = (match, outcome) => `Тотал: ${match.homeTeam} бесінші партияда`;
const bo_q34 = (match, outcome) => `Тотал: ${match.homeTeam} алтыншы партияда`;
const bo_r34 = (match, outcome) => `Тотал: ${match.homeTeam} жетінші партияда`;
const bo_s34 = (match, outcome) => `Тотал: ${match.awayTeam} бірінші партияда`;
const bo_t34 = (match, outcome) => `Тотал: ${match.awayTeam} екінші партияда`;
const bo_u34 = (match, outcome) => `Тотал: ${match.awayTeam} үшінші партияда`;
const bo_v34 = (match, outcome) => `Тотал: ${match.awayTeam} төртінші партияда`;
const bo_w34 = (match, outcome) => `Тотал: ${match.awayTeam} бесінші партияда`;
const bo_x34 = (match, outcome) => `Тотал: ${match.awayTeam} алтыншы партияда`;
const bo_y34 = (match, outcome) => `Тотал: ${match.awayTeam} жетінші партияда`;
const bo_z34 = (match, outcome) => `${match.homeTeam} бірінші партияда тура ${outcome.condition} ұпаймен жеңеді`;
const bo_a35 = (match, outcome) => `${match.homeTeam} екінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_b35 = (match, outcome) => `${match.homeTeam} үшінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_c35 = (match, outcome) => `${match.homeTeam} төртінші партияда тура ${outcome.condition} ұпаймен жеңеді`;
const bo_d35 = (match, outcome) => `${match.homeTeam} бесінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_e35 = (match, outcome) => `${match.homeTeam} алтыншы партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_f35 = (match, outcome) => `${match.homeTeam} жетінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_g35 = (match, outcome) => `${match.awayTeam} бірінші партияда тура ${outcome.condition} ұпаймен жеңеді`;
const bo_h35 = (match, outcome) => `${match.awayTeam} екінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_i35 = (match, outcome) => `${match.awayTeam} үшінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_j35 = (match, outcome) => `${match.awayTeam} төртінші партияда тура ${outcome.condition} ұпаймен жеңеді`;
const bo_k35 = (match, outcome) => `${match.awayTeam} бесінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_l35 = (match, outcome) => `${match.awayTeam} алтыншы партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_m35 = (match, outcome) => `${match.awayTeam} жетінші партияда туура ${outcome.condition} ұпаймен жеңеді`;
const bo_n35 = (match, outcome) => 'Бірінші партияның дәл тоталы';
const bo_o35 = (match, outcome) => 'Екінші партияның дәл тоталы';
const bo_p35 = (match, outcome) => 'Үшінші партияның дәл тоталы';
const bo_q35 = (match, outcome) => 'Төртінші партияның дәл тоталы';
const bo_r35 = (match, outcome) => 'Бесінші партияның дәл тоталы';
const bo_s35 = (match, outcome) => 'Алтыншы партияның дәл тоталы';
const bo_t35 = (match, outcome) => 'Жетінші партияның дәл тоталы';
const bo_u35 = (match, outcome) => `Бірінші партияда кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_v35 = (match, outcome) => `Екінші партияда кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_w35 = (match, outcome) => `Үшінші партияда кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_x35 = (match, outcome) => `Төртінші партияда кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_y35 = (match, outcome) => `Бесінші партияда кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_z35 = (match, outcome) => `Алтыншы партияда кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_a36 = (match, outcome) => `Жетінші партияда кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_b36 = (match, outcome) => 'Жұп/бірінші кезеңнің тотал тағы';
const bo_c36 = (match, outcome) => 'Жұп/екінші кезеңнің тотал тағы';
const bo_d36 = (match, outcome) => 'Жұп/үшінші кезеңнің тотал тағы';
const bo_e36 = (match, outcome) => 'Жұп/төртінші кезеңнің тотал тағы';
const bo_f36 = (match, outcome) => 'Жұп/бесінші кезеңнің тотал тағы';
const bo_g36 = (match, outcome) => 'Жұп/алтыншы кезеңнің тотал тағы';
const bo_h36 = (match, outcome) => 'Жұп/жетінші кезеңнің тотал тағы';
const bo_i36 = (match, outcome) => 'Матчтың дәл есебі';
const bo_j36 = (match, outcome) => `${match.awayTeam} 1-ші немесе 2-ші геймдерде брейк жасайды`;
const bo_k36 = (match, outcome) => 'Теннисшімен қатарынан алынған геймдердің ең жоғарғы саны';
const bo_l36 = (match, outcome) => 'Брейктермен алмасу болады ма (екі қатар)?';
const bo_m36 = (match, outcome) => `Тотал: ${match.homeTeam} төртінші сетте`;
const bo_n36 = (match, outcome) => `Тотал: ${match.homeTeam} бесінші сетте`;
const bo_o36 = (match, outcome) => `Тотал: ${match.awayTeam} төртінші сетте`;
const bo_p36 = (match, outcome) => `Тотал: ${match.awayTeam} бесінші сетте`;
const bo_q36 = (match, outcome) => 'Төртінші сеттің жұп/тақ болуы';
const bo_r36 = (match, outcome) => 'Бесінші сеттің жұп/тақ болуы';
const bo_s36 = (match, outcome) => 'Бірінші сет/матч';
const bo_t36 = (match, outcome) => `${outcome.condition} геймде брейк пойнт болады ма?`;
const bo_u36 = (match, outcome) => 'Екінші сеттің брейктердің тоталы';
const bo_v36 = (match, outcome) => 'Үшінші сеттің брейктердің тоталы';
const bo_w36 = (match, outcome) => 'Төртінші сеттің брейктердің тоталы';
const bo_x36 = (match, outcome) => 'Бесінші сеттің брейктердің тоталы';
const bo_y36 = (match, outcome) => `Жеңіс және төртінші сеттің тоталы ${outcome.condition}`;
const bo_z36 = (match, outcome) => `Жеңіс және бесінші сеттің тоталы ${outcome.condition}`;
const bo_a37 = (match, outcome) => `Брейктердің тоталы: ${match.homeTeam} бірінші сетте`;
const bo_b37 = (match, outcome) => `Брейктердің тоталы: ${match.homeTeam} екінші сетте`;
const bo_c37 = (match, outcome) => `Брейктердің тоталы: ${match.homeTeam} үшінші сетте`;
const bo_d37 = (match, outcome) => `Брейктердің тоталы: ${match.homeTeam} төртінші сетте`;
const bo_e37 = (match, outcome) => `Брейктердің тоталы: ${match.homeTeam} бесінші сетте`;
const bo_f37 = (match, outcome) => `Брейктердің тоталы: ${match.awayTeam} бірінші сетте`;
const bo_g37 = (match, outcome) => `Брейктердің тоталы: ${match.awayTeam} екінші сетте`;
const bo_h37 = (match, outcome) => `Брейктердің тоталы: ${match.awayTeam} үшінші сетте`;
const bo_i37 = (match, outcome) => `Брейктердің тоталы: ${match.awayTeam} төртінші сетте`;
const bo_j37 = (match, outcome) => `Брейктердің тоталы: ${match.awayTeam} бесінші сетте`;
const bo_k37 = (match, outcome) => `Бірінші сетте әлдекім қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_l37 = (match, outcome) => `Екінші сетте әлдекім қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_m37 = (match, outcome) => `Үшінші сетте әлдекім қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_n37 = (match, outcome) => `Төртінші сетте әлдекім қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_o37 = (match, outcome) => `Бесінші сетте әлдекім қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_p37 = (match, outcome) => `Бірінші сетте ${match.homeTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_q37 = (match, outcome) => `Екінші сетте ${match.homeTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_r37 = (match, outcome) => `Үшінші сетте ${match.homeTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_s37 = (match, outcome) => `Төртінші сетте ${match.homeTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_t37 = (match, outcome) => `Бесінші сетте ${match.homeTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_u37 = (match, outcome) => `Бірінші сетте ${match.awayTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_v37 = (match, outcome) => `Екінші сетте ${match.awayTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_w37 = (match, outcome) => `Үшінші сетте ${match.awayTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_x37 = (match, outcome) => `Төртінші сетте ${match.awayTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_y37 = (match, outcome) => `Бесінші сетте ${match.awayTeam} қатарынан ${outcome.condition} гейм ұтады ма?`;
const bo_z37 = (match, outcome) => 'Төртінші сеттегі фора';
const bo_a38 = (match, outcome) => 'Бесінші сеттегі фора';
const bo_b38 = (match, outcome) => 'Төртінші сеттің тоталы';
const bo_c38 = (match, outcome) => 'Бесінші сеттің тоталы';
const bo_d38 = (match, outcome) => `${outcome.condition} геймнің дәл есебі`;
const bo_e38 = (match, outcome) => `${outcome.condition} геймді кім алады?`;
const bo_f38 = (match, outcome) => 'Бірінші сеттің дәл есебі';
const bo_g38 = (match, outcome) => 'Екінші сеттің дәл есебі';
const bo_h38 = (match, outcome) => 'Үшінші сеттің дәл есебі';
const bo_i38 = (match, outcome) => 'Төртінші сеттің дәл есебі';
const bo_j38 = (match, outcome) => 'Бесінші сеттің дәл есебі';
const bo_k38 = (match, outcome) => `${outcome.condition} геймде 15x15 бола ма?`;
const bo_l38 = (match, outcome) => `${outcome.condition} геймде 30x30 бола ма?`;
const bo_m38 = (match, outcome) => `${outcome.condition} геймде 40x40 бола ма?`;
const bo_n38 = (match, outcome) => `Бірінші сетте бірінші болып кім ${outcome.condition} геймді алады`;
const bo_o38 = (match, outcome) => `Екінші сетте бірінші болып кім ${outcome.condition} геймді алады`;
const bo_p38 = (match, outcome) => `Үшінші сетте бірінші болып кім ${outcome.condition} геймді алады`;
const bo_q38 = (match, outcome) => `Төртінші сетте бірінші болып кім ${outcome.condition} геймді алады`;
const bo_r38 = (match, outcome) => `Бесінші сетте бірінші болып кім ${outcome.condition} геймді алады`;
const bo_s38 = (match, outcome) => 'Төртінші сет нәтижесі';
const bo_t38 = (match, outcome) => 'Бесінші сет нәтижесі';
const bo_u38 = (match, outcome) => `${outcome.condition} геймде кім бірінші ұтысты алады?`;
const bo_v38 = (match, outcome) => 'Бірінші сетте тай-брейк бола ма?';
const bo_w38 = (match, outcome) => 'Екінші сетте тай-брейк бола ма?';
const bo_x38 = (match, outcome) => 'Үшінші сетте тай-брейк бола ма?';
const bo_y38 = (match, outcome) => 'Төртінші сетте тай-брейк бола ма?';
const bo_z38 = (match, outcome) => 'Бесінші сетте тай-брейк бола ма?';
const bo_a39 = (match, outcome) => 'Матчта тай-брейк болады ма?';
const bo_b39 = (match, outcome) => 'Бірінші сеттегі тай-брейктің тоталы';
const bo_c39 = (match, outcome) => 'Екінші сеттегі тай-брейктің тоталы';
const bo_d39 = (match, outcome) => 'Үшінші сеттегі тай-брейктің тоталы';
const bo_e39 = (match, outcome) => 'Төртінші сеттегі тай-брейктің тоталы';
const bo_f39 = (match, outcome) => 'Бесінші сеттегі тай-брейктің тоталы';
const bo_g39 = (match, outcome) => 'Бірінші сеттегі тай-брейктің дәл есебі';
const bo_h39 = (match, outcome) => 'Екінші сеттегі тай-брейктің дәл есебі';
const bo_i39 = (match, outcome) => 'Үшінші сеттегі тай-брейктің дәл есебі';
const bo_j39 = (match, outcome) => 'Төртінші сеттегі тай-брейктің дәл есебі';
const bo_k39 = (match, outcome) => 'Бесінші сеттегі тай-брейктің дәл есебі';
const bo_l39 = (match, outcome) => 'Бірінші сеттегі тай-брейктің дәл тоталы';
const bo_m39 = (match, outcome) => 'Екінші сеттегі тай-брейктің дәл тоталы';
const bo_n39 = (match, outcome) => 'Үшінші сеттегі тай-брейктің дәл тоталы';
const bo_o39 = (match, outcome) => 'Төртінші сеттегі тай-брейктің дәл тоталы';
const bo_p39 = (match, outcome) => 'Бесінші сеттегі тай-брейктің дәл тоталы';
const bo_q39 = (match, outcome) => 'Бірінші сетте тай-брейкте кім жеңеді?';
const bo_r39 = (match, outcome) => 'Екінші сетте тай-брейкте кім жеңеді?';
const bo_s39 = (match, outcome) => 'Үшінші сетте тай-брейкте кім жеңеді?';
const bo_t39 = (match, outcome) => 'Төртінші сетте тай-брейкте кім жеңеді?';
const bo_u39 = (match, outcome) => 'Бесінші сетте тай-брейкте кім жеңеді?';
const bo_v39 = (match, outcome) => 'Бірінші сеттің брейктердің тоталы';
const bo_w39 = (match, outcome) => 'Матчтағы брейктердің тоталы';
const bo_x39 = (match, outcome) => `${match.homeTeam} матчта сетті ұтады`;
const bo_y39 = (match, outcome) => `${match.awayTeam} матчта сетті ұтады`;
const bo_z39 = (match, outcome) => 'Ең нәтижесіз сеттің тоталы';
const bo_a40 = (match, outcome) => 'Матчта кім бірінші эйсті береді';
const bo_b40 = (match, outcome) => 'Матчта кім бірінші қосарлы қателікті жасайды';
const bo_c40 = (match, outcome) => `${match.homeTeam}: берудің ең жоғарғы жылдамдығы (км/с)`;
const bo_d40 = (match, outcome) => `${match.awayTeam}: берудің ең жоғарғы жылдамдығы (км/с)`;
const bo_e40 = (match, outcome) => 'Бірінші сеттің ұтылысынан кейін матчтағы жеңіс';
const bo_f40 = (match, outcome) => `${match.homeTeam}: бірінші беру %;`;
const bo_g40 = (match, outcome) => `${match.awayTeam}: бірінші беру %;`;
const bo_h40 = (match, outcome) => 'Матчта кім көп брейк жасайды';
const bo_i40 = (match, outcome) => `Брейктердің тоталы: ${match.homeTeam}`;
const bo_j40 = (match, outcome) => `Брейктердің тоталы: ${match.awayTeam}`;
const bo_k40 = (match, outcome) => 'Матчта кім бірінші брейкті жасайды';
const bo_l40 = (match, outcome) => `${match.homeTeam} 1-ші немесе 2-ші геймдерде брейк жасайды`;
const bo_m40 = (match, outcome) => 'Матчта 6:0 немесе 0:6 есеппен сет болады ма?';
const bo_n40 = (match, outcome) => `Кім ${outcome.condition} гейм алады?`;
const bo_o40 = (match, outcome) => `${outcome.condition} геймде 15x15 болады ма?`;
const bo_p40 = (match, outcome) => `${outcome.condition} геймде 30x30 болады ма?`;
const bo_q40 = (match, outcome) => `${outcome.condition} геймде 40x40 болады ма?`;
const bo_r40 = (match, outcome) => `${outcome.condition} геймде бірінші ұпай`;
const bo_s40 = (match, outcome) => ` ${outcome.condition} геймде бірінші ұпай`;
const bo_t40 = (match, outcome) => 'Матчтағы эйстер тоталы';
const bo_u40 = (match, outcome) => `Матчтағы эйстер тоталы: ${match.homeTeam}`;
const bo_v40 = (match, outcome) => `Матчтағы эйстер тоталы: ${match.awayTeam}`;
const bo_w40 = (match, outcome) => 'Матчтағы қос қателер тоталы';
const bo_x40 = (match, outcome) => `Матчтағы қос қателер тоталы : ${match.homeTeam}`;
const bo_y40 = (match, outcome) => `Матчтағы қос қателер тоталы : ${match.awayTeam}`;
const bo_z40 = (match, outcome) => 'Сеттер (Тотал) нәтижелілігі';
const bo_a41 = (match, outcome) => 'Матчта өтіп шығу беріспен жеңеді';
const bo_b41 = (match, outcome) => `1-інші немесе 2-нші геймдерде эйс: ${match.homeTeam}`;
const bo_c41 = (match, outcome) => `1-інші немесе 2-нші геймдерде эйс: ${match.awayTeam}`;
const bo_d41 = (match, outcome) => `1-інші немесе 2-нші геймдерде қос қате: ${match.homeTeam}`;
const bo_e41 = (match, outcome) => `1-інші немесе 2-нші геймдерде қос қате: ${match.awayTeam}`;
const bo_f41 = (match, outcome) => 'Бірінші сетте эйс тоталы';
const bo_g41 = (match, outcome) => 'Матч барысында споршы шығады (дискв.)';
const bo_h41 = (match, outcome) => `${match.homeTeam} бірінші берістің тигізу %`;
const bo_i41 = (match, outcome) => `${match.awayTeam}  бірінші берістің тигізу %`;
const bo_j41 = (match, outcome) => 'Бірінші сетте брейктерден нәтиже';
const bo_k41 = (match, outcome) => 'Екінші сетте брейктерден нәтиже';
const bo_l41 = (match, outcome) => 'Үшінші сетте брейктерден нәтиже';
const bo_m41 = (match, outcome) => 'Төртінші сетте брейктерден нәтиже';
const bo_n41 = (match, outcome) => 'Бесінші сетте брейктерден нәтиже';
const bo_o41 = (match, outcome) => 'Матчтағы брейктерден фора';
const bo_p41 = (match, outcome) => 'Бірінші сетте брейктерден фора';
const bo_q41 = (match, outcome) => 'Екінші сетте брейктерден фора';
const bo_r41 = (match, outcome) => 'Үшінші сетте брейктерден фора';
const bo_s41 = (match, outcome) => 'Төртінші сетте брейктерден фора';
const bo_t41 = (match, outcome) => 'Бесінші сетте брейктерден фора';
const bo_u41 = (match, outcome) => `Кім ${outcome.conditionTwo} ұпайды ${outcome.condition} геймде алады`;
const bo_v41 = (match, outcome) => `${outcome.condition} және ${outcome.conditionTwo} геймдерде нәтиже`;
const bo_w41 = (match, outcome) => `${outcome.conditionTwo} геймде фора`;
const bo_x41 = (match, outcome) => `${outcome.conditionTwo} геймде тотал`;
const bo_y41 = (match, outcome) => `Төртінші сетте кім ${outcome.condition} ұпайды бірінші болып алады?`;
const bo_z41 = (match, outcome) => `Бесінші сетте кім ${outcome.condition} ұпайды бірінші болып алады?`;
const bo_a42 = (match, outcome) => 'Төртінші сеттің дәл тоталы';
const bo_b42 = (match, outcome) => 'Бесінші сеттің дәл тоталы';
const bo_c42 = (match, outcome) => `${match.homeTeam} төртінші сетте айырмашылықпен жеңеді`;
const bo_d42 = (match, outcome) => `${match.homeTeam} бесінші сетте айырмашылықпен жеңеді`;
const bo_e42 = (match, outcome) => `${match.awayTeam} төртінші сетте айырмашылықпен жеңеді`;
const bo_f42 = (match, outcome) => `${match.awayTeam} бесінші сетте айырмашылықпен жеңеді`;
const bo_g42 = (match, outcome) => 'Ең нәтижелі сеттің тоталы';
const bo_h42 = (match, outcome) => 'Төртінші сетте айырмашылықпен жеңіс';
const bo_i42 = (match, outcome) => 'Бесінші сетте айырмашылықпен жеңіс';
const bo_j42 = (match, outcome) => 'Бірінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
const bo_k42 = (match, outcome) => 'Екінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
const bo_l42 = (match, outcome) => 'Үшінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
const bo_m42 = (match, outcome) => 'Төртінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
const bo_n42 = (match, outcome) => 'Бірінші сеттің 10 ұпайына дейін шағын сетте фора';
const bo_o42 = (match, outcome) => 'Екінші сеттің 10 ұпайына дейін шағын сетте фора';
const bo_p42 = (match, outcome) => 'Үшінші сеттің 10 ұпайына дейін шағын сетте фора';
const bo_q42 = (match, outcome) => 'Төртінші сеттің 10 ұпайына дейін шағын сетте фора';
const bo_r42 = (match, outcome) => 'Бірінші сеттің 10 ұпайына дейін шағын сетте тотал';
const bo_s42 = (match, outcome) => 'Екінші сеттің 10 ұпайына дейін шағын сетте тотал';
const bo_t42 = (match, outcome) => 'Үшінші сеттің 10 ұпайына дейін шағын сетте тотал';
const bo_u42 = (match, outcome) => 'Төртінші сеттің 10 ұпайына дейін шағын сетте тотал';
const bo_v42 = (match, outcome) => 'Бірінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
const bo_w42 = (match, outcome) => 'Екінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
const bo_x42 = (match, outcome) => 'Үшінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
const bo_y42 = (match, outcome) => 'Төртінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
const bo_z42 = (match, outcome) => 'Бірінші сеттің 15 ұпайына дейін шағын сетте фора';
const bo_a43 = (match, outcome) => 'Екінші сеттің 15 ұпайына дейін шағын сетте фора';
const bo_b43 = (match, outcome) => 'Үшінші сеттің 15 ұпайына дейін шағын сетте фора';
const bo_c43 = (match, outcome) => 'Төртінші сеттің 15 ұпайына дейін шағын сетте фора';
const bo_d43 = (match, outcome) => 'Бірінші сеттің 15 ұпайына дейін шағын сетте тотал';
const bo_e43 = (match, outcome) => 'Екінші сеттің 15 ұпайына дейін шағын сетте тотал';
const bo_f43 = (match, outcome) => 'Үшінші сеттің 15 ұпайына дейін шағын сетте тотал';
const bo_g43 = (match, outcome) => 'Төртінші сеттің 15 ұпайына дейін шағын сетте тотал';
const bo_h43 = (match, outcome) => `Төртінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_i43 = (match, outcome) => `Бесінші сетте кім ${numeralNeuterEnding(outcome.condition)} ұпай ұтады`;
const bo_j43 = (match, outcome) => 'Алтын сетте фора';
const bo_k43 = (match, outcome) => 'Алтын сет тоталы';
const bo_l43 = (match, outcome) => `Тотал: ${match.homeTeam}Алтын сетте`;
const bo_m43 = (match, outcome) => `Тотал: ${match.awayTeam} Алтын сетте`;
const bo_n43 = (match, outcome) => 'Алтын сет нәтижесі';
const bo_o43 = (match, outcome) => `Кім бірінші болып Алтын сетте ${outcome.condition} ${plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар'])} алады`;
const bo_p43 = (match, outcome) => 'Алтын сеттің дәл тоталы';
const bo_q43 = (match, outcome) => 'Алтын сеттің жұп/тақ';
const bo_r43 = (match, outcome) => `Алтын сеттің жеңісі және тоталы ${outcome.condition}`;
const bo_s43 = (match, outcome) => 'Алтын сетте айырмашылықпен жеңіс';
const bo_t43 = (match, outcome) => 'Неше сетте шағын тай-брейк болады?';
const bo_u43 = (match, outcome) => `${outcome.condition} раундты кім жеңеді?`;
const bo_v43 = (match, outcome) => 'Выпадет ли 13 сектор?';
const bo_w43 = (match, outcome) => `Выпадет ли 13 сектор в ${outcome.condition}-м раунде?`;

const fa_b1 = (match, outcome) => `Ф1(${signed(outcome.condition)})`;
const fa_c1 = (match, outcome) => `Ф2(${signed(-outcome.condition)})`;
const fa_d1 = (match, outcome) => `Аз ${outcome.condition}`;
const fa_e1 = (match, outcome) => `Көп ${outcome.condition}`;
const fa_f1 = (match, outcome) => `${outcome.condition} аз`;
const fa_g1 = (match, outcome) => `${outcome.condition} көп`;
const fa_h1 = (match, outcome) => 'Жұп';
const fa_i1 = (match, outcome) => 'Тақ';
const fa_j1 = (match, outcome) => 'Ж1';
const fa_k1 = (match, outcome) => 'Ж2';
const fa_l1 = (match, outcome) => '1-інші жоғары';
const fa_m1 = (match, outcome) => '2-нші жоғары';
const fa_n1 = (match, outcome) => 'Иә';
const fa_o1 = (match, outcome) => 'Жоқ';
const fa_p1 = (match, outcome) => `Көп${outcome.condition}`;
const fa_q1 = (match, outcome) => '0-2';
const fa_r1 = (match, outcome) => '0-3';
const fa_s1 = (match, outcome) => '1-2';
const fa_t1 = (match, outcome) => '1-3';
const fa_u1 = (match, outcome) => '2-0';
const fa_v1 = (match, outcome) => '2-1';
const fa_w1 = (match, outcome) => '2-3';
const fa_x1 = (match, outcome) => '3-0';
const fa_y1 = (match, outcome) => '3-1';
const fa_z1 = (match, outcome) => '3-2';
const fa_a2 = (match, outcome) => `${match.homeTeam}`;
const fa_b2 = (match, outcome) => `${match.awayTeam}`;
const fa_c2 = (match, outcome) => 'Х';
const fa_d2 = (match, outcome) => 'Ешкім';
const fa_e2 = (match, outcome) => '1X';
const fa_f2 = (match, outcome) => '12';
const fa_g2 = (match, outcome) => '2X';
const fa_h2 = (match, outcome) => `Ж1Та ${outcome.condition}`;
const fa_i2 = (match, outcome) => `Ж1Тк ${outcome.condition}`;
const fa_j2 = (match, outcome) => `Ж2Та ${outcome.condition}`;
const fa_k2 = (match, outcome) => `Ж2Тк ${outcome.condition}`;
const fa_l2 = (match, outcome) => `ХТа ${outcome.condition}`;
const fa_m2 = (match, outcome) => `ХТк ${outcome.condition}`;
const fa_n2 = (match, outcome) => '0';
const fa_o2 = (match, outcome) => '1';
const fa_p2 = (match, outcome) => '2';
const fa_q2 = (match, outcome) => '3';
const fa_r2 = (match, outcome) => '4';
const fa_s2 = (match, outcome) => '≥ 5';
const fa_t2 = (match, outcome) => 'Екі команда соғады';
const fa_u2 = (match, outcome) => 'Тура бір команда соғады';
const fa_v2 = (match, outcome) => 'Екі команда соөқпайды';
const fa_w2 = (match, outcome) => '0-0';
const fa_x2 = (match, outcome) => '0-1';
const fa_y2 = (match, outcome) => '0-4';
const fa_z2 = (match, outcome) => '0-5';
const fa_a3 = (match, outcome) => '1-0';
const fa_b3 = (match, outcome) => '1-1';
const fa_c3 = (match, outcome) => '1-4';
const fa_d3 = (match, outcome) => '1-5';
const fa_e3 = (match, outcome) => '2-2';
const fa_f3 = (match, outcome) => '2-4';
const fa_g3 = (match, outcome) => '2-5';
const fa_h3 = (match, outcome) => '2-6';
const fa_i3 = (match, outcome) => '3-3';
const fa_j3 = (match, outcome) => '3-4';
const fa_k3 = (match, outcome) => '3-5';
const fa_l3 = (match, outcome) => '4-0';
const fa_m3 = (match, outcome) => '4-1';
const fa_n3 = (match, outcome) => '4-2';
const fa_o3 = (match, outcome) => '4-3';
const fa_p3 = (match, outcome) => '4-4';
const fa_q3 = (match, outcome) => '5-0';
const fa_r3 = (match, outcome) => '5-1';
const fa_s3 = (match, outcome) => '5-2';
const fa_t3 = (match, outcome) => '5-3';
const fa_u3 = (match, outcome) => 'Кез келген басқа';
const fa_v3 = (match, outcome) => `≤ ${outcome.condition}`;
const fa_w3 = (match, outcome) => `${outcome.condition + 1} - ${outcome.condition + 2}`;
const fa_x3 = (match, outcome) => `${outcome.condition + 3} - ${outcome.condition + 4}`;
const fa_y3 = (match, outcome) => `${outcome.condition + 5} - ${outcome.condition + 6}`;
const fa_z3 = (match, outcome) => `${outcome.condition + 7} - ${outcome.condition + 8}`;
const fa_a4 = (match, outcome) => `≥ ${outcome.condition + 9}`;
const fa_b4 = (match, outcome) => '6-9';
const fa_c4 = (match, outcome) => '10-12';
const fa_d4 = (match, outcome) => '13-16';
const fa_e4 = (match, outcome) => '17-20';
const fa_f4 = (match, outcome) => '≥21';
const fa_g4 = (match, outcome) => `Өту: ${match.homeTeam}`;
const fa_h4 = (match, outcome) => `Өту: ${match.awayTeam}`;
const fa_i4 = (match, outcome) => '1-ші жарты';
const fa_j4 = (match, outcome) => '2-ші жарты';
const fa_k4 = (match, outcome) => '1-ші ширек';
const fa_l4 = (match, outcome) => '2-ші ширек';
const fa_m4 = (match, outcome) => '3-ші ширек';
const fa_n4 = (match, outcome) => '4-ші ширек';
const fa_o4 = (match, outcome) => 'Ж1: 1-2';
const fa_p4 = (match, outcome) => 'Ж1: 3-5';
const fa_q4 = (match, outcome) => 'Ж1: 6-9';
const fa_r4 = (match, outcome) => 'Ж1: 10-12';
const fa_s4 = (match, outcome) => 'Ж1: 13-16';
const fa_t4 = (match, outcome) => 'Ж1: 17-20';
const fa_u4 = (match, outcome) => 'Ж1: ≥21';
const fa_v4 = (match, outcome) => 'Ж2: 1-2';
const fa_w4 = (match, outcome) => 'Ж2: 3-5';
const fa_x4 = (match, outcome) => 'Ж2: 6-9';
const fa_y4 = (match, outcome) => 'Ж2: 10-12';
const fa_z4 = (match, outcome) => 'Ж2: 13-16';
const fa_a5 = (match, outcome) => 'Ж2: 17-20';
const fa_b5 = (match, outcome) => 'Ж2: ≥21';
const fa_c5 = (match, outcome) => 'Ж1: 3-4';
const fa_d5 = (match, outcome) => 'Ж1: 5-7';
const fa_e5 = (match, outcome) => 'Ж1: ≥8';
const fa_f5 = (match, outcome) => 'Х2';
const fa_g5 = (match, outcome) => 'Ж2: 3-4';
const fa_h5 = (match, outcome) => 'Ж2: 5-7';
const fa_i5 = (match, outcome) => 'Ж2: ≥8';
const fa_j5 = (match, outcome) => 'Х1';
const fa_k5 = (match, outcome) => '1-інші ширек';
const fa_l5 = (match, outcome) => '2-нші ширек';
const fa_m5 = (match, outcome) => '3-інші ширек';
const fa_n5 = (match, outcome) => '4-інші ширек';
const fa_o5 = (match, outcome) => 'Айыппұл доп';
const fa_p5 = (match, outcome) => '3-ұпайлық';
const fa_q5 = (match, outcome) => '2-ұпайлық';
const fa_r5 = (match, outcome) => `Ж1 ≥ ${outcome.condition}`;
const fa_s5 = (match, outcome) => `Айырмашылық ${outcome.condition} аз`;
const fa_t5 = (match, outcome) => `Ж2 ≥ ${outcome.condition}`;
const fa_u5 = (match, outcome) => `Ж1: ${outcome.condition} көп =21`;
const fa_v5 = (match, outcome) => `Ж2:${outcome.condition} көп=21`;
const fa_w5 = (match, outcome) => 'Ж1: 8 және одан көп';
const fa_x5 = (match, outcome) => 'Ж2: 8 және одан көп';
const fa_y5 = (match, outcome) => '1-інші жартылық';
const fa_z5 = (match, outcome) => '2-нші жартылық';
const fa_a6 = (match, outcome) => 'Ешқандай';
const fa_b6 = (match, outcome) => 'жұп';
const fa_c6 = (match, outcome) => 'тақ';
const fa_d6 = (match, outcome) => 'Ж1: 1';
const fa_e6 = (match, outcome) => 'Ж1: 2';
const fa_f6 = (match, outcome) => 'Ж1: 3';
const fa_g6 = (match, outcome) => 'Ж1: 4';
const fa_h6 = (match, outcome) => 'Ж1: ≥ 5';
const fa_i6 = (match, outcome) => 'Ж2: 1';
const fa_j6 = (match, outcome) => 'Ж2: 2';
const fa_k6 = (match, outcome) => 'Ж2: 3';
const fa_l6 = (match, outcome) => 'Ж2: 4';
const fa_m6 = (match, outcome) => 'Ж2: ≥ 5';
const fa_n6 = (match, outcome) => '1Х';
const fa_o6 = (match, outcome) => 'Екеуі де';
const fa_p6 = (match, outcome) => 'Бір';
const fa_q6 = (match, outcome) => 'Ешқайсысы';
const fa_r6 = (match, outcome) => '0 немесе 1';
const fa_s6 = (match, outcome) => '5';
const fa_t6 = (match, outcome) => '6';
const fa_u6 = (match, outcome) => '7';
const fa_v6 = (match, outcome) => '≥ 8';
const fa_w6 = (match, outcome) => 'Ж1Ж1';
const fa_x6 = (match, outcome) => 'Ж1Ж';
const fa_y6 = (match, outcome) => 'Ж1Ж2';
const fa_z6 = (match, outcome) => 'НЖ1';
const fa_a7 = (match, outcome) => 'НН';
const fa_b7 = (match, outcome) => 'НЖ2';
const fa_c7 = (match, outcome) => 'Ж2Ж1';
const fa_d7 = (match, outcome) => 'Ж2Н';
const fa_e7 = (match, outcome) => 'Ж2Ж2';
const fa_f7 = (match, outcome) => `${outcome.condition + 1}`;
const fa_g7 = (match, outcome) => `${outcome.condition + 2}`;
const fa_h7 = (match, outcome) => `${outcome.condition + 3}`;
const fa_i7 = (match, outcome) => `${outcome.condition + 4}`;
const fa_j7 = (match, outcome) => `${outcome.condition + 5}`;
const fa_k7 = (match, outcome) => `${outcome.condition + 6}`;
const fa_l7 = (match, outcome) => `≥ ${outcome.condition + 7}`;
const fa_m7 = (match, outcome) => `${outcome.condition + 1} - ${outcome.condition + 2} дейін`;
const fa_n7 = (match, outcome) => `${outcome.condition + 3} - ${outcome.condition + 4} дейін`;
const fa_o7 = (match, outcome) => `${outcome.condition + 5} - ${outcome.condition + 6} дейін`;
const fa_p7 = (match, outcome) => `≥ ${outcome.condition + 7} және одан асады`;
const fa_q7 = (match, outcome) => '44960';
const fa_r7 = (match, outcome) => '45022';
const fa_s7 = (match, outcome) => '7 және одан асады';
const fa_t7 = (match, outcome) => '4-6';
const fa_u7 = (match, outcome) => 'Ж1Та';
const fa_v7 = (match, outcome) => 'Ж1Тк';
const fa_w7 = (match, outcome) => 'Ж2Та';
const fa_x7 = (match, outcome) => 'Ж2Тк';
const fa_y7 = (match, outcome) => '1-ші көп';
const fa_z7 = (match, outcome) => '2-нші көп';
const fa_a8 = (match, outcome) => 'Ж1: 2-3';
const fa_b8 = (match, outcome) => 'Ж1: 4-6';
const fa_c8 = (match, outcome) => 'Ж1: ≥7';
const fa_d8 = (match, outcome) => 'Ж2: 2-3';
const fa_e8 = (match, outcome) => 'Ж2: 4-6';
const fa_f8 = (match, outcome) => 'Ж2: ≥7';
const fa_g8 = (match, outcome) => `${outcome.condition}`;
const fa_h8 = (match, outcome) => `≥ ${outcome.condition + 6}`;
const fa_i8 = (match, outcome) => 'Ж1: мерзімнен бұрын жеңу';
const fa_j8 = (match, outcome) => 'Ж1: ұпайдан жеңу';
const fa_k8 = (match, outcome) => 'Тең';
const fa_l8 = (match, outcome) => 'Ж2: мерзімнен бұрын жеңу';
const fa_m8 = (match, outcome) => 'Ж2: ұпайдан жеңу';
const fa_n8 = (match, outcome) => 'Ж1: 1 раунд';
const fa_o8 = (match, outcome) => 'Ж1: 2 раунд';
const fa_p8 = (match, outcome) => 'Ж1: 3 раунд';
const fa_q8 = (match, outcome) => 'ЖЖ1: 4 раунд';
const fa_r8 = (match, outcome) => 'Ж1: 5 раунд';
const fa_s8 = (match, outcome) => 'Ж1: 6 раунд';
const fa_t8 = (match, outcome) => 'Ж1: 7 раунд';
const fa_u8 = (match, outcome) => 'Ж1: 8 раунд';
const fa_v8 = (match, outcome) => 'Ж1: 9 раунд';
const fa_w8 = (match, outcome) => 'Ж1: 10 раунд';
const fa_x8 = (match, outcome) => 'Ж1: 11 раунд';
const fa_y8 = (match, outcome) => 'Ж1: 12 раунд';
const fa_z8 = (match, outcome) => 'Ж2: 1 раунд';
const fa_a9 = (match, outcome) => 'Ж2: 2 раунд';
const fa_b9 = (match, outcome) => 'Ж2: 3 раунд';
const fa_c9 = (match, outcome) => 'Ж2: 4 раунд';
const fa_d9 = (match, outcome) => 'Ж2: 5 раунд';
const fa_e9 = (match, outcome) => 'Ж2: 6 раунд';
const fa_f9 = (match, outcome) => 'Ж2: 7 раунд';
const fa_g9 = (match, outcome) => 'Ж2: 8 раунд';
const fa_h9 = (match, outcome) => 'Ж2: 9 раунд';
const fa_i9 = (match, outcome) => 'Ж2: 10 раунд';
const fa_j9 = (match, outcome) => 'Ж2: 11 раунд';
const fa_k9 = (match, outcome) => 'Ж2: 12 раунд';
const fa_l9 = (match, outcome) => 'Ия';
const fa_m9 = (match, outcome) => 'X';
const fa_n9 = (match, outcome) => '5 және одан көп';
const fa_o9 = (match, outcome) => 'Екі';
const fa_p9 = (match, outcome) => 'Ешбірі';
const fa_q9 = (match, outcome) => `Командалардың әрқайсысы ${outcome.condition + 1} немесе одан асатын голды салады`;
const fa_r9 = (match, outcome) => `Тура біреуі ${outcome.condition + 1} немесе одан асатын голды салады`;
const fa_s9 = (match, outcome) => `Ешкім ${outcome.condition + 1} немесе одан асатын голды салады`;
const fa_t9 = (match, outcome) => 'Бірінші голды баспен ұрып салады';
const fa_u9 = (match, outcome) => 'Бірінші голды аяқпен (ойындағы) салады';
const fa_v9 = (match, outcome) => 'Бірінші гол автогол болады';
const fa_w9 = (match, outcome) => 'Бірінші гол пенальтиден салынады';
const fa_x9 = (match, outcome) => 'Бұрыштама';
const fa_y9 = (match, outcome) => 'Офсайд';
const fa_z9 = (match, outcome) => 'СК';
const fa_a10 = (match, outcome) => 'Гол';
const fa_b10 = (match, outcome) => 'Болады';
const fa_c10 = (match, outcome) => 'Болмайды';
const fa_d10 = (match, outcome) => `Ерте ${outcome.condition}`;
const fa_e10 = (match, outcome) => 'Кейін';
const fa_f10 = (match, outcome) => 'Бірінші таймда';
const fa_g10 = (match, outcome) => 'Екінші таймда';
const fa_h10 = (match, outcome) => 'Гол болмайды';
const fa_i10 = (match, outcome) => 'Салмайды';
const fa_j10 = (match, outcome) => 'Ж1Т';
const fa_k10 = (match, outcome) => 'ТЖ1';
const fa_l10 = (match, outcome) => 'ТТ';
const fa_m10 = (match, outcome) => 'ТЖ2';
const fa_n10 = (match, outcome) => 'Ж2Т';
const fa_o10 = (match, outcome) => '0-6';
const fa_p10 = (match, outcome) => '1-6';
const fa_q10 = (match, outcome) => '6-0';
const fa_r10 = (match, outcome) => '6-1';
const fa_s10 = (match, outcome) => 'Голдық тең ойын';
const fa_t10 = (match, outcome) => 'Голсыз тең ойын';
const fa_u10 = (match, outcome) => 'Тең ойын емес';
const fa_v10 = (match, outcome) => 'Ерте';
const fa_w10 = (match, outcome) => 'Соғады';
const fa_x10 = (match, outcome) => 'Соқпайды';
const fa_y10 = (match, outcome) => 'Екі команда соқпайды';
const fa_z10 = (match, outcome) => 'Бірінші аздау';
const fa_a11 = (match, outcome) => 'Теңдік';
const fa_b11 = (match, outcome) => 'Бірінші көп';
const fa_c11 = (match, outcome) => `Мен. ${outcome.condition}`;
const fa_d11 = (match, outcome) => `Бол. ${outcome.condition}`;
const fa_e11 = (match, outcome) => 'Иә/Иә';
const fa_f11 = (match, outcome) => 'Иә/Жоқ';
const fa_g11 = (match, outcome) => 'Жоқ/Иә';
const fa_h11 = (match, outcome) => 'Жоқ/Жоқ';
const fa_i11 = (match, outcome) => `Тб${outcome.condition}/Иә`;
const fa_j11 = (match, outcome) => `Тб${outcome.condition}/Жоқ`;
const fa_k11 = (match, outcome) => `Тм${outcome.condition}/Иә`;
const fa_l11 = (match, outcome) => `Тм${outcome.condition}/Жоқ`;
const fa_m11 = (match, outcome) => 'Ж1 негізгі уақытта';
const fa_n11 = (match, outcome) => 'Ж2 негізгі уақытта';
const fa_o11 = (match, outcome) => 'Ж1 қосымша уақытта';
const fa_p11 = (match, outcome) => 'Ж2 қосымша уақытта';
const fa_q11 = (match, outcome) => 'Ж1 пенальти сериясында';
const fa_r11 = (match, outcome) => 'Ж2 пенальти сериясында';
const fa_s11 = (match, outcome) => '1 тайм';
const fa_t11 = (match, outcome) => 'Үзіліс';
const fa_u11 = (match, outcome) => '2 тайм';
const fa_v11 = (match, outcome) => `Аз${outcome.condition}`;
const fa_w11 = (match, outcome) => '5-4';
const fa_x11 = (match, outcome) => 'Ж1 кез келген басқамен';
const fa_y11 = (match, outcome) => '4-5';
const fa_z11 = (match, outcome) => 'Ж2 кез келген басқамен';
const fa_a12 = (match, outcome) => '1-10';
const fa_b12 = (match, outcome) => '11-20';
const fa_c12 = (match, outcome) => '21-30';
const fa_d12 = (match, outcome) => '31-40';
const fa_e12 = (match, outcome) => '41-50';
const fa_f12 = (match, outcome) => '51-60';
const fa_g12 = (match, outcome) => '61-70';
const fa_h12 = (match, outcome) => '71-80';
const fa_i12 = (match, outcome) => '81-ОВ соңы';
const fa_j12 = (match, outcome) => 'Гол жоқ';
const fa_k12 = (match, outcome) => 'Ж1: 8 және одан асады';
const fa_l12 = (match, outcome) => '1<2';
const fa_m12 = (match, outcome) => '1=2';
const fa_n12 = (match, outcome) => '1>2';
const fa_o12 = (match, outcome) => '1<3';
const fa_p12 = (match, outcome) => '1=3';
const fa_q12 = (match, outcome) => '1>3';
const fa_r12 = (match, outcome) => '2<3';
const fa_s12 = (match, outcome) => '2=3';
const fa_t12 = (match, outcome) => '2>3';
const fa_u12 = (match, outcome) => 'Чет';
const fa_v12 = (match, outcome) => 'Нечет';
const fa_w12 = (match, outcome) => 'Первый меньше';
const fa_x12 = (match, outcome) => 'Первый больше';
const fa_y12 = (match, outcome) => 'Да';
const fa_z12 = (match, outcome) => 'Нет';
const fa_a13 = (match, outcome) => '1-ші жоғары';
const fa_b13 = (match, outcome) => '2-ші жоғары';
const fa_c13 = (match, outcome) => 'Ж1: 4 раунд';
const fa_d13 = (match, outcome) => 'Ж1: ұпай бойынша жеңіс';
const fa_e13 = (match, outcome) => 'Тең түсу';
const fa_f13 = (match, outcome) => 'Ж2: ұпайлар бойынша жеңіс';
const fa_g13 = (match, outcome) => 'иә';
const fa_h13 = (match, outcome) => 'жоқ';
const fa_i13 = (match, outcome) => 'Сары шар';
const fa_j13 = (match, outcome) => 'Жасыл шар';
const fa_k13 = (match, outcome) => 'Қоңыр шар';
const fa_l13 = (match, outcome) => 'Көк шар';
const fa_m13 = (match, outcome) => 'Қызғылт шар';
const fa_n13 = (match, outcome) => 'Қара шар';
const fa_o13 = (match, outcome) => `≥ ${outcome.condition + 5}`;
const fa_p13 = (match, outcome) => '≤ 14';
const fa_q13 = (match, outcome) => '15-тен 17 дейін';
const fa_r13 = (match, outcome) => '18-ден 19 дейін';
const fa_s13 = (match, outcome) => '≥ 20';
const fa_t13 = (match, outcome) => `Аз ${outcome.condition}`;
const fa_u13 = (match, outcome) => 'Ж1-0';
const fa_v13 = (match, outcome) => 'Ж1-15';
const fa_w13 = (match, outcome) => 'Ж1-30';
const fa_x13 = (match, outcome) => 'Ж1-40';
const fa_y13 = (match, outcome) => '0-Ж2';
const fa_z13 = (match, outcome) => '15-Ж2';
const fa_a14 = (match, outcome) => '30-Ж2';
const fa_b14 = (match, outcome) => '40-Ж2';
const fa_c14 = (match, outcome) => '3-6';
const fa_d14 = (match, outcome) => '5-7';
const fa_e14 = (match, outcome) => '6-2';
const fa_f14 = (match, outcome) => '6-3';
const fa_g14 = (match, outcome) => '6-4';
const fa_h14 = (match, outcome) => '6-7';
const fa_i14 = (match, outcome) => '7-5';
const fa_j14 = (match, outcome) => '7-6';
const fa_k14 = (match, outcome) => '7-0';
const fa_l14 = (match, outcome) => '7-1';
const fa_m14 = (match, outcome) => '7-2';
const fa_n14 = (match, outcome) => '7-3';
const fa_o14 = (match, outcome) => '7-4';
const fa_p14 = (match, outcome) => 'Кез келген басқамен Ж1';
const fa_q14 = (match, outcome) => '0-7';
const fa_r14 = (match, outcome) => '1-7';
const fa_s14 = (match, outcome) => '2-7';
const fa_t14 = (match, outcome) => '3-7';
const fa_u14 = (match, outcome) => '4-7';
const fa_v14 = (match, outcome) => 'Кез келген басқамен Ж2';
const fa_w14 = (match, outcome) => '8';
const fa_x14 = (match, outcome) => '9';
const fa_y14 = (match, outcome) => '10';
const fa_z14 = (match, outcome) => '11';
const fa_a15 = (match, outcome) => '≥ 13';
const fa_b15 = (match, outcome) => `${match.homeTeam} (С.П.)`;
const fa_c15 = (match, outcome) => `${match.awayTeam} (С.П.)`;
const fa_d15 = (match, outcome) => 'Равенство';
const fa_e15 = (match, outcome) => 'Екеуі деП1';
const fa_f15 = (match, outcome) => 'Тең ойын';
const fa_g15 = (match, outcome) => 'Екеуі де Ж2';
const fa_h15 = (match, outcome) => 'ПЖ';
const fa_i15 = (match, outcome) => 'Ф1';
const fa_j15 = (match, outcome) => 'Ф2';
const fa_k15 = (match, outcome) => `${outcome.condition + 1} ${outcome.condition + 2} дейін`;
const fa_l15 = (match, outcome) => ` ${outcome.condition + 3} ${outcome.condition + 4} дейін`;
const fa_m15 = (match, outcome) => ` ${outcome.condition + 5} ${outcome.condition + 6} дейін`;
const fa_n15 = (match, outcome) => 'Ж1: 7 және одан көп';
const fa_o15 = (match, outcome) => 'Ж2: 7 және одан көп';
const fa_p15 = (match, outcome) => '6-5';
const fa_q15 = (match, outcome) => '5-6';

let groupConfig = {
    32: {
        0: 'Жарыс',
        1: 'Бірінші сет',
        2: 'Екінші сет',
        3: 'Үшінші сет',
        4: 'Кіші-сет - 10 ұпайға дейін (Бірінші сет)',
        5: 'Кіші-сет - 15 ұпайға дейін (Бірінші сет)',
        6: 'Кіші-сет - 10 ұпайға дейін (Екінші сет)',
        7: 'Кіші-сет - 15 ұпайға дейін (Екінші сет)',
        8: 'Кіші-сет - 10 ұпайға дейін (Үшінші сет)',
        9: 'Кіші-сет - 15 ұпайға дейін (Үшінші сет)'
    },
    35: {
        0: 'Жарыс',
        1: 'Бірінші кезең'
    },
    31: {
        0: 'Жарыс',
        1: 'Бірінші ширек',
        2: 'Екінші ширек',
        3: 'Үшінші ширек',
        4: 'Төртінші ширек',
        5: 'Екі ұпайлы лақтыру',
        6: 'Үш ұпайлы лақтыру',
        7: 'Бірінші жарты',
        8: 'Екінші жарты'
    },
    41: {
        0: 'Жарыс',
        1: 'Бірінші жарты',
        2: 'Екінші жарты',
        3: 'Екі ұпайлы лақтыру',
        4: 'Үш ұпайлы лақтыру'
    },
    18: {
        0: 'Жарыс',
        1: 'Бірінші кезең',
        2: 'Екінші кезең',
        3: 'Үшінші кезең'
    },
    3: {
        0: 'Жарыс',
        1: 'Бірінші сет',
        2: 'Екінші сет',
        3: 'Үшінші сет',
        4: 'Кіші-сет - 10 ұпайға дейін (Бірінші сет)',
        5: 'Кіші-сет - 15 ұпайға дейін (Бірінші сет)',
        6: 'Кіші-сет - 10 ұпайға дейін (Екінші сет)',
        7: 'Кіші-сет - 15 ұпайға дейін (Екінші сет)'
    },
    20: {
        0: 'Жарыс',
        1: 'Бірінші ату шебі',
        2: 'Екінші ату шебі',
        3: 'Үшінші ату шебі',
        4: 'Төртінші ату шебі',
        5: 'Бесінші ату шебі',
        6: 'Алтыншы ату шебі',
        7: 'Жетінші ату шебі',
        8: 'Сегізінші ату шебі'
    },
    42: {
        0: 'Жарыс',
        1: 'Бірінші карта',
        2: 'Екінші карта',
        3: 'Үшінші карта',
        4: 'Төртінші карта',
        5: 'Бесінші карта'
    },
    36: {
        0: 'Жарыс',
        1: 'Бірінші кезең'
    },
    7: {
        0: 'Жарыс',
        1: 'Бірінші тайм',
        2: 'Екінші тайм',
        3: '1-ден 15 минут аралығында',
        4: '16-дан 30 минут аралығында',
        5: '31 минуттан үзіліске дейін',
        6: '46-дан 60 минут аралығында',
        7: '61-ден 75 минут аралығында',
        8: '76 минуттан НУ соңына дейін',
        9: 'Бұрыштық',
        10: 'Бұрыштық (Бірінші тайм)',
        11: 'Сары карточкалар',
        12: 'Сары карточкалар (Бірінші тайм)',
        13: 'Қосымша уақыт',
        14: 'Бірінші қосымша уақыт',
        15: 'Екінші қосымша уақыт',
        16: 'Пенальти сериясы'
    },
    34: {
        0: 'Жарыс',
        1: 'Бірінші тайм',
        2: 'Екінші тайм',
        3: '1-ден 15 минут аралығында',
        4: '16-дан 30 минут аралығында',
        5: '31 минуттан үзіліске дейін',
        6: '46-дан 60 минут аралығында',
        7: '61-ден 75 минут аралығында',
        8: '76 минуттан НУ соңына дейін',
        9: 'Бұрыштық',
        10: 'Сары карточкалар'
    },
    19: {
        0: 'Жарыс',
        1: 'Бірінші кезең',
        2: 'Екінші кезең'
    },
    30: {
        0: 'Жарыс',
        1: 'Бірінші кезең',
        2: 'Екінші кезең',
        3: 'Үшінші кезең',
        4: '1-ден 10 минут аралығында',
        5: '11-ден 20 минут аралығында',
        6: '21-ден 30 минут аралығында',
        7: '31-ден 40 минут аралығында',
        8: '41-ден 50 минут аралығында',
        9: '51-ден 60 минут аралығында'
    },
    9: {
        0: 'Жарыс',
        1: 'Бірінші кезең',
        2: 'Екінші кезең'
    },
    29: {
        0: 'Жарыс',
        1: 'Бірінші кезең',
        2: 'Екінші кезең',
        3: 'Үшінші кезең',
        4: 'Төртінші кезең',
        5: 'Бесінші кезең',
        6: 'Алтыншы кезең',
        7: 'Жетінші кезең',
        8: 'Сегізінші кезең',
        9: 'Тоғызыншы кезең',
        10: 'Оныншы кезең',
        11: 'Он бірінші кезең',
        12: 'Он екінші кезең',
        13: 'Он үшінші кезең',
        14: 'Он төртінші кезең',
        15: 'Он бесінші кезең',
        16: 'Он алтыншы кезең',
        17: 'Семнадцатый период',
        18: 'Он жетінші кезең',
        19: 'Он сегізінші кезең',
        20: 'Жиырмасыншы кезең',
        21: 'Жиырма бірінші кезең',
        22: 'Жиырма екінші кезең',
        23: 'Жиырма үшінші кезең',
        24: 'Жиырма төртінші кезең',
        25: 'Жиырма бесінші кезең',
        26: 'Жиырма алтыншы кезең',
        27: 'Жиырма жетінші кезең',
        28: 'Жиырма сегізінші кезең',
        29: 'Жиырма тоғызыншы кезең',
        30: 'Отызыншы кезең',
        31: 'Отыз бірінші кезең',
        32: 'Отыз екінші кезең',
        33: 'Отыз үшінші кезең',
        34: 'Отыз төртінші кезең',
        35: 'Отыз бесінші кезең',
        36: 'Отыз алтыншы кезең',
        37: 'Отыз жетінші кезең'
    },
    2: {
        0: 'Жарыс',
        1: 'Бірінші сет',
        2: 'Екінші сет',
        3: 'Үшінші сет',
        4: 'Төртінші сет',
        5: 'Бесінші сет',
        6: 'Алтыншы сет',
        7: 'Жетінші сет'
    },
    6: {
        0: 'Матч',
        1: 'Бірінші сет',
        2: 'Екінші сет',
        3: 'Үшінші сет',
        4: 'Төртінші сет',
        5: 'Бесінші сет'
    },
    4: {
        0: 'Жарыс',
        1: 'Бірінші сет',
        2: 'Екінші сет',
        3: 'Үшінші сет',
        4: 'Төртінші сет',
        5: 'Бесінші сет',
        6: 'Алтыншы сет',
        7: 'Кіші-сет - 10 ұпайға дейін (Бірінші сет)',
        8: 'Кіші-сет - 15 ұпайға дейін (Бірінші сет)',
        9: 'Кіші-сет - 10 ұпайға дейін (Екінші сет)',
        10: 'Кіші-сет - 15 ұпайға дейін (Екінші сет)',
        11: 'Кіші-сет - 10 ұпайға дейін (Үшінші сет)',
        12: 'Кіші-сет - 15 ұпайға дейін (Үшінші сет)',
        13: 'Кіші-сет - 10 ұпайға дейін (Төртінші сет)',
        14: 'Кіші-сет - 15 ұпайға дейін (Төртінші сет)'
    },
    8: {
        0: 'Жарыс',
        1: 'Бірінші ширек',
        2: 'Екінші ширек',
        3: 'Үшінші ширек',
        4: 'Төртінші ширек'
    }
};

let slotConfig = {
    32: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        557: sl_e1,
        607: sl_f1,
        122: sl_g1,
        129: sl_h1,
        138: sl_i1,
        182: sl_j1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        558: sl_e1,
        608: sl_f1,
        123: sl_k1,
        130: sl_h1,
        139: sl_i1,
        183: sl_j1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        559: sl_e1,
        609: sl_f1,
        124: sl_k1,
        131: sl_h1,
        140: sl_i1,
        184: sl_j1,
        362: sl_l1,
        17: sl_c1,
        176: sl_m1,
        358: sl_l1,
        13: sl_c1,
        172: sl_m1,
        363: sl_l1,
        18: sl_c1,
        177: sl_m1,
        359: sl_l1,
        14: sl_c1,
        173: sl_m1,
        364: sl_l1,
        19: sl_c1,
        178: sl_m1,
        360: sl_l1,
        15: sl_c1,
        174: sl_m1
    },
    35: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1
    },
    31: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        769: sl_n1,
        138: sl_i1,
        182: sl_j1,
        775: sl_o1,
        765: sl_p1,
        629: sl_q1,
        633: sl_r1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        770: sl_n1,
        139: sl_i1,
        183: sl_j1,
        776: sl_o1,
        766: sl_p1,
        630: sl_q1,
        634: sl_s1,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        771: sl_n1,
        140: sl_i1,
        184: sl_j1,
        777: sl_o1,
        767: sl_p1,
        631: sl_q1,
        635: sl_r1,
        667: sl_b1,
        24: sl_c1,
        198: sl_d1,
        772: sl_n1,
        141: sl_i1,
        185: sl_j1,
        778: sl_o1,
        768: sl_p1,
        632: sl_q1,
        636: sl_r1,
        676: sl_t1,
        248: sl_m1,
        62: sl_c1,
        241: sl_u1,
        233: sl_v1,
        406: sl_w1,
        675: sl_t1,
        246: sl_m1,
        61: sl_c1,
        240: sl_u1,
        232: sl_v1,
        405: sl_w1,
        672: sl_t1,
        58: sl_c1,
        238: sl_d1,
        234: sl_i1,
        236: sl_j1,
        673: sl_t1,
        59: sl_c1,
        239: sl_d1,
        235: sl_i1,
        237: sl_j1
    },
    41: {
        664: sl_x1,
        21: sl_c1,
        195: sl_m1,
        782: sl_y1,
        785: sl_z1,
        780: sl_a2,
        138: sl_u1,
        182: sl_v1,
        639: sl_b2,
        665: sl_x1,
        22: sl_c1,
        196: sl_m1,
        783: sl_y1,
        786: sl_z1,
        781: sl_a2,
        139: sl_u1,
        183: sl_v1,
        640: sl_b2,
        64: sl_c1,
        678: sl_x1,
        250: sl_m1,
        63: sl_c1,
        677: sl_x1,
        249: sl_m1
    },
    18: {
        664: sl_b1,
        195: sl_d1,
        698: sl_c2,
        21: sl_c1,
        734: sl_d2,
        665: sl_b1,
        196: sl_d1,
        699: sl_c2,
        22: sl_c1,
        735: sl_d2,
        666: sl_b1,
        197: sl_d1,
        700: sl_c2,
        23: sl_c1,
        736: sl_d2
    },
    3: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        896: sl_e2,
        138: sl_i1,
        182: sl_j1,
        557: sl_e1,
        83: sl_f2,
        788: sl_g2,
        842: sl_h2,
        845: sl_i2,
        848: sl_j2,
        607: sl_k2,
        791: sl_l2,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        897: sl_e2,
        139: sl_i1,
        183: sl_j1,
        558: sl_e1,
        84: sl_f2,
        789: sl_g2,
        843: sl_h2,
        846: sl_i2,
        849: sl_j2,
        608: sl_k2,
        792: sl_l2,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        898: sl_e2,
        140: sl_i1,
        184: sl_j1,
        559: sl_e1,
        85: sl_f2,
        790: sl_g2,
        844: sl_h2,
        847: sl_i2,
        850: sl_j2,
        609: sl_k2,
        793: sl_l2,
        362: sl_l1,
        17: sl_c1,
        176: sl_m1,
        358: sl_l1,
        13: sl_c1,
        172: sl_m1,
        363: sl_l1,
        18: sl_c1,
        177: sl_m1,
        359: sl_l1,
        14: sl_c1,
        173: sl_m1
    },
    20: {
        664: sl_t1,
        21: sl_c1,
        195: sl_m1,
        138: sl_i1,
        182: sl_j1,
        851: sl_n1,
        665: sl_t1,
        22: sl_c1,
        196: sl_m1,
        139: sl_i1,
        183: sl_j1,
        852: sl_n1,
        666: sl_t1,
        23: sl_c1,
        197: sl_m1,
        140: sl_i1,
        184: sl_j1,
        853: sl_n1,
        667: sl_t1,
        24: sl_c1,
        198: sl_m1,
        141: sl_i1,
        185: sl_j1,
        854: sl_n1,
        199: sl_t1,
        142: sl_c1,
        186: sl_m1,
        25: sl_i1,
        668: sl_j1,
        855: sl_n1,
        200: sl_t1,
        143: sl_c1,
        187: sl_m1,
        26: sl_i1,
        669: sl_j1,
        856: sl_n1,
        201: sl_t1,
        144: sl_c1,
        188: sl_m1,
        27: sl_i1,
        670: sl_j1,
        857: sl_n1,
        202: sl_t1,
        145: sl_c1,
        189: sl_m1,
        28: sl_i1,
        671: sl_j1,
        858: sl_n1
    },
    42: {
        557: sl_m2,
        1865: sl_n2,
        558: sl_m2,
        1866: sl_n2,
        559: sl_m2,
        1867: sl_n2,
        560: sl_m2,
        1868: sl_n2,
        561: sl_m2,
        1869: sl_n2
    },
    36: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1
    },
    7: {
        426: sl_o2,
        526: sl_p2,
        419: sl_q2,
        519: sl_r2,
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_s2,
        756: sl_n1,
        698: sl_t2,
        794: sl_u2,
        860: sl_v2,
        273: sl_w2,
        83: sl_f2,
        727: sl_x2,
        729: sl_y2,
        731: sl_z2,
        648: sl_a3,
        420: sl_q2,
        520: sl_r2,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_s2,
        757: sl_n1,
        699: sl_t2,
        859: sl_u2,
        861: sl_v2,
        274: sl_w2,
        84: sl_f2,
        728: sl_x2,
        649: sl_a3,
        652: sl_b1,
        641: sl_a3,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_b1,
        642: sl_a3,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_b1,
        643: sl_a3,
        7: sl_c1,
        165: sl_d1,
        150: sl_i1,
        156: sl_j1,
        658: sl_b1,
        644: sl_a3,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_b1,
        645: sl_a3,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_b1,
        646: sl_a3,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        680: sl_b1,
        66: sl_c1,
        255: sl_d1,
        438: sl_b3,
        354: sl_i1,
        355: sl_j1,
        681: sl_b1,
        67: sl_c1,
        258: sl_d1,
        356: sl_i1,
        357: sl_j1,
        690: sl_b1,
        81: sl_c1,
        353: sl_d1,
        440: sl_c3,
        441: sl_d3,
        682: sl_b1,
        68: sl_c1,
        259: sl_d1,
        146: sl_i1,
        650: sl_a3,
        740: sl_e3,
        69: sl_c1,
        262: sl_m1,
        683: sl_f3,
        694: sl_y2,
        180: sl_j1,
        70: sl_c1,
        263: sl_m1,
        684: sl_b1,
        72: sl_c1,
        277: sl_m1,
        686: sl_b1,
        181: sl_g3,
        147: sl_h3,
        741: sl_e3,
        276: sl_i3,
        275: sl_j3
    },
    34: {
        419: sl_q2,
        519: sl_r2,
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_s2,
        756: sl_n1,
        698: sl_t2,
        794: sl_k3,
        860: sl_l3,
        83: sl_f2,
        420: sl_q2,
        520: sl_r2,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_s2,
        757: sl_n1,
        699: sl_t2,
        795: sl_k3,
        861: sl_l3,
        84: sl_f2,
        652: sl_b1,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_b1,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_b1,
        7: sl_c1,
        165: sl_d1,
        150: sl_i1,
        156: sl_j1,
        658: sl_b1,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_b1,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_b1,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        255: sl_d1,
        353: sl_d1
    },
    19: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        877: sl_n1,
        138: sl_i1,
        182: sl_j1,
        875: sl_g2,
        873: sl_h2,
        196: sl_d1,
        878: sl_n1,
        876: sl_g2,
        874: sl_h2,
        665: sl_b1,
        22: sl_c1
    },
    30: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        756: sl_n1,
        138: sl_i1,
        182: sl_j1,
        734: sl_s2,
        83: sl_f2,
        698: sl_c2,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        757: sl_n1,
        139: sl_i1,
        183: sl_j1,
        735: sl_s2,
        84: sl_f2,
        699: sl_c2,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        758: sl_n1,
        140: sl_i1,
        184: sl_j1,
        736: sl_s2,
        85: sl_f2,
        700: sl_c2,
        653: sl_b1,
        161: sl_d1,
        3: sl_c1,
        654: sl_b1,
        162: sl_d1,
        4: sl_c1,
        656: sl_b1,
        164: sl_d1,
        6: sl_c1,
        659: sl_b1,
        167: sl_d1,
        8: sl_c1,
        661: sl_b1,
        169: sl_d1,
        10: sl_c1,
        662: sl_b1,
        170: sl_d1,
        11: sl_c1
    },
    9: {
        664: sl_b1,
        195: sl_d1,
        665: sl_b1,
        196: sl_d1
    },
    29: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        466: sl_m3,
        557: sl_n3,
        799: sl_o3,
        83: sl_f2,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        467: sl_m3,
        558: sl_n3,
        800: sl_o3,
        84: sl_f2,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        468: sl_m3,
        559: sl_n3,
        801: sl_o3,
        85: sl_f2,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        469: sl_m3,
        560: sl_n3,
        802: sl_o3,
        86: sl_f2,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        470: sl_m3,
        561: sl_n3,
        803: sl_o3,
        87: sl_f2,
        371: sl_b1,
        26: sl_c1,
        200: sl_d1,
        471: sl_m3,
        562: sl_n3,
        804: sl_o3,
        88: sl_f2,
        372: sl_b1,
        27: sl_c1,
        201: sl_d1,
        472: sl_m3,
        563: sl_n3,
        805: sl_o3,
        89: sl_f2,
        373: sl_b1,
        28: sl_c1,
        202: sl_d1,
        473: sl_m3,
        564: sl_n3,
        806: sl_o3,
        90: sl_f2,
        374: sl_b1,
        29: sl_c1,
        203: sl_d1,
        474: sl_m3,
        565: sl_n3,
        807: sl_o3,
        91: sl_f2,
        375: sl_b1,
        30: sl_c1,
        204: sl_d1,
        475: sl_m3,
        566: sl_n3,
        808: sl_o3,
        92: sl_f2,
        376: sl_b1,
        31: sl_c1,
        205: sl_d1,
        476: sl_m3,
        567: sl_n3,
        809: sl_o3,
        93: sl_f2,
        377: sl_b1,
        32: sl_c1,
        206: sl_d1,
        477: sl_m3,
        568: sl_n3,
        810: sl_o3,
        94: sl_f2,
        378: sl_b1,
        33: sl_c1,
        207: sl_d1,
        478: sl_m3,
        569: sl_n3,
        811: sl_o3,
        95: sl_f2,
        379: sl_b1,
        34: sl_c1,
        208: sl_d1,
        479: sl_m3,
        570: sl_n3,
        812: sl_o3,
        96: sl_f2,
        380: sl_b1,
        35: sl_c1,
        209: sl_d1,
        480: sl_m3,
        571: sl_n3,
        813: sl_o3,
        97: sl_f2,
        381: sl_b1,
        36: sl_c1,
        210: sl_d1,
        481: sl_m3,
        572: sl_n3,
        814: sl_o3,
        98: sl_f2,
        382: sl_b1,
        37: sl_c1,
        211: sl_d1,
        482: sl_m3,
        573: sl_n3,
        815: sl_o3,
        99: sl_f2,
        383: sl_b1,
        38: sl_c1,
        212: sl_d1,
        483: sl_m3,
        574: sl_n3,
        816: sl_o3,
        100: sl_f2,
        384: sl_b1,
        39: sl_c1,
        213: sl_d1,
        484: sl_m3,
        575: sl_n3,
        817: sl_o3,
        101: sl_f2,
        385: sl_b1,
        40: sl_c1,
        214: sl_d1,
        485: sl_m3,
        576: sl_n3,
        818: sl_o3,
        104: sl_f2,
        386: sl_b1,
        41: sl_c1,
        215: sl_d1,
        486: sl_m3,
        577: sl_n3,
        819: sl_o3,
        105: sl_f2,
        387: sl_b1,
        42: sl_c1,
        216: sl_d1,
        487: sl_m3,
        578: sl_n3,
        820: sl_o3,
        106: sl_f2,
        388: sl_b1,
        43: sl_c1,
        217: sl_d1,
        488: sl_m3,
        579: sl_n3,
        821: sl_o3,
        107: sl_f2,
        389: sl_b1,
        44: sl_c1,
        218: sl_d1,
        489: sl_m3,
        580: sl_n3,
        822: sl_o3,
        108: sl_f2,
        390: sl_b1,
        45: sl_c1,
        219: sl_d1,
        490: sl_m3,
        581: sl_n3,
        823: sl_o3,
        109: sl_f2,
        391: sl_b1,
        46: sl_c1,
        220: sl_d1,
        491: sl_m3,
        582: sl_n3,
        824: sl_o3,
        110: sl_f2,
        392: sl_b1,
        47: sl_c1,
        221: sl_d1,
        492: sl_m3,
        583: sl_n3,
        825: sl_o3,
        111: sl_f2,
        393: sl_b1,
        48: sl_c1,
        222: sl_d1,
        493: sl_m3,
        584: sl_n3,
        826: sl_o3,
        112: sl_f2,
        394: sl_b1,
        49: sl_c1,
        223: sl_d1,
        494: sl_m3,
        585: sl_n3,
        827: sl_o3,
        113: sl_f2,
        395: sl_b1,
        50: sl_c1,
        224: sl_d1,
        495: sl_m3,
        586: sl_n3,
        828: sl_o3,
        114: sl_f2,
        396: sl_b1,
        51: sl_c1,
        225: sl_d1,
        496: sl_m3,
        587: sl_n3,
        829: sl_o3,
        115: sl_f2,
        397: sl_b1,
        52: sl_c1,
        226: sl_d1,
        497: sl_m3,
        588: sl_n3,
        830: sl_o3,
        116: sl_f2,
        398: sl_b1,
        53: sl_c1,
        227: sl_d1,
        498: sl_m3,
        589: sl_n3,
        831: sl_o3,
        117: sl_f2,
        399: sl_b1,
        54: sl_c1,
        228: sl_d1,
        499: sl_m3,
        590: sl_n3,
        832: sl_o3,
        118: sl_f2,
        400: sl_b1,
        55: sl_c1,
        229: sl_d1,
        500: sl_m3,
        591: sl_n3,
        833: sl_o3,
        119: sl_f2,
        401: sl_b1,
        56: sl_c1,
        230: sl_d1,
        501: sl_m3,
        592: sl_n3,
        834: sl_o3,
        120: sl_f2,
        402: sl_b1,
        57: sl_c1,
        231: sl_d1,
        502: sl_m3,
        593: sl_n3,
        835: sl_o3,
        121: sl_f2
    },
    2: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        607: sl_f1,
        557: sl_n3,
        863: sl_n1,
        885: sl_n1,
        122: sl_g1,
        129: sl_p3,
        83: sl_q3,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        608: sl_f1,
        558: sl_n3,
        864: sl_n1,
        886: sl_n1,
        123: sl_g1,
        130: sl_p3,
        84: sl_q3,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        609: sl_f1,
        559: sl_n3,
        865: sl_n1,
        887: sl_n1,
        124: sl_g1,
        131: sl_p3,
        85: sl_q3,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        610: sl_f1,
        560: sl_n3,
        866: sl_n1,
        888: sl_n1,
        125: sl_g1,
        132: sl_p3,
        86: sl_q3,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        611: sl_f1,
        561: sl_n3,
        867: sl_n1,
        889: sl_n1,
        126: sl_g1,
        133: sl_p3,
        87: sl_q3,
        371: sl_b1,
        26: sl_c1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        612: sl_f1,
        562: sl_n3,
        868: sl_n1,
        890: sl_n1,
        127: sl_g1,
        134: sl_p3,
        88: sl_q3,
        372: sl_b1,
        27: sl_c1,
        201: sl_d1,
        144: sl_i1,
        188: sl_j1,
        613: sl_f1,
        563: sl_n3,
        869: sl_n1,
        891: sl_n1,
        128: sl_g1,
        135: sl_p3,
        89: sl_q3
    },
    6: {
        1861: sl_r3,
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        333: sl_s3,
        557: sl_t3,
        745: sl_s2,
        896: sl_u3,
        618: sl_v3,
        594: sl_w3,
        759: sl_x3,
        750: sl_y3,
        190: sl_z3,
        83: sl_f2,
        300: sl_a4,
        310: sl_b4,
        545: sl_c4,
        508: sl_d4,
        552: sl_e4,
        708: sl_f4,
        76: sl_g4,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        334: sl_s3,
        558: sl_t3,
        746: sl_s2,
        897: sl_u3,
        619: sl_v3,
        595: sl_w3,
        760: sl_x3,
        751: sl_y3,
        191: sl_z3,
        84: sl_f2,
        301: sl_a4,
        311: sl_b4,
        546: sl_c4,
        509: sl_d4,
        553: sl_e4,
        709: sl_f4,
        77: sl_g4,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        335: sl_s3,
        559: sl_t3,
        747: sl_s2,
        898: sl_u3,
        620: sl_v3,
        596: sl_w3,
        761: sl_x3,
        752: sl_y3,
        192: sl_z3,
        85: sl_f2,
        302: sl_a4,
        312: sl_b4,
        547: sl_c4,
        510: sl_d4,
        554: sl_e4,
        710: sl_f4,
        78: sl_g4,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        336: sl_s3,
        560: sl_t3,
        748: sl_s2,
        899: sl_u3,
        621: sl_v3,
        597: sl_w3,
        762: sl_x3,
        753: sl_y3,
        193: sl_z3,
        86: sl_f2,
        303: sl_a4,
        313: sl_b4,
        548: sl_c4,
        511: sl_d4,
        555: sl_e4,
        711: sl_f4,
        79: sl_g4,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        337: sl_s3,
        561: sl_t3,
        749: sl_s2,
        900: sl_u3,
        622: sl_v3,
        598: sl_w3,
        763: sl_x3,
        754: sl_y3,
        194: sl_z3,
        87: sl_f2,
        304: sl_a4,
        314: sl_b4,
        549: sl_c4,
        512: sl_d4,
        556: sl_e4,
        712: sl_f4,
        80: sl_g4
    },
    4: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        896: sl_u3,
        557: sl_e1,
        836: sl_g2,
        909: sl_h2,
        914: sl_n1,
        920: sl_n1,
        83: sl_f2,
        903: sl_l2,
        607: sl_f1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        897: sl_u3,
        558: sl_e1,
        837: sl_g2,
        910: sl_h2,
        915: sl_n1,
        921: sl_n1,
        84: sl_f2,
        904: sl_l2,
        608: sl_f1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        898: sl_u3,
        559: sl_e1,
        838: sl_g2,
        911: sl_h2,
        916: sl_n1,
        922: sl_n1,
        85: sl_f2,
        905: sl_l2,
        609: sl_f1,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        899: sl_u3,
        560: sl_e1,
        839: sl_g2,
        912: sl_h2,
        917: sl_n1,
        923: sl_n1,
        86: sl_f2,
        906: sl_l2,
        610: sl_f1,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        900: sl_u3,
        561: sl_e1,
        840: sl_g2,
        913: sl_h2,
        918: sl_n1,
        924: sl_n1,
        87: sl_f2,
        907: sl_l2,
        611: sl_f1,
        26: sl_c1,
        200: sl_m1,
        143: sl_i1,
        187: sl_j1,
        371: sl_x1,
        562: sl_q1,
        919: sl_y1,
        925: sl_y1,
        901: sl_h4,
        908: sl_l2,
        88: sl_i4,
        362: sl_l1,
        17: sl_c1,
        176: sl_m1,
        358: sl_l1,
        13: sl_c1,
        172: sl_m1,
        363: sl_l1,
        18: sl_c1,
        177: sl_m1,
        359: sl_l1,
        14: sl_c1,
        173: sl_m1,
        364: sl_l1,
        19: sl_c1,
        178: sl_m1,
        360: sl_l1,
        15: sl_c1,
        174: sl_m1,
        365: sl_l1,
        20: sl_c1,
        179: sl_m1,
        361: sl_l1,
        16: sl_c1,
        175: sl_m1
    },
    8: {
        664: sl_b1,
        195: sl_d1,
        665: sl_b1,
        196: sl_d1,
        666: sl_b1,
        197: sl_d1,
        667: sl_b1,
        198: sl_d1
    }
};

let baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        122: bo_a2,
        123: bo_b2,
        124: bo_c2,
        129: bo_d2,
        130: bo_e2,
        131: bo_f2,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        257: bo_d1,
        307: bo_e1,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_e3,
        256: bo_d1,
        21: bo_f3,
        673: bo_g3,
        182: bo_h3,
        306: bo_e1,
        698: bo_g1,
        731: bo_i3,
        656: bo_j3,
        195: bo_k3,
        74: bo_b1,
        349: bo_c1,
        443: bo_h1,
        608: bo_i1,
        911: bo_l3,
        426: bo_m3,
        535: bo_n3,
        871: bo_o3,
        710: bo_p3,
        742: bo_q3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        1: bo_r3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_s3,
        22: bo_t3,
        23: bo_u3,
        24: bo_v3,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        403: bo_g1,
        138: bo_e4,
        139: bo_f4,
        140: bo_g4,
        141: bo_h4,
        182: bo_i4,
        183: bo_j4,
        184: bo_k4,
        185: bo_l4,
        238: bo_m4,
        682: bo_n4,
        239: bo_o4,
        58: bo_p4,
        59: bo_q4,
        681: bo_r4,
        234: bo_s4,
        235: bo_t4,
        236: bo_u4,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_o3,
        778: bo_a5,
        779: bo_b5,
        780: bo_c5,
        781: bo_d5,
        783: bo_e5,
        773: bo_f5,
        474: bo_g5,
        421: bo_h5,
        530: bo_i5,
        422: bo_j5,
        531: bo_k5,
        444: bo_l5,
        888: bo_m5,
        280: bo_n5,
        317: bo_o5,
        424: bo_p5,
        533: bo_q5,
        423: bo_r5,
        532: bo_s5,
        637: bo_t5,
        788: bo_u5,
        784: bo_v5,
        785: bo_w5,
        786: bo_x5,
        787: bo_y5,
        774: bo_v5,
        775: bo_w5,
        776: bo_x5,
        777: bo_y5,
        281: bo_z5,
        137: bo_a6,
        246: bo_b6,
        248: bo_c6,
        240: bo_d6,
        232: bo_e6,
        241: bo_f6,
        233: bo_g6,
        61: bo_h6,
        62: bo_i6,
        684: bo_j6,
        685: bo_k6,
        443: bo_h1,
        608: bo_i1,
        890: bo_l6,
        242: bo_m6,
        245: bo_n6,
        243: bo_o6,
        60: bo_p6,
        683: bo_q6,
        406: bo_r6,
        405: bo_s6,
        404: bo_t6,
        700: bo_u6,
        408: bo_v6,
        407: bo_w6,
        247: bo_x6,
        244: bo_y6,
        638: bo_z6,
        639: bo_a7,
        640: bo_b7,
        641: bo_c7,
        646: bo_d7,
        642: bo_e7,
        643: bo_f7,
        644: bo_g7,
        645: bo_h7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_i7,
        22: bo_j7,
        403: bo_g1,
        673: bo_k7,
        674: bo_l7,
        195: bo_m7,
        196: bo_n7,
        791: bo_o7,
        792: bo_n7,
        637: bo_p7,
        796: bo_u5,
        794: bo_q7,
        795: bo_r7,
        789: bo_q7,
        790: bo_r7,
        725: bo_s7,
        726: bo_t7,
        793: bo_u7,
        411: bo_v7,
        701: bo_l5,
        251: bo_w7,
        252: bo_x7,
        409: bo_y7,
        430: bo_z7,
        410: bo_a8,
        431: bo_b8,
        281: bo_z5,
        137: bo_a6,
        249: bo_c8,
        250: bo_d8,
        63: bo_e8,
        64: bo_f8,
        686: bo_g8,
        687: bo_h8,
        103: bo_i8,
        256: bo_d1,
        306: bo_e1,
        138: bo_j8,
        139: bo_k8,
        182: bo_l8,
        183: bo_m8,
        443: bo_h1,
        608: bo_i1,
        648: bo_s7,
        649: bo_t7
    },
    18: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_n8,
        196: bo_o8,
        197: bo_p8,
        673: bo_q8,
        674: bo_r8,
        675: bo_s8,
        610: bo_t8,
        443: bo_h1,
        608: bo_i1,
        806: bo_u8,
        893: bo_v8,
        707: bo_w8,
        708: bo_x8,
        709: bo_y8,
        889: bo_u7,
        904: bo_z8,
        253: bo_a9,
        688: bo_b9,
        65: bo_c9,
        751: bo_q3,
        21: bo_d9,
        22: bo_e9,
        23: bo_f9,
        743: bo_g9,
        744: bo_h9,
        745: bo_i9,
        615: bo_j9,
        350: bo_a9
    },
    3: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        746: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        74: bo_k9,
        854: bo_l9,
        855: bo_m9,
        856: bo_n9,
        857: bo_l9,
        858: bo_m9,
        859: bo_n9,
        797: bo_o9,
        798: bo_p9,
        799: bo_q9,
        851: bo_r9,
        852: bo_s9,
        853: bo_t9,
        83: bo_u9,
        84: bo_v9,
        85: bo_w9,
        905: bo_x9,
        906: bo_y9,
        907: bo_z9,
        443: bo_h1,
        608: bo_i1,
        362: bo_a10,
        363: bo_b10,
        17: bo_c10,
        18: bo_d10,
        176: bo_e10,
        177: bo_f10,
        358: bo_g10,
        359: bo_g10,
        13: bo_h10,
        14: bo_i10,
        172: bo_j10,
        173: bo_k10,
        616: bo_l10,
        617: bo_m10,
        618: bo_n10,
        891: bo_l3,
        257: bo_d1,
        307: bo_e1,
        800: bo_o10,
        801: bo_p10,
        802: bo_q10
    },
    20: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_r10,
        196: bo_s10,
        197: bo_t10,
        198: bo_u10,
        199: bo_v10,
        200: bo_w10,
        201: bo_x10,
        202: bo_y10,
        138: bo_z10,
        139: bo_a11,
        140: bo_b11,
        141: bo_c11,
        142: bo_d11,
        143: bo_e11,
        144: bo_f11,
        145: bo_g11,
        182: bo_h11,
        183: bo_i11,
        184: bo_j11,
        185: bo_k11,
        186: bo_l11,
        187: bo_m11,
        188: bo_n11,
        189: bo_o11,
        21: bo_p11,
        22: bo_q11,
        23: bo_r11,
        24: bo_s11,
        25: bo_t11,
        26: bo_u11,
        27: bo_v11,
        28: bo_w11,
        673: bo_x11,
        674: bo_y11,
        675: bo_z11,
        676: bo_a12,
        677: bo_b12,
        678: bo_c12,
        679: bo_d12,
        680: bo_e12,
        860: bo_f12,
        861: bo_g12,
        862: bo_h12,
        863: bo_i12,
        864: bo_j12,
        865: bo_k12,
        866: bo_l12,
        867: bo_m12,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_c1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_n12,
        948: bo_o12,
        949: bo_p12
    },
    40: {
        656: bo_j3,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_q12,
        615: bo_r12,
        413: bo_s12,
        414: bo_t12
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_q12,
        615: bo_u12,
        413: bo_s12,
        414: bo_v12,
        566: bo_w12,
        567: bo_x12,
        568: bo_y12,
        569: bo_z12,
        570: bo_a13,
        698: bo_b13,
        366: bo_c13,
        367: bo_d13,
        368: bo_e13,
        369: bo_f13,
        370: bo_g13,
        940: bo_h13,
        941: bo_i13,
        942: bo_j13,
        943: bo_k13,
        944: bo_l13
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_m13,
        698: bo_g1,
        656: bo_j3,
        74: bo_b1,
        349: bo_c1,
        615: bo_j9,
        256: bo_d1,
        306: bo_e1,
        673: bo_q8,
        21: bo_d9,
        195: bo_n8,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_n13,
        534: bo_o13,
        540: bo_p13,
        343: bo_q13,
        345: bo_r13,
        260: bo_s13,
        261: bo_t13,
        83: bo_u13,
        84: bo_v13,
        803: bo_w13,
        868: bo_x13,
        869: bo_y13,
        870: bo_z13,
        805: bo_a14,
        892: bo_b14,
        346: bo_c14,
        419: bo_d14,
        528: bo_e14,
        420: bo_f14,
        529: bo_g14,
        707: bo_h14,
        708: bo_i14,
        706: bo_j14,
        804: bo_k14,
        474: bo_l14,
        614: bo_m14,
        609: bo_n14,
        416: bo_o14,
        732: bo_p14,
        525: bo_q14,
        850: bo_r14,
        473: bo_s14,
        442: bo_t14,
        729: bo_u14,
        538: bo_v14,
        542: bo_w14,
        730: bo_x14,
        471: bo_y14,
        635: bo_z14,
        714: bo_a15,
        624: bo_b15,
        625: bo_c15,
        715: bo_d15,
        650: bo_e15,
        651: bo_f15,
        652: bo_g15,
        653: bo_h15,
        654: bo_i15,
        655: bo_j15,
        634: bo_k15,
        626: bo_l15,
        733: bo_m15,
        734: bo_n15,
        258: bo_o15,
        259: bo_p15,
        66: bo_q15,
        67: bo_r15,
        81: bo_s15,
        68: bo_t15,
        689: bo_u15,
        690: bo_v15,
        699: bo_w15,
        691: bo_x15,
        723: bo_y15,
        633: bo_z15,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_a16,
        904: bo_b16,
        1: bo_r3,
        136: bo_c16,
        747: bo_q3,
        871: bo_o3,
        255: bo_d16,
        705: bo_e16,
        323: bo_f16,
        324: bo_g16,
        702: bo_h16,
        278: bo_i16,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        21: bo_f3,
        22: bo_k16,
        282: bo_l16,
        911: bo_l3,
        353: bo_m16,
        673: bo_g3,
        674: bo_n16,
        2: bo_o16,
        5: bo_p16,
        7: bo_q16,
        939: bo_r16,
        9: bo_s16,
        12: bo_t16,
        417: bo_u16,
        526: bo_v16,
        325: bo_w16,
        103: bo_f1,
        160: bo_x16,
        163: bo_y16,
        165: bo_z16,
        166: bo_a17,
        168: bo_b17,
        171: bo_c17,
        148: bo_d17,
        149: bo_e17,
        150: bo_f17,
        151: bo_g17,
        152: bo_h17,
        153: bo_i17,
        154: bo_j17,
        155: bo_k17,
        156: bo_l17,
        157: bo_m17,
        158: bo_n17,
        159: bo_o17,
        731: bo_i3,
        765: bo_p17,
        766: bo_q17,
        415: bo_r17,
        524: bo_s17,
        418: bo_t17,
        527: bo_u17,
        743: bo_v17,
        744: bo_w17,
        710: bo_p3,
        321: bo_x17,
        326: bo_y17,
        327: bo_z17,
        724: bo_a18,
        661: bo_b18,
        664: bo_c18,
        666: bo_d18,
        667: bo_e18,
        669: bo_f18,
        672: bo_g18,
        426: bo_m3,
        535: bo_n3,
        537: bo_h18,
        541: bo_i18,
        539: bo_j18,
        138: bo_e3,
        139: bo_k18,
        182: bo_h3,
        183: bo_l18,
        437: bo_m18,
        436: bo_n18,
        694: bo_o18,
        71: bo_p18,
        271: bo_c1,
        268: bo_q18,
        265: bo_r18,
        267: bo_s18,
        270: bo_t18,
        272: bo_u18,
        269: bo_v18,
        266: bo_w18,
        264: bo_x18,
        281: bo_z5,
        137: bo_a6,
        660: bo_y18,
        880: bo_z18,
        879: bo_a19,
        429: bo_b19,
        433: bo_c19,
        443: bo_h1,
        608: bo_i1,
        881: bo_d19,
        273: bo_e19,
        274: bo_f19,
        435: bo_g19,
        704: bo_h19,
        432: bo_i19,
        428: bo_j19,
        434: bo_k19,
        439: bo_l19,
        440: bo_m19,
        441: bo_n19,
        438: bo_o19,
        623: bo_p19,
        180: bo_q19,
        146: bo_r19,
        659: bo_s19,
        749: bo_t19,
        69: bo_u19,
        262: bo_v19,
        692: bo_w19,
        703: bo_x19,
        70: bo_y19,
        263: bo_z19,
        693: bo_a20,
        72: bo_b20,
        277: bo_c20,
        695: bo_d20,
        750: bo_e20,
        181: bo_f20,
        147: bo_g20,
        276: bo_h20,
        275: bo_i20,
        735: bo_j20,
        736: bo_k20,
        737: bo_l20,
        738: bo_m20,
        739: bo_n20,
        740: bo_o20,
        356: bo_p20,
        357: bo_q20,
        354: bo_r20,
        355: bo_s20,
        937: bo_t20,
        657: bo_u20,
        658: bo_v20,
        412: bo_w20
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_n13,
        534: bo_o13,
        540: bo_p13,
        343: bo_q13,
        345: bo_r13,
        260: bo_s13,
        261: bo_t13,
        83: bo_u13,
        84: bo_v13,
        803: bo_w13,
        868: bo_x13,
        869: bo_y13,
        870: bo_z13,
        346: bo_c14,
        419: bo_d14,
        528: bo_e14,
        420: bo_f14,
        529: bo_g14,
        707: bo_h14,
        708: bo_i14,
        706: bo_j14,
        538: bo_v14,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_a16,
        904: bo_b16,
        1: bo_r3,
        136: bo_c16,
        747: bo_q3,
        871: bo_o3,
        255: bo_d16,
        705: bo_e16,
        323: bo_f16,
        324: bo_g16,
        702: bo_h16,
        278: bo_i16,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        21: bo_f3,
        22: bo_k16,
        282: bo_l16,
        911: bo_l3,
        353: bo_m16,
        673: bo_g3,
        674: bo_n16,
        2: bo_o16,
        5: bo_p16,
        7: bo_q16,
        939: bo_r16,
        9: bo_s16,
        12: bo_t16,
        417: bo_u16,
        526: bo_v16,
        325: bo_w16,
        103: bo_f1,
        160: bo_x16,
        163: bo_y16,
        165: bo_z16,
        166: bo_a17,
        168: bo_b17,
        171: bo_c17,
        148: bo_d17,
        149: bo_e17,
        150: bo_f17,
        151: bo_g17,
        152: bo_h17,
        153: bo_i17,
        154: bo_j17,
        155: bo_k17,
        156: bo_l17,
        157: bo_m17,
        158: bo_n17,
        159: bo_o17,
        731: bo_i3,
        765: bo_p17,
        766: bo_q17,
        415: bo_r17,
        524: bo_s17,
        418: bo_t17,
        527: bo_u17,
        743: bo_v17,
        744: bo_w17,
        710: bo_p3,
        321: bo_x17,
        326: bo_y17,
        327: bo_z17,
        724: bo_a18,
        661: bo_b18,
        664: bo_c18,
        666: bo_d18,
        667: bo_e18,
        669: bo_f18,
        672: bo_g18,
        426: bo_m3,
        535: bo_n3,
        537: bo_h18,
        541: bo_i18,
        539: bo_j18,
        138: bo_e3,
        139: bo_k18,
        182: bo_h3,
        183: bo_l18,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_c1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        103: bo_f1,
        615: bo_j9,
        886: bo_p17,
        887: bo_q17,
        911: bo_l3,
        884: bo_x20,
        885: bo_y20,
        882: bo_z20,
        883: bo_a21,
        723: bo_y15,
        673: bo_g3,
        674: bo_n16,
        21: bo_f3,
        22: bo_k16,
        138: bo_e3,
        182: bo_h3,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        21: bo_d9,
        22: bo_e9,
        23: bo_f9,
        279: bo_b21,
        610: bo_t8,
        256: bo_d1,
        306: bo_e1,
        195: bo_c21,
        196: bo_d21,
        197: bo_e21,
        673: bo_q8,
        674: bo_r8,
        675: bo_s8,
        350: bo_a9,
        103: bo_f1,
        415: bo_r17,
        524: bo_s17,
        743: bo_f21,
        744: bo_g21,
        745: bo_h21,
        710: bo_p3,
        403: bo_g1,
        426: bo_m3,
        535: bo_n3,
        706: bo_j14,
        343: bo_q13,
        346: bo_c14,
        83: bo_i21,
        84: bo_j21,
        85: bo_k21,
        344: bo_l21,
        347: bo_m21,
        765: bo_n21,
        766: bo_o21,
        767: bo_p21,
        138: bo_q21,
        139: bo_r21,
        140: bo_s21,
        182: bo_t21,
        183: bo_u21,
        184: bo_v21,
        751: bo_q3,
        911: bo_l3,
        889: bo_o3,
        637: bo_t5,
        615: bo_j9,
        412: bo_w21,
        634: bo_k15,
        626: bo_l15,
        611: bo_x21,
        443: bo_h1,
        608: bo_i1,
        904: bo_y21,
        449: bo_z21,
        446: bo_a22,
        451: bo_b22,
        711: bo_c22,
        712: bo_d22,
        713: bo_e22,
        450: bo_f22,
        447: bo_g22,
        448: bo_h22,
        662: bo_i22,
        663: bo_j22,
        665: bo_k22,
        668: bo_l22,
        670: bo_m22,
        671: bo_n22,
        3: bo_o22,
        4: bo_p22,
        6: bo_q22,
        8: bo_r22,
        10: bo_s22,
        11: bo_t22,
        161: bo_u22,
        162: bo_v22,
        164: bo_w22,
        167: bo_x22,
        169: bo_y22,
        170: bo_z22,
        707: bo_a23,
        708: bo_b23,
        709: bo_c23,
        946: bo_d23,
        947: bo_e23
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_f23,
        470: bo_g23,
        467: bo_h23,
        469: bo_i23,
        464: bo_j23,
        466: bo_k23,
        465: bo_l23,
        463: bo_m23,
        289: bo_n23,
        288: bo_o23,
        292: bo_p23,
        461: bo_q23,
        283: bo_r23,
        295: bo_s23,
        293: bo_t23,
        284: bo_u23,
        285: bo_v23,
        316: bo_w23,
        286: bo_x23,
        287: bo_y23,
        290: bo_z23,
        291: bo_a24,
        462: bo_b24,
        294: bo_c24
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_c1,
        950: bo_d24,
        955: bo_e24,
        951: bo_f24,
        952: bo_g24,
        953: bo_h24,
        954: bo_i24
    },
    33: {
        348: bo_j24,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        673: bo_g3,
        674: bo_n16,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_k24,
        395: bo_l24,
        396: bo_m24,
        397: bo_n24,
        398: bo_o24,
        399: bo_p24,
        400: bo_q24,
        401: bo_r24,
        402: bo_s24,
        100: bo_t24,
        101: bo_u24,
        104: bo_v24,
        105: bo_w24,
        106: bo_x24,
        107: bo_y24,
        108: bo_z24,
        109: bo_a25,
        110: bo_b25,
        111: bo_c25,
        112: bo_d25,
        113: bo_e25,
        114: bo_f25,
        115: bo_g25,
        116: bo_h25,
        117: bo_i25,
        118: bo_j25,
        119: bo_k25,
        120: bo_l25,
        121: bo_m25,
        808: bo_n25,
        809: bo_o25,
        810: bo_p25,
        811: bo_q25,
        812: bo_r25,
        813: bo_s25,
        814: bo_t25,
        815: bo_u25,
        816: bo_v25,
        817: bo_w25,
        818: bo_x25,
        819: bo_y25,
        820: bo_z25,
        821: bo_a26,
        822: bo_b26,
        823: bo_c26,
        824: bo_d26,
        825: bo_e26,
        826: bo_f26,
        827: bo_g26,
        828: bo_h26,
        829: bo_i26,
        830: bo_j26,
        831: bo_k26,
        832: bo_l26,
        833: bo_m26,
        834: bo_n26,
        835: bo_o26,
        836: bo_p26,
        837: bo_q26,
        838: bo_r26,
        839: bo_s26,
        840: bo_t26,
        841: bo_u26,
        842: bo_v26,
        843: bo_w26,
        844: bo_x26,
        366: bo_y26,
        367: bo_z26,
        368: bo_a27,
        369: bo_b27,
        370: bo_c27,
        371: bo_d27,
        372: bo_e27,
        373: bo_f27,
        374: bo_g27,
        375: bo_h27,
        376: bo_i27,
        377: bo_j27,
        378: bo_k27,
        379: bo_l27,
        380: bo_m27,
        381: bo_n27,
        382: bo_o27,
        383: bo_p27,
        384: bo_q27,
        385: bo_r27,
        386: bo_s27,
        387: bo_t27,
        388: bo_u27,
        389: bo_v27,
        390: bo_w27,
        391: bo_x27,
        392: bo_y27,
        393: bo_z27,
        481: bo_a28,
        482: bo_b28,
        483: bo_c28,
        484: bo_d28,
        485: bo_e28,
        486: bo_f28,
        487: bo_g28,
        488: bo_h28,
        489: bo_i28,
        490: bo_j28,
        491: bo_k28,
        492: bo_l28,
        493: bo_m28,
        494: bo_n28,
        495: bo_o28,
        496: bo_p28,
        497: bo_q28,
        498: bo_r28,
        499: bo_s28,
        500: bo_t28,
        501: bo_u28,
        502: bo_v28,
        503: bo_w28,
        504: bo_x28,
        505: bo_y28,
        506: bo_z28,
        507: bo_a29,
        508: bo_b29,
        509: bo_c29,
        510: bo_d29,
        511: bo_e29,
        566: bo_f29,
        567: bo_g29,
        568: bo_h29,
        569: bo_i29,
        570: bo_j29,
        571: bo_k29,
        572: bo_l29,
        573: bo_m29,
        574: bo_n29,
        575: bo_o29,
        576: bo_p29,
        577: bo_q29,
        578: bo_r29,
        579: bo_s29,
        580: bo_t29,
        581: bo_u29,
        582: bo_v29,
        583: bo_w29,
        584: bo_x29,
        585: bo_y29,
        586: bo_z29,
        587: bo_a30,
        588: bo_b30,
        589: bo_c30,
        590: bo_d30,
        591: bo_e30,
        592: bo_f30,
        593: bo_g30,
        594: bo_h30,
        595: bo_i30,
        596: bo_j30,
        597: bo_k30,
        598: bo_l30,
        599: bo_m30,
        600: bo_n30,
        601: bo_o30,
        602: bo_p30,
        83: bo_q30,
        84: bo_r30,
        85: bo_s30,
        86: bo_t30,
        87: bo_u30,
        88: bo_v30,
        89: bo_w30,
        90: bo_x30,
        91: bo_y30,
        92: bo_z30,
        93: bo_a31,
        94: bo_b31,
        95: bo_c31,
        96: bo_d31,
        97: bo_e31,
        98: bo_f31,
        99: bo_g31,
        74: bo_b1,
        349: bo_c1,
        254: bo_h31,
        403: bo_g1,
        21: bo_i31,
        22: bo_j31,
        23: bo_k31,
        24: bo_l31,
        25: bo_m31,
        26: bo_n31,
        27: bo_o31,
        28: bo_p31,
        29: bo_q31,
        30: bo_r31,
        31: bo_s31,
        32: bo_t31,
        33: bo_u31,
        34: bo_v31,
        35: bo_w31,
        36: bo_x31,
        37: bo_y31,
        38: bo_z31,
        39: bo_a32,
        40: bo_b32,
        41: bo_c32,
        42: bo_d32,
        43: bo_e32,
        44: bo_f32,
        45: bo_g32,
        46: bo_h32,
        47: bo_i32,
        48: bo_j32,
        49: bo_k32,
        50: bo_l32,
        51: bo_m32,
        52: bo_n32,
        53: bo_o32,
        54: bo_p32,
        55: bo_q32,
        56: bo_r32,
        57: bo_s32,
        195: bo_t32,
        196: bo_u32,
        197: bo_v32,
        198: bo_w32,
        199: bo_x32,
        200: bo_y32,
        201: bo_z32,
        202: bo_a33,
        203: bo_b33,
        204: bo_c33,
        205: bo_d33,
        206: bo_e33,
        207: bo_f33,
        208: bo_g33,
        209: bo_h33,
        210: bo_i33,
        211: bo_j33,
        212: bo_k33,
        213: bo_l33,
        214: bo_m33,
        215: bo_n33,
        216: bo_o33,
        217: bo_p33,
        218: bo_q33,
        219: bo_r33,
        220: bo_s33,
        221: bo_t33,
        222: bo_u33,
        223: bo_v33,
        224: bo_w33,
        225: bo_x33,
        226: bo_y33,
        227: bo_z33,
        228: bo_a34,
        229: bo_b34,
        230: bo_c34,
        231: bo_d34,
        475: bo_e34,
        476: bo_f34,
        477: bo_g34,
        478: bo_h34,
        479: bo_i34,
        480: bo_j34,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_c1,
        21: bo_i31,
        22: bo_j31,
        23: bo_k31,
        24: bo_l31,
        25: bo_m31,
        26: bo_n31,
        27: bo_o31,
        195: bo_t32,
        196: bo_u32,
        197: bo_v32,
        198: bo_w32,
        199: bo_x32,
        200: bo_y32,
        201: bo_z32,
        352: bo_k34,
        102: bo_f1,
        403: bo_g1,
        138: bo_l34,
        139: bo_m34,
        140: bo_n34,
        141: bo_o34,
        142: bo_p34,
        143: bo_q34,
        144: bo_r34,
        182: bo_s34,
        183: bo_t34,
        184: bo_u34,
        185: bo_v34,
        186: bo_w34,
        187: bo_x34,
        188: bo_y34,
        566: bo_f29,
        567: bo_g29,
        568: bo_h29,
        569: bo_i29,
        570: bo_j29,
        571: bo_k29,
        572: bo_l29,
        366: bo_y26,
        367: bo_z26,
        368: bo_a27,
        369: bo_b27,
        370: bo_c27,
        371: bo_d27,
        372: bo_e27,
        122: bo_z34,
        123: bo_a35,
        124: bo_b35,
        125: bo_c35,
        126: bo_d35,
        127: bo_e35,
        128: bo_f35,
        129: bo_g35,
        130: bo_h35,
        131: bo_i35,
        132: bo_j35,
        133: bo_k35,
        134: bo_l35,
        135: bo_m35,
        872: bo_n35,
        873: bo_o35,
        874: bo_p35,
        875: bo_q35,
        876: bo_r35,
        877: bo_s35,
        878: bo_t35,
        616: bo_u35,
        617: bo_v35,
        618: bo_w35,
        619: bo_x35,
        620: bo_y35,
        621: bo_z35,
        622: bo_a36,
        894: bo_n35,
        895: bo_o35,
        896: bo_p35,
        897: bo_q35,
        898: bo_r35,
        899: bo_s35,
        900: bo_t35,
        443: bo_h1,
        608: bo_i1,
        83: bo_b36,
        84: bo_c36,
        85: bo_d36,
        86: bo_e36,
        87: bo_f36,
        88: bo_g36,
        89: bo_h36,
        257: bo_d1,
        307: bo_e1,
        752: bo_i36,
        753: bo_i36
    },
    6: {
        553: bo_j36,
        339: bo_k36,
        547: bo_l36,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_m36,
        142: bo_n36,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_o36,
        186: bo_p36,
        83: bo_u9,
        84: bo_v9,
        85: bo_w9,
        86: bo_q36,
        87: bo_r36,
        807: bo_s36,
        636: bo_t36,
        334: bo_u36,
        335: bo_v36,
        336: bo_w36,
        337: bo_x36,
        906: bo_y9,
        907: bo_z9,
        908: bo_y36,
        909: bo_z36,
        300: bo_a37,
        301: bo_b37,
        302: bo_c37,
        303: bo_d37,
        304: bo_e37,
        310: bo_f37,
        311: bo_g37,
        312: bo_h37,
        313: bo_i37,
        314: bo_j37,
        554: bo_k37,
        555: bo_l37,
        556: bo_m37,
        557: bo_n37,
        558: bo_o37,
        517: bo_p37,
        518: bo_q37,
        519: bo_r37,
        520: bo_s37,
        521: bo_t37,
        561: bo_u37,
        562: bo_v37,
        563: bo_w37,
        564: bo_x37,
        565: bo_y37,
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_z37,
        25: bo_a38,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_b38,
        199: bo_c38,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        903: bo_d38,
        445: bo_e38,
        754: bo_f38,
        755: bo_g38,
        756: bo_h38,
        757: bo_i38,
        758: bo_j38,
        452: bo_k38,
        453: bo_l38,
        454: bo_m38,
        566: bo_n38,
        567: bo_o38,
        568: bo_p38,
        569: bo_q38,
        570: bo_r38,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_s38,
        370: bo_t38,
        522: bo_u38,
        627: bo_v38,
        628: bo_w38,
        629: bo_x38,
        630: bo_y38,
        631: bo_z38,
        632: bo_a39,
        190: bo_b39,
        191: bo_c39,
        192: bo_d39,
        193: bo_e39,
        194: bo_f39,
        759: bo_g39,
        760: bo_h39,
        761: bo_i39,
        762: bo_j39,
        763: bo_k39,
        768: bo_l39,
        769: bo_m39,
        770: bo_n39,
        771: bo_o39,
        772: bo_p39,
        603: bo_q39,
        604: bo_r39,
        605: bo_s39,
        606: bo_t39,
        607: bo_u39,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_v39,
        341: bo_w39,
        427: bo_x39,
        536: bo_y39,
        905: bo_x9,
        320: bo_z39,
        514: bo_a40,
        516: bo_b40,
        305: bo_c40,
        315: bo_d40,
        523: bo_e40,
        299: bo_f40,
        309: bo_g40,
        697: bo_h40,
        298: bo_i40,
        308: bo_j40,
        515: bo_k40,
        549: bo_l40,
        548: bo_m40,
        443: bo_h1,
        608: bo_i1,
        550: bo_n40,
        551: bo_n40,
        455: bo_o40,
        456: bo_o40,
        457: bo_p40,
        458: bo_p40,
        459: bo_q40,
        460: bo_q40,
        512: bo_r40,
        513: bo_s40,
        901: bo_d38,
        902: bo_d38,
        340: bo_t40,
        328: bo_u40,
        329: bo_v40,
        342: bo_w40,
        330: bo_x40,
        331: bo_y40,
        722: bo_z40,
        560: bo_a41,
        543: bo_b41,
        544: bo_c41,
        545: bo_d41,
        546: bo_e41,
        332: bo_f41,
        559: bo_g41,
        296: bo_h41,
        297: bo_i41,
        717: bo_j41,
        718: bo_k41,
        719: bo_l41,
        720: bo_m41,
        721: bo_n41,
        552: bo_o41,
        76: bo_p41,
        77: bo_q41,
        78: bo_r41,
        79: bo_s41,
        80: bo_t41,
        647: bo_u41,
        741: bo_v41,
        82: bo_w41,
        338: bo_x41
    },
    17: {
        348: bo_j24,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_z37,
        25: bo_a38,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_b38,
        199: bo_c38,
        352: bo_p1,
        764: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_m36,
        142: bo_n36,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_o36,
        186: bo_p36,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_s38,
        370: bo_t38,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        569: bo_y41,
        570: bo_z41,
        74: bo_k9,
        923: bo_l9,
        924: bo_m9,
        925: bo_n9,
        926: bo_a42,
        927: bo_b42,
        929: bo_l9,
        930: bo_m9,
        931: bo_n9,
        932: bo_a42,
        933: bo_b42,
        845: bo_o9,
        846: bo_p9,
        847: bo_q9,
        848: bo_c42,
        849: bo_d42,
        918: bo_r9,
        919: bo_s9,
        920: bo_t9,
        921: bo_e42,
        922: bo_f42,
        83: bo_u9,
        84: bo_v9,
        85: bo_w9,
        86: bo_q36,
        87: bo_r36,
        905: bo_x9,
        906: bo_y9,
        907: bo_z9,
        908: bo_y36,
        909: bo_z36,
        807: bo_s36,
        319: bo_g42,
        320: bo_z39,
        912: bo_o10,
        913: bo_p10,
        914: bo_q10,
        915: bo_h42,
        916: bo_i42,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_j42,
        363: bo_k42,
        364: bo_l42,
        365: bo_m42,
        17: bo_n42,
        18: bo_o42,
        19: bo_p42,
        20: bo_q42,
        176: bo_r42,
        177: bo_s42,
        178: bo_t42,
        179: bo_u42,
        358: bo_v42,
        359: bo_w42,
        360: bo_x42,
        361: bo_y42,
        13: bo_z42,
        14: bo_a43,
        15: bo_b43,
        16: bo_c43,
        172: bo_d43,
        173: bo_e43,
        174: bo_f43,
        175: bo_g43,
        281: bo_z5,
        137: bo_a6,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        619: bo_h43,
        620: bo_i43,
        891: bo_l3,
        26: bo_j43,
        200: bo_k43,
        143: bo_l43,
        187: bo_m43,
        371: bo_n43,
        571: bo_o43,
        928: bo_p43,
        934: bo_p43,
        88: bo_q43,
        910: bo_r43,
        917: bo_s43,
        936: bo_t43
    },
    8: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_u43,
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_q3,
        612: bo_v43,
        613: bo_w43,
        443: bo_h1,
        608: bo_i1
    }
};

let outcomeConfig = {
    7: {
        426: (match, outcome) => `${match.homeTeam} дәл ${outcome.condition} гол айырмашылығымен жеңеді`,
        535: (match, outcome) => `${match.awayTeam} дәл ${outcome.condition} гол айырмашылығымен жеңеді`
    },
    6: {
        455: (match, outcome) => `${outcome.condition} геймде 15x15 болады ма?`,
        456: (match, outcome) => `${outcome.condition} геймде 15x15 болады ма?`,
        457: (match, outcome) => `${outcome.condition} геймде 30x30 болады ма?`,
        458: (match, outcome) => `${outcome.condition} геймде 30x30 болады ма?`,
        459: (match, outcome) => `${outcome.condition} геймде 40x40 болады ма?`,
        460: (match, outcome) => `${outcome.condition} геймде 40x40 болады ма?`
    }
};

let baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_f1,
            2: fa_g1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_p1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_q1,
            2: fa_r1,
            3: fa_s1,
            4: fa_t1,
            5: fa_u1,
            6: fa_v1,
            7: fa_w1,
            8: fa_x1,
            9: fa_y1,
            10: fa_z1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_p1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_n1,
            2: fa_o1
        },
        123: {
            1: fa_n1,
            2: fa_o1
        },
        124: {
            1: fa_n1,
            2: fa_o1
        },
        129: {
            1: fa_n1,
            2: fa_o1
        },
        130: {
            1: fa_n1,
            2: fa_o1
        },
        131: {
            1: fa_n1,
            2: fa_o1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        362: {
            1: fa_j1,
            2: fa_k1
        },
        363: {
            1: fa_j1,
            2: fa_k1
        },
        364: {
            1: fa_j1,
            2: fa_k1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_j1,
            2: fa_k1
        },
        359: {
            1: fa_j1,
            2: fa_k1
        },
        360: {
            1: fa_j1,
            2: fa_k1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        731: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        871: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_v2
        },
        742: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_a3,
            8: fa_b3,
            9: fa_s1,
            10: fa_t1,
            11: fa_c3,
            12: fa_d3,
            13: fa_u1,
            14: fa_v1,
            15: fa_e3,
            16: fa_w1,
            17: fa_f3,
            18: fa_g3,
            19: fa_h3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_j3,
            25: fa_k3,
            26: fa_l3,
            27: fa_m3,
            28: fa_n3,
            29: fa_o3,
            30: fa_p3,
            31: fa_q3,
            32: fa_r3,
            33: fa_s3,
            34: fa_t3,
            35: fa_u3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        676: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        726: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        727: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        728: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        782: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        778: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        779: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        780: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        781: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        783: {
            1: fa_s1,
            2: fa_k3,
            3: fa_b4,
            4: fa_c4,
            5: fa_d4,
            6: fa_e4,
            7: fa_f4,
            8: fa_k1
        },
        773: {
            1: fa_s1,
            2: fa_k3,
            3: fa_b4,
            4: fa_c4,
            5: fa_d4,
            6: fa_e4,
            7: fa_f4,
            8: fa_j1
        },
        474: {
            1: fa_g4,
            2: fa_h4
        },
        421: {
            1: fa_n1,
            2: fa_o1
        },
        530: {
            1: fa_n1,
            2: fa_o1
        },
        422: {
            1: fa_n1,
            2: fa_o1
        },
        531: {
            1: fa_n1,
            2: fa_o1
        },
        444: {
            1: fa_i4,
            2: fa_j4
        },
        888: {
            1: fa_k4,
            2: fa_l4,
            3: fa_m4,
            4: fa_n4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_n1,
            2: fa_o1
        },
        533: {
            1: fa_n1,
            2: fa_o1
        },
        423: {
            1: fa_n1,
            2: fa_o1
        },
        532: {
            1: fa_n1,
            2: fa_o1
        },
        637: {
            1: fa_n1,
            2: fa_o1
        },
        788: {
            1: fa_o4,
            2: fa_p4,
            3: fa_q4,
            4: fa_r4,
            5: fa_s4,
            6: fa_t4,
            7: fa_u4,
            8: fa_v4,
            9: fa_w4,
            10: fa_x4,
            11: fa_y4,
            12: fa_z4,
            13: fa_a5,
            14: fa_b5
        },
        784: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        785: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        786: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        787: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        774: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        775: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        776: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        777: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        685: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        890: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5,
            4: fa_n5
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        406: {
            1: fa_a2,
            2: fa_b2
        },
        405: {
            1: fa_a2,
            2: fa_b2
        },
        404: {
            1: fa_a2,
            2: fa_b2
        },
        700: {
            1: fa_o5,
            2: fa_p5,
            3: fa_q5
        },
        408: {
            1: fa_a2,
            2: fa_b2
        },
        407: {
            1: fa_a2,
            2: fa_b2
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_a2,
            2: fa_b2
        },
        639: {
            1: fa_a2,
            2: fa_b2
        },
        640: {
            1: fa_a2,
            2: fa_b2
        },
        641: {
            1: fa_a2,
            2: fa_b2
        },
        646: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        642: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        643: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        644: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        645: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        792: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        637: {
            1: fa_n1,
            2: fa_o1
        },
        796: {
            1: fa_o4,
            2: fa_p4,
            3: fa_q4,
            4: fa_r4,
            5: fa_s4,
            6: fa_t4,
            7: fa_u5,
            8: fa_v4,
            9: fa_w4,
            10: fa_x4,
            11: fa_y4,
            12: fa_z4,
            13: fa_a5,
            14: fa_v5
        },
        794: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_w5,
            5: fa_f5
        },
        795: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_w5,
            5: fa_f5
        },
        789: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_x5,
            5: fa_j5
        },
        790: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_x5,
            5: fa_j5
        },
        725: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        726: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        793: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        411: {
            1: fa_a2,
            2: fa_b2
        },
        701: {
            1: fa_y5,
            2: fa_z5,
            3: fa_a6
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_n1,
            2: fa_o1
        },
        430: {
            1: fa_n1,
            2: fa_o1
        },
        410: {
            1: fa_n1,
            2: fa_o1
        },
        431: {
            1: fa_n1,
            2: fa_o1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_p1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        687: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        103: {
            1: fa_b6,
            2: fa_c6
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        648: {
            1: fa_a2,
            2: fa_b2
        },
        649: {
            1: fa_a2,
            2: fa_b2
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        610: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        806: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6,
            4: fa_g6,
            5: fa_h6,
            6: fa_f5
        },
        893: {
            1: fa_i6,
            2: fa_j6,
            3: fa_k6,
            4: fa_l6,
            5: fa_m6,
            6: fa_n6
        },
        707: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        708: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        709: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        889: {
            1: fa_r6,
            2: fa_p2,
            3: fa_q2,
            4: fa_r2,
            5: fa_s6,
            6: fa_t6,
            7: fa_u6,
            8: fa_v6
        },
        904: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6,
            5: fa_a7,
            6: fa_b7,
            7: fa_c7,
            8: fa_d7,
            9: fa_e7
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_a3,
            8: fa_b3,
            9: fa_s1,
            10: fa_t1,
            11: fa_c3,
            12: fa_d3,
            13: fa_u1,
            14: fa_v1,
            15: fa_e3,
            16: fa_w1,
            17: fa_f3,
            18: fa_g3,
            19: fa_h3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_j3,
            25: fa_k3,
            26: fa_l3,
            27: fa_m3,
            28: fa_n3,
            29: fa_o3,
            30: fa_p3,
            31: fa_q3,
            32: fa_r3,
            33: fa_s3,
            34: fa_t3,
            35: fa_u3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        745: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_u1,
            2: fa_v1,
            3: fa_s1,
            4: fa_q1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        855: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        856: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        857: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_p7
        },
        858: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_p7
        },
        859: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_p7
        },
        797: {
            1: fa_q7,
            2: fa_r7,
            3: fa_s7,
            4: fa_k1
        },
        798: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        799: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        851: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        852: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        853: {
            1: fa_q7,
            2: fa_r7,
            3: fa_s7,
            4: fa_j1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        905: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        906: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        907: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        443: {
            1: fa_y7,
            2: fa_z7
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        362: {
            1: fa_j1,
            2: fa_k1
        },
        363: {
            1: fa_j1,
            2: fa_k1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_p1
        },
        358: {
            1: fa_j1,
            2: fa_k1
        },
        359: {
            1: fa_j1,
            2: fa_k1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        891: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        801: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        802: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        676: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        677: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        678: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        679: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        680: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        860: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        861: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        862: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        863: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        864: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        865: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        866: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        867: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        945: {
            1: fa_n1,
            2: fa_o1
        },
        948: {
            1: fa_i8,
            2: fa_j8,
            3: fa_k8,
            4: fa_l8,
            5: fa_m8
        },
        949: {
            1: fa_n8,
            2: fa_o8,
            3: fa_p8,
            4: fa_q8,
            5: fa_r8,
            6: fa_s8,
            7: fa_t8,
            8: fa_u8,
            9: fa_v8,
            10: fa_w8,
            11: fa_x8,
            12: fa_y8,
            13: fa_j8,
            14: fa_k8,
            15: fa_z8,
            16: fa_a9,
            17: fa_b9,
            18: fa_c9,
            19: fa_d9,
            20: fa_e9,
            21: fa_f9,
            22: fa_g9,
            23: fa_h9,
            24: fa_i9,
            25: fa_j9,
            26: fa_k9,
            27: fa_m8
        }
    },
    40: {
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    37: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    38: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        413: {
            1: fa_a2,
            2: fa_b2
        },
        414: {
            1: fa_a2,
            2: fa_b2
        }
    },
    42: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_l9,
            2: fa_o1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        413: {
            1: fa_a2,
            2: fa_b2
        },
        414: {
            1: fa_a2,
            2: fa_b2
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        698: {
            1: fa_j1,
            2: fa_m9,
            3: fa_k1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        940: {
            1: fa_j1,
            2: fa_k1
        },
        941: {
            1: fa_j1,
            2: fa_k1
        },
        942: {
            1: fa_j1,
            2: fa_k1
        },
        943: {
            1: fa_j1,
            2: fa_k1
        },
        944: {
            1: fa_j1,
            2: fa_k1
        }
    },
    26: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    25: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    16: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    36: {
        610: {
            1: fa_j1,
            2: fa_k1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    7: {
        425: {
            1: fa_n1,
            2: fa_o1
        },
        534: {
            1: fa_n1,
            2: fa_o1
        },
        540: {
            1: fa_d1,
            2: fa_p1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_n1,
            2: fa_o1
        },
        261: {
            1: fa_n1,
            2: fa_o1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        803: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        868: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        869: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        870: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        805: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        892: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_n1,
            2: fa_o1
        },
        528: {
            1: fa_n1,
            2: fa_o1
        },
        420: {
            1: fa_n1,
            2: fa_o1
        },
        529: {
            1: fa_n1,
            2: fa_o1
        },
        707: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        708: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        706: {
            1: fa_q9,
            2: fa_r9,
            3: fa_s9
        },
        804: {
            1: fa_t9,
            2: fa_u9,
            3: fa_v9,
            4: fa_w9
        },
        474: {
            1: fa_g4,
            2: fa_h4
        },
        614: {
            1: fa_a2,
            2: fa_b2
        },
        609: {
            1: fa_n1,
            2: fa_o1
        },
        416: {
            1: fa_n1,
            2: fa_o1
        },
        732: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        525: {
            1: fa_n1,
            2: fa_o1
        },
        850: {
            1: fa_x9,
            2: fa_y9,
            3: fa_z9,
            4: fa_a10
        },
        473: {
            1: fa_b10,
            2: fa_c10
        },
        442: {
            1: fa_b10,
            2: fa_c10
        },
        729: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_n1,
            2: fa_o1
        },
        730: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        471: {
            1: fa_b10,
            2: fa_c10
        },
        635: {
            1: fa_n1,
            2: fa_o1
        },
        714: {
            1: fa_d10,
            2: fa_d2,
            3: fa_e10
        },
        624: {
            1: fa_a2,
            2: fa_b2
        },
        625: {
            1: fa_a2,
            2: fa_b2
        },
        715: {
            1: fa_f10,
            2: fa_g10,
            3: fa_h10
        },
        650: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        651: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        652: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        653: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        654: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        655: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        634: {
            1: fa_n1,
            2: fa_o1
        },
        626: {
            1: fa_n1,
            2: fa_o1
        },
        733: {
            1: fa_f10,
            2: fa_g10,
            3: fa_i10
        },
        734: {
            1: fa_f10,
            2: fa_g10,
            3: fa_i10
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        690: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        699: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        691: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        723: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        633: {
            1: fa_n1,
            2: fa_o1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_w6,
            2: fa_j10,
            3: fa_y6,
            4: fa_k10,
            5: fa_l10,
            6: fa_m10,
            7: fa_c7,
            8: fa_n10,
            9: fa_e7
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_o10,
            8: fa_a3,
            9: fa_b3,
            10: fa_s1,
            11: fa_t1,
            12: fa_c3,
            13: fa_d3,
            14: fa_p10,
            15: fa_u1,
            16: fa_v1,
            17: fa_e3,
            18: fa_w1,
            19: fa_f3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_l3,
            25: fa_m3,
            26: fa_n3,
            27: fa_q3,
            28: fa_r3,
            29: fa_q10,
            30: fa_r10,
            31: fa_u3
        },
        871: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        255: {
            1: fa_d1,
            2: fa_p1
        },
        705: {
            1: fa_s10,
            2: fa_t10,
            3: fa_u10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_v10,
            2: fa_d2,
            3: fa_e10
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_w10,
            2: fa_x10
        },
        526: {
            1: fa_w10,
            2: fa_x10
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_p1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        765: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        766: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        415: {
            1: fa_n1,
            2: fa_o1
        },
        524: {
            1: fa_n1,
            2: fa_o1
        },
        418: {
            1: fa_n1,
            2: fa_o1
        },
        527: {
            1: fa_n1,
            2: fa_o1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_y10
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_n1,
            2: fa_o1
        },
        327: {
            1: fa_n1,
            2: fa_o1
        },
        724: {
            1: fa_z10,
            2: fa_a11,
            3: fa_b11
        },
        661: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        664: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        666: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        667: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        669: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        672: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        537: {
            1: fa_n1,
            2: fa_o1
        },
        541: {
            1: fa_n1,
            2: fa_o1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_n1,
            2: fa_o1
        },
        436: {
            1: fa_n1,
            2: fa_o1
        },
        694: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_c11,
            2: fa_d11
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        880: {
            1: fa_e11,
            2: fa_f11,
            3: fa_g11,
            4: fa_h11
        },
        879: {
            1: fa_i11,
            2: fa_j11,
            3: fa_k11,
            4: fa_l11
        },
        429: {
            1: fa_n1,
            2: fa_o1
        },
        433: {
            1: fa_n1,
            2: fa_o1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        881: {
            1: fa_m11,
            2: fa_n11,
            3: fa_o11,
            4: fa_p11,
            5: fa_q11,
            6: fa_r11
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_n1,
            2: fa_o1
        },
        704: {
            1: fa_s11,
            2: fa_t11,
            3: fa_u11
        },
        432: {
            1: fa_n1,
            2: fa_o1
        },
        428: {
            1: fa_n1,
            2: fa_o1
        },
        434: {
            1: fa_n1,
            2: fa_o1
        },
        439: {
            1: fa_n1,
            2: fa_o1
        },
        440: {
            1: fa_n1,
            2: fa_o1
        },
        441: {
            1: fa_n1,
            2: fa_o1
        },
        438: {
            1: fa_n1,
            2: fa_o1
        },
        623: {
            1: fa_a2,
            2: fa_b2
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        749: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        703: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_v11,
            2: fa_e1
        },
        695: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        750: {
            1: fa_a3,
            2: fa_u1,
            3: fa_x1,
            4: fa_v1,
            5: fa_y1,
            6: fa_z1,
            7: fa_m3,
            8: fa_n3,
            9: fa_o3,
            10: fa_t3,
            11: fa_w11,
            12: fa_x11,
            13: fa_x2,
            14: fa_q1,
            15: fa_r1,
            16: fa_s1,
            17: fa_t1,
            18: fa_w1,
            19: fa_c3,
            20: fa_f3,
            21: fa_j3,
            22: fa_k3,
            23: fa_y11,
            24: fa_z11
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        736: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        737: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        738: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        739: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        740: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12,
            5: fa_e12,
            6: fa_f12,
            7: fa_g12,
            8: fa_h12,
            9: fa_i12,
            10: fa_j12
        },
        657: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        658: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        412: {
            1: fa_n1,
            2: fa_o1
        }
    },
    14: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    34: {
        425: {
            1: fa_n1,
            2: fa_o1
        },
        534: {
            1: fa_n1,
            2: fa_o1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_n1,
            2: fa_o1
        },
        261: {
            1: fa_n1,
            2: fa_o1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        803: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        868: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        869: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        870: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_n1,
            2: fa_o1
        },
        528: {
            1: fa_n1,
            2: fa_o1
        },
        420: {
            1: fa_n1,
            2: fa_o1
        },
        529: {
            1: fa_n1,
            2: fa_o1
        },
        707: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        708: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        706: {
            1: fa_q9,
            2: fa_r9,
            3: fa_s9
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_w6,
            2: fa_j10,
            3: fa_y6,
            4: fa_k10,
            5: fa_l10,
            6: fa_m10,
            7: fa_c7,
            8: fa_n10,
            9: fa_e7
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_o10,
            8: fa_a3,
            9: fa_b3,
            10: fa_s1,
            11: fa_t1,
            12: fa_c3,
            13: fa_d3,
            14: fa_p10,
            15: fa_u1,
            16: fa_v1,
            17: fa_e3,
            18: fa_w1,
            19: fa_f3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_l3,
            25: fa_m3,
            26: fa_n3,
            27: fa_q3,
            28: fa_r3,
            29: fa_q10,
            30: fa_r10,
            31: fa_u3
        },
        871: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_s10,
            2: fa_t10,
            3: fa_u10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_c11,
            2: fa_d11
        },
        702: {
            1: fa_v10,
            2: fa_d2,
            3: fa_e10
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_w10,
            2: fa_x10
        },
        526: {
            1: fa_w10,
            2: fa_x10
        },
        325: {
            1: fa_c11,
            2: fa_d11
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        765: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        766: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        415: {
            1: fa_n1,
            2: fa_o1
        },
        524: {
            1: fa_n1,
            2: fa_o1
        },
        418: {
            1: fa_n1,
            2: fa_o1
        },
        527: {
            1: fa_n1,
            2: fa_o1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_v2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_n1,
            2: fa_o1
        },
        327: {
            1: fa_n1,
            2: fa_o1
        },
        724: {
            1: fa_z10,
            2: fa_a11,
            3: fa_b11
        },
        661: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        664: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        666: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        667: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        669: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        672: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        537: {
            1: fa_n1,
            2: fa_o1
        },
        541: {
            1: fa_n1,
            2: fa_o1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        886: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        887: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        884: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_f5
        },
        885: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_f5
        },
        882: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_e2
        },
        883: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_e2
        },
        723: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        279: {
            1: fa_c11,
            2: fa_d11
        },
        610: {
            1: fa_j1,
            2: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        350: {
            1: fa_c11,
            2: fa_d11
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        415: {
            1: fa_n1,
            2: fa_o1
        },
        524: {
            1: fa_n1,
            2: fa_o1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        745: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_v2
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        706: {
            1: fa_q9,
            2: fa_r9,
            3: fa_s9
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        766: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        767: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_a3,
            8: fa_b3,
            9: fa_s1,
            10: fa_t1,
            11: fa_c3,
            12: fa_d3,
            13: fa_u1,
            14: fa_v1,
            15: fa_e3,
            16: fa_w1,
            17: fa_f3,
            18: fa_g3,
            19: fa_h3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_j3,
            25: fa_k3,
            26: fa_l3,
            27: fa_m3,
            28: fa_n3,
            29: fa_o3,
            30: fa_p3,
            31: fa_q3,
            32: fa_r3,
            33: fa_s3,
            34: fa_t3,
            35: fa_u3
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        889: {
            1: fa_r6,
            2: fa_p2,
            3: fa_q2,
            4: fa_r2,
            5: fa_s6,
            6: fa_t6,
            7: fa_u6,
            8: fa_v6
        },
        637: {
            1: fa_n1,
            2: fa_o1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        412: {
            1: fa_n1,
            2: fa_o1
        },
        634: {
            1: fa_n1,
            2: fa_o1
        },
        626: {
            1: fa_n1,
            2: fa_o1
        },
        611: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        904: {
            1: fa_w6,
            2: fa_j10,
            3: fa_y6,
            4: fa_k10,
            5: fa_l10,
            6: fa_m10,
            7: fa_c7,
            8: fa_n10,
            9: fa_e7
        },
        449: {
            1: fa_n1,
            2: fa_o1
        },
        446: {
            1: fa_n1,
            2: fa_o1
        },
        451: {
            1: fa_n1,
            2: fa_o1
        },
        711: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12
        },
        712: {
            1: fa_o12,
            2: fa_p12,
            3: fa_q12
        },
        713: {
            1: fa_r12,
            2: fa_s12,
            3: fa_t12
        },
        450: {
            1: fa_n1,
            2: fa_o1
        },
        447: {
            1: fa_n1,
            2: fa_o1
        },
        448: {
            1: fa_n1,
            2: fa_o1
        },
        662: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        663: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        665: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        668: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        670: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        671: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        708: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        709: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        946: {
            1: fa_n1,
            2: fa_o1
        },
        947: {
            1: fa_n1,
            2: fa_o1
        }
    },
    23: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    13: {
        468: {
            1: fa_u12,
            2: fa_v12
        },
        470: {
            1: fa_u12,
            2: fa_v12
        },
        467: {
            1: fa_u12,
            2: fa_v12
        },
        469: {
            1: fa_u12,
            2: fa_v12
        },
        464: {
            1: fa_w12,
            2: fa_x12
        },
        466: {
            1: fa_y12,
            2: fa_z12
        },
        465: {
            1: fa_y12,
            2: fa_z12
        },
        463: {
            1: fa_y12,
            2: fa_z12
        },
        289: {
            1: fa_c11,
            2: fa_d11
        },
        288: {
            1: fa_c11,
            2: fa_d11
        },
        292: {
            1: fa_c11,
            2: fa_d11
        },
        461: {
            1: fa_y12,
            2: fa_z12
        },
        283: {
            1: fa_c11,
            2: fa_d11
        },
        295: {
            1: fa_c11,
            2: fa_d11
        },
        293: {
            1: fa_c11,
            2: fa_d11
        },
        284: {
            1: fa_c11,
            2: fa_d11
        },
        285: {
            1: fa_c11,
            2: fa_d11
        },
        316: {
            1: fa_c11,
            2: fa_d11
        },
        286: {
            1: fa_c11,
            2: fa_d11
        },
        287: {
            1: fa_c11,
            2: fa_d11
        },
        290: {
            1: fa_c11,
            2: fa_d11
        },
        291: {
            1: fa_c11,
            2: fa_d11
        },
        462: {
            1: fa_y12,
            2: fa_z12
        },
        294: {
            1: fa_c11,
            2: fa_d11
        }
    },
    39: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_a13,
            2: fa_b13
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        950: {
            1: fa_n8,
            2: fa_o8,
            3: fa_p8,
            4: fa_c13,
            5: fa_r8,
            6: fa_d13,
            7: fa_e13,
            8: fa_z8,
            9: fa_a9,
            10: fa_b9,
            11: fa_c9,
            12: fa_d9,
            13: fa_f13
        },
        955: {
            1: fa_n1,
            2: fa_o1
        },
        951: {
            1: fa_g13,
            2: fa_h13
        },
        952: {
            1: fa_g13,
            2: fa_h13
        },
        953: {
            1: fa_g13,
            2: fa_h13
        },
        954: {
            1: fa_g13,
            2: fa_h13
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    24: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    21: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    29: {
        394: {
            1: fa_j1,
            2: fa_k1
        },
        395: {
            1: fa_j1,
            2: fa_k1
        },
        396: {
            1: fa_j1,
            2: fa_k1
        },
        397: {
            1: fa_j1,
            2: fa_k1
        },
        398: {
            1: fa_j1,
            2: fa_k1
        },
        399: {
            1: fa_j1,
            2: fa_k1
        },
        400: {
            1: fa_j1,
            2: fa_k1
        },
        401: {
            1: fa_j1,
            2: fa_k1
        },
        402: {
            1: fa_j1,
            2: fa_k1
        },
        100: {
            1: fa_h1,
            2: fa_i1
        },
        101: {
            1: fa_h1,
            2: fa_i1
        },
        104: {
            1: fa_h1,
            2: fa_i1
        },
        105: {
            1: fa_h1,
            2: fa_i1
        },
        106: {
            1: fa_h1,
            2: fa_i1
        },
        107: {
            1: fa_h1,
            2: fa_i1
        },
        108: {
            1: fa_h1,
            2: fa_i1
        },
        109: {
            1: fa_h1,
            2: fa_i1
        },
        110: {
            1: fa_h1,
            2: fa_i1
        },
        111: {
            1: fa_h1,
            2: fa_i1
        },
        112: {
            1: fa_h1,
            2: fa_i1
        },
        113: {
            1: fa_h1,
            2: fa_i1
        },
        114: {
            1: fa_h1,
            2: fa_i1
        },
        115: {
            1: fa_h1,
            2: fa_i1
        },
        116: {
            1: fa_h1,
            2: fa_i1
        },
        117: {
            1: fa_h1,
            2: fa_i1
        },
        118: {
            1: fa_h1,
            2: fa_i1
        },
        119: {
            1: fa_h1,
            2: fa_i1
        },
        120: {
            1: fa_h1,
            2: fa_i1
        },
        121: {
            1: fa_h1,
            2: fa_i1
        },
        808: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        809: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        810: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        811: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        812: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        813: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        814: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        815: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        816: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        817: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        818: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        819: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        820: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        821: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        822: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        823: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        824: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        825: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        826: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        827: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        828: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        829: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        830: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        831: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        832: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        833: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        834: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        835: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        836: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        837: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        838: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        839: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        840: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        841: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        842: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        843: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        844: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        371: {
            1: fa_j1,
            2: fa_k1
        },
        372: {
            1: fa_j1,
            2: fa_k1
        },
        373: {
            1: fa_j1,
            2: fa_k1
        },
        374: {
            1: fa_j1,
            2: fa_k1
        },
        375: {
            1: fa_j1,
            2: fa_k1
        },
        376: {
            1: fa_j1,
            2: fa_k1
        },
        377: {
            1: fa_j1,
            2: fa_k1
        },
        378: {
            1: fa_j1,
            2: fa_k1
        },
        379: {
            1: fa_j1,
            2: fa_k1
        },
        380: {
            1: fa_j1,
            2: fa_k1
        },
        381: {
            1: fa_j1,
            2: fa_k1
        },
        382: {
            1: fa_j1,
            2: fa_k1
        },
        383: {
            1: fa_j1,
            2: fa_k1
        },
        384: {
            1: fa_j1,
            2: fa_k1
        },
        385: {
            1: fa_j1,
            2: fa_k1
        },
        386: {
            1: fa_j1,
            2: fa_k1
        },
        387: {
            1: fa_j1,
            2: fa_k1
        },
        388: {
            1: fa_j1,
            2: fa_k1
        },
        389: {
            1: fa_j1,
            2: fa_k1
        },
        390: {
            1: fa_j1,
            2: fa_k1
        },
        391: {
            1: fa_j1,
            2: fa_k1
        },
        392: {
            1: fa_j1,
            2: fa_k1
        },
        393: {
            1: fa_j1,
            2: fa_k1
        },
        481: {
            1: fa_a2,
            2: fa_b2
        },
        482: {
            1: fa_a2,
            2: fa_b2
        },
        483: {
            1: fa_a2,
            2: fa_b2
        },
        484: {
            1: fa_a2,
            2: fa_b2
        },
        485: {
            1: fa_a2,
            2: fa_b2
        },
        486: {
            1: fa_a2,
            2: fa_b2
        },
        487: {
            1: fa_a2,
            2: fa_b2
        },
        488: {
            1: fa_a2,
            2: fa_b2
        },
        489: {
            1: fa_a2,
            2: fa_b2
        },
        490: {
            1: fa_a2,
            2: fa_b2
        },
        491: {
            1: fa_a2,
            2: fa_b2
        },
        492: {
            1: fa_a2,
            2: fa_b2
        },
        493: {
            1: fa_a2,
            2: fa_b2
        },
        494: {
            1: fa_a2,
            2: fa_b2
        },
        495: {
            1: fa_a2,
            2: fa_b2
        },
        496: {
            1: fa_a2,
            2: fa_b2
        },
        497: {
            1: fa_a2,
            2: fa_b2
        },
        498: {
            1: fa_a2,
            2: fa_b2
        },
        499: {
            1: fa_a2,
            2: fa_b2
        },
        500: {
            1: fa_a2,
            2: fa_b2
        },
        501: {
            1: fa_a2,
            2: fa_b2
        },
        502: {
            1: fa_a2,
            2: fa_b2
        },
        503: {
            1: fa_a2,
            2: fa_b2
        },
        504: {
            1: fa_a2,
            2: fa_b2
        },
        505: {
            1: fa_a2,
            2: fa_b2
        },
        506: {
            1: fa_a2,
            2: fa_b2
        },
        507: {
            1: fa_a2,
            2: fa_b2
        },
        508: {
            1: fa_a2,
            2: fa_b2
        },
        509: {
            1: fa_a2,
            2: fa_b2
        },
        510: {
            1: fa_a2,
            2: fa_b2
        },
        511: {
            1: fa_a2,
            2: fa_b2
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        571: {
            1: fa_a2,
            2: fa_b2
        },
        572: {
            1: fa_a2,
            2: fa_b2
        },
        573: {
            1: fa_a2,
            2: fa_b2
        },
        574: {
            1: fa_a2,
            2: fa_b2
        },
        575: {
            1: fa_a2,
            2: fa_b2
        },
        576: {
            1: fa_a2,
            2: fa_b2
        },
        577: {
            1: fa_a2,
            2: fa_b2
        },
        578: {
            1: fa_a2,
            2: fa_b2
        },
        579: {
            1: fa_a2,
            2: fa_b2
        },
        580: {
            1: fa_a2,
            2: fa_b2
        },
        581: {
            1: fa_a2,
            2: fa_b2
        },
        582: {
            1: fa_a2,
            2: fa_b2
        },
        583: {
            1: fa_a2,
            2: fa_b2
        },
        584: {
            1: fa_a2,
            2: fa_b2
        },
        585: {
            1: fa_a2,
            2: fa_b2
        },
        586: {
            1: fa_a2,
            2: fa_b2
        },
        587: {
            1: fa_a2,
            2: fa_b2
        },
        588: {
            1: fa_a2,
            2: fa_b2
        },
        589: {
            1: fa_a2,
            2: fa_b2
        },
        590: {
            1: fa_a2,
            2: fa_b2
        },
        591: {
            1: fa_a2,
            2: fa_b2
        },
        592: {
            1: fa_a2,
            2: fa_b2
        },
        593: {
            1: fa_a2,
            2: fa_b2
        },
        594: {
            1: fa_a2,
            2: fa_b2
        },
        595: {
            1: fa_a2,
            2: fa_b2
        },
        596: {
            1: fa_a2,
            2: fa_b2
        },
        597: {
            1: fa_a2,
            2: fa_b2
        },
        598: {
            1: fa_a2,
            2: fa_b2
        },
        599: {
            1: fa_a2,
            2: fa_b2
        },
        600: {
            1: fa_a2,
            2: fa_b2
        },
        601: {
            1: fa_a2,
            2: fa_b2
        },
        602: {
            1: fa_a2,
            2: fa_b2
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        88: {
            1: fa_h1,
            2: fa_i1
        },
        89: {
            1: fa_h1,
            2: fa_i1
        },
        90: {
            1: fa_h1,
            2: fa_i1
        },
        91: {
            1: fa_h1,
            2: fa_i1
        },
        92: {
            1: fa_h1,
            2: fa_i1
        },
        93: {
            1: fa_h1,
            2: fa_i1
        },
        94: {
            1: fa_h1,
            2: fa_i1
        },
        95: {
            1: fa_h1,
            2: fa_i1
        },
        96: {
            1: fa_h1,
            2: fa_i1
        },
        97: {
            1: fa_h1,
            2: fa_i1
        },
        98: {
            1: fa_h1,
            2: fa_i1
        },
        99: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_c11,
            2: fa_d11
        },
        254: {
            1: fa_c11,
            2: fa_d11
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_a2,
            2: fa_b2
        },
        476: {
            1: fa_a2,
            2: fa_b2
        },
        477: {
            1: fa_a2,
            2: fa_b2
        },
        478: {
            1: fa_a2,
            2: fa_b2
        },
        479: {
            1: fa_a2,
            2: fa_b2
        },
        480: {
            1: fa_a2,
            2: fa_b2
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    15: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_c11,
            2: fa_d11
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        571: {
            1: fa_a2,
            2: fa_b2
        },
        572: {
            1: fa_a2,
            2: fa_b2
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        371: {
            1: fa_j1,
            2: fa_k1
        },
        372: {
            1: fa_j1,
            2: fa_k1
        },
        122: {
            1: fa_n1,
            2: fa_o1
        },
        123: {
            1: fa_n1,
            2: fa_o1
        },
        124: {
            1: fa_n1,
            2: fa_o1
        },
        125: {
            1: fa_n1,
            2: fa_o1
        },
        126: {
            1: fa_n1,
            2: fa_o1
        },
        127: {
            1: fa_n1,
            2: fa_o1
        },
        128: {
            1: fa_n1,
            2: fa_o1
        },
        129: {
            1: fa_n1,
            2: fa_o1
        },
        130: {
            1: fa_n1,
            2: fa_o1
        },
        131: {
            1: fa_n1,
            2: fa_o1
        },
        132: {
            1: fa_n1,
            2: fa_o1
        },
        133: {
            1: fa_n1,
            2: fa_o1
        },
        134: {
            1: fa_n1,
            2: fa_o1
        },
        135: {
            1: fa_n1,
            2: fa_o1
        },
        872: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        873: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        874: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        875: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        876: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        877: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        878: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        619: {
            1: fa_a2,
            2: fa_b2
        },
        620: {
            1: fa_a2,
            2: fa_b2
        },
        621: {
            1: fa_a2,
            2: fa_b2
        },
        622: {
            1: fa_a2,
            2: fa_b2
        },
        894: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        895: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        896: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        897: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        898: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        899: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        900: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        88: {
            1: fa_h1,
            2: fa_i1
        },
        89: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_t13,
            2: fa_e1
        },
        307: {
            1: fa_t13,
            2: fa_e1
        },
        752: {
            1: fa_x1,
            2: fa_y1,
            3: fa_z1,
            4: fa_w1,
            5: fa_t1,
            6: fa_r1
        },
        753: {
            1: fa_l3,
            2: fa_m3,
            3: fa_n3,
            4: fa_o3,
            5: fa_j3,
            6: fa_f3,
            7: fa_c3,
            8: fa_y2
        }
    },
    6: {
        553: {
            1: fa_n1,
            2: fa_o1
        },
        339: {
            1: fa_d1,
            2: fa_p1
        },
        547: {
            1: fa_b10,
            2: fa_c10
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        807: {
            1: fa_w6,
            2: fa_y6,
            3: fa_c7,
            4: fa_e7
        },
        636: {
            1: fa_n1,
            2: fa_o1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        907: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        908: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        909: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_n1,
            2: fa_o1
        },
        555: {
            1: fa_n1,
            2: fa_o1
        },
        556: {
            1: fa_n1,
            2: fa_o1
        },
        557: {
            1: fa_n1,
            2: fa_o1
        },
        558: {
            1: fa_n1,
            2: fa_o1
        },
        517: {
            1: fa_n1,
            2: fa_o1
        },
        518: {
            1: fa_n1,
            2: fa_o1
        },
        519: {
            1: fa_n1,
            2: fa_o1
        },
        520: {
            1: fa_n1,
            2: fa_o1
        },
        521: {
            1: fa_n1,
            2: fa_o1
        },
        561: {
            1: fa_n1,
            2: fa_o1
        },
        562: {
            1: fa_n1,
            2: fa_o1
        },
        563: {
            1: fa_n1,
            2: fa_o1
        },
        564: {
            1: fa_n1,
            2: fa_o1
        },
        565: {
            1: fa_n1,
            2: fa_o1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_q1,
            2: fa_r1,
            3: fa_s1,
            4: fa_t1,
            5: fa_u1,
            6: fa_v1,
            7: fa_w1,
            8: fa_x1,
            9: fa_y1,
            10: fa_z1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        903: {
            1: fa_u13,
            2: fa_v13,
            3: fa_w13,
            4: fa_x13,
            5: fa_y13,
            6: fa_z13,
            7: fa_a14,
            8: fa_b14
        },
        445: {
            1: fa_a2,
            2: fa_b2
        },
        754: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        755: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        756: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        757: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        758: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        452: {
            1: fa_b10,
            2: fa_c10
        },
        453: {
            1: fa_b10,
            2: fa_c10
        },
        454: {
            1: fa_b10,
            2: fa_c10
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        522: {
            1: fa_a2,
            2: fa_b2
        },
        627: {
            1: fa_n1,
            2: fa_o1
        },
        628: {
            1: fa_n1,
            2: fa_o1
        },
        629: {
            1: fa_n1,
            2: fa_o1
        },
        630: {
            1: fa_n1,
            2: fa_o1
        },
        631: {
            1: fa_n1,
            2: fa_o1
        },
        632: {
            1: fa_n1,
            2: fa_o1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        760: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        761: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        762: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        763: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        768: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        769: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        770: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        771: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        772: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        603: {
            1: fa_a2,
            2: fa_b2
        },
        604: {
            1: fa_a2,
            2: fa_b2
        },
        605: {
            1: fa_a2,
            2: fa_b2
        },
        606: {
            1: fa_a2,
            2: fa_b2
        },
        607: {
            1: fa_a2,
            2: fa_b2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_n1,
            2: fa_o1
        },
        536: {
            1: fa_n1,
            2: fa_o1
        },
        905: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_a2,
            2: fa_b2
        },
        516: {
            1: fa_a2,
            2: fa_b2
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_n1,
            2: fa_o1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_a2,
            2: fa_b2
        },
        549: {
            1: fa_n1,
            2: fa_o1
        },
        548: {
            1: fa_n1,
            2: fa_o1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        550: {
            1: fa_b15,
            2: fa_b2
        },
        551: {
            1: fa_a2,
            2: fa_c15
        },
        455: {
            1: fa_b10,
            2: fa_c10
        },
        456: {
            1: fa_b10,
            2: fa_c10
        },
        457: {
            1: fa_b10,
            2: fa_c10
        },
        458: {
            1: fa_b10,
            2: fa_c10
        },
        459: {
            1: fa_b10,
            2: fa_c10
        },
        460: {
            1: fa_b10,
            2: fa_c10
        },
        512: {
            1: fa_b15,
            2: fa_b2
        },
        513: {
            1: fa_a2,
            2: fa_c15
        },
        901: {
            1: fa_u13,
            2: fa_v13,
            3: fa_w13,
            4: fa_x13,
            5: fa_y13,
            6: fa_z13,
            7: fa_a14,
            8: fa_b14
        },
        902: {
            1: fa_u13,
            2: fa_v13,
            3: fa_w13,
            4: fa_x13,
            5: fa_y13,
            6: fa_z13,
            7: fa_a14,
            8: fa_b14
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_w12,
            2: fa_d15,
            3: fa_x12
        },
        560: {
            1: fa_n1,
            2: fa_o1
        },
        543: {
            1: fa_n1,
            2: fa_o1
        },
        544: {
            1: fa_n1,
            2: fa_o1
        },
        545: {
            1: fa_n1,
            2: fa_o1
        },
        546: {
            1: fa_n1,
            2: fa_o1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_n1,
            2: fa_o1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        718: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        719: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        720: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        721: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_a2,
            2: fa_b2
        },
        741: {
            1: fa_e15,
            2: fa_f15,
            3: fa_g15
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_p1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_r1,
            2: fa_t1,
            3: fa_w1,
            4: fa_x1,
            5: fa_y1,
            6: fa_z1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        924: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        925: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        926: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        927: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        929: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        930: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        931: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        932: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        933: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        845: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        846: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        847: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        848: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        849: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        918: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        919: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        920: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        921: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        922: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        905: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        906: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        907: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        908: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        909: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        807: {
            1: fa_w6,
            2: fa_y6,
            3: fa_c7,
            4: fa_e7
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        913: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        914: {
            1: fa_h15,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        915: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        916: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_j1,
            2: fa_k1
        },
        363: {
            1: fa_j1,
            2: fa_k1
        },
        364: {
            1: fa_j1,
            2: fa_k1
        },
        365: {
            1: fa_j1,
            2: fa_k1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_j1,
            2: fa_k1
        },
        359: {
            1: fa_j1,
            2: fa_k1
        },
        360: {
            1: fa_j1,
            2: fa_k1
        },
        361: {
            1: fa_j1,
            2: fa_k1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        619: {
            1: fa_a2,
            2: fa_b2
        },
        620: {
            1: fa_a2,
            2: fa_b2
        },
        891: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2
        },
        26: {
            1: fa_i15,
            2: fa_j15
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_j1,
            2: fa_k1
        },
        571: {
            1: fa_a2,
            2: fa_b2
        },
        928: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        934: {
            1: fa_v3,
            2: fa_k15,
            3: fa_l15,
            4: fa_m15,
            5: fa_l7
        },
        88: {
            1: fa_h1,
            2: fa_i1
        },
        910: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        917: {
            1: fa_a8,
            2: fa_b8,
            3: fa_n15,
            4: fa_d8,
            5: fa_e8,
            6: fa_o15
        },
        936: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s6
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        676: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    27: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    28: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        935: {
            1: fa_q10,
            2: fa_r10,
            3: fa_e14,
            4: fa_f14,
            5: fa_g14,
            6: fa_p15,
            7: fa_o10,
            8: fa_p10,
            9: fa_h3,
            10: fa_c14,
            11: fa_t7,
            12: fa_q15
        },
        612: {
            1: fa_n1,
            2: fa_o1
        },
        613: {
            1: fa_n1,
            2: fa_o1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    }
};

let periodConfig = {
    2: {
        208: 'Матч аяқталды',
        207: 'Жетінші партия',
        206: 'Алтыншы партия',
        205: 'Бесінші партия',
        200: 'Матч әлі басталған жоқ',
        203: 'Үшінші партия',
        202: 'Екінші партия',
        201: 'Бірінші партия',
        204: 'Төртінші партия'
    },
    3: {
        304: 'Матч аяқталды',
        303: 'Үшінші сет',
        302: 'Екінші сет',
        301: 'Бірінші сет',
        300: 'Матч әлі басталған жоқ'
    },
    4: {
        406: 'Матч аяқталды',
        403: 'Үшінші сет',
        402: 'Екінші сет',
        401: 'Бірінші сет',
        400: 'Матч әлі басталған жоқ',
        407: 'Алтын сет',
        405: 'Бесінші сет',
        404: 'Төртінші сет'
    },
    5: {
        510: 'Оныншы раунд',
        509: 'Тоғызыншы раунд',
        508: 'Сегізінші раунд',
        507: 'Жетінші раунд',
        506: 'Алтыншы раунд',
        505: 'Бесінші раунд',
        513: 'Матч аяқталды',
        503: 'Үшінші раунд',
        500: 'Матч әлі басталған жоқ',
        501: 'Бірінші раунд',
        502: 'Екінші тур',
        511: 'Он бірінші раунд',
        512: 'Он екінші раунд',
        504: 'Төртінші раунд'
    },
    6: {
        600: 'Матч әлі басталған жоқ',
        601: 'Бірінші сет',
        602: 'Екінші сет',
        603: 'Үшінші сет',
        604: 'Төртінші сет',
        605: 'Бесінші сет',
        606: 'Матч аяқталды'
    },
    7: {
        701: 'Бірінші тайм',
        700: 'Матч әлі басталған жоқ',
        703: 'Екінші тайм',
        704: 'Негізгі уақыт аяқталды',
        705: 'Бірінші қосымша уақыт',
        702: 'Үзіліс',
        707: 'Екінші қосымша уақыт',
        708: 'Екінші қосымша уақыт аяқталады',
        709: 'Пенальти',
        710: 'Матч аяқталды',
        706: 'Бірінші қосымша уақыт аяқталады'
    },
    8: {
        808: 'Кідірту',
        807: 'Төртінші ширек',
        806: 'Кідірту',
        805: 'Үшінші ширек',
        804: 'Үзіліс',
        809: 'Овертайм',
        802: 'Кідірту',
        801: 'Бірінші ширек',
        800: 'Матч әлі басталған жоқ',
        810: 'Матч аяқталды',
        803: 'Екінші ширек'
    },
    9: {
        903: 'Екінші тайм',
        902: 'Үзіліс',
        901: 'Бірінші тайм',
        900: 'Матч әлі басталған жоқ',
        904: 'Матч аяқталды'
    },
    12: {
        1203: 'Екінші тайм',
        1202: 'Үзіліс',
        1201: 'Бірінші тайм',
        1200: 'Матч әлі басталған жоқ',
        1204: 'Матч аяқталды'
    },
    18: {
        1808: 'Овертайм аяқталады',
        1807: 'Овертайм',
        1806: 'Негізгі уақыт аяқталды',
        1805: 'Үшінші кезең',
        1804: 'Екінші үзіліс',
        1809: 'Пенальти',
        1802: 'Бірінші үзіліс',
        1801: 'Бірінші кезең',
        1800: 'Матч әлі басталған жоқ',
        1810: 'Матч аяқталды',
        1803: 'Екінші кезең'
    },
    19: {
        1904: 'Негізгі уақыт аяқталды',
        1903: 'Екінші тайм',
        1902: 'Үзіліс',
        1901: 'Бірінші тайм',
        1900: 'Матч әлі басталған жоқ',
        1905: 'Матч аяқталды'
    },
    20: {
        2016: 'Сегізінші атыс желісі',
        2017: 'Матч аяқталды',
        2000: 'Матч әлі басталған жоқ',
        2001: 'Бірінші тур',
        2002: 'Бірінші атыс сызығы',
        2003: 'Екінші тур',
        2004: 'Екінші атыс желісі',
        2005: 'Үшінші тур',
        2006: 'Үшінші атыс желісі',
        2007: 'Төртінші тур',
        2008: 'Төртінші атыс желісі',
        2009: 'Бесінші тур',
        2010: 'Бесінші атыс желісі',
        2011: 'Алтыншы тур',
        2012: 'Алтыншы атыс желісі',
        2013: 'Жетінші тур',
        2014: 'Жетінші атыс желісі',
        2015: 'Сегізінші тур'
    },
    28: {
        2801: 'Негізгі уақыт',
        2802: 'Матч аяқталды',
        2800: 'Матч әлі басталған жоқ'
    },
    29: {
        2911: '6-шы партия',
        2912: 'Үзіліс',
        2913: '7-ші партия',
        2914: 'Үзіліс',
        2915: '8-ші партия',
        2916: 'Үзіліс',
        2917: '9-шы партия',
        2918: 'Үзіліс',
        2919: '10-шы партия',
        2920: 'Үзіліс',
        2921: '11-ші партия',
        2964: 'Үзіліс',
        2965: '33-ші партия',
        2966: 'Үзіліс',
        2967: '34-ші партия',
        2968: 'Үзіліс',
        2969: '35-ші партия',
        2970: 'Үзіліс',
        2971: '36-шы партия',
        2972: 'Үзіліс',
        2973: '37-ші партия',
        2974: 'Матч аяқталды',
        2943: '22-ші партия',
        2944: 'Үзіліс',
        2945: '23-ші партия',
        2946: 'Үзіліс',
        2947: '24-ші партия',
        2948: 'Үзіліс',
        2949: '25-ші партия',
        2950: 'Үзіліс',
        2951: '26-шы партия',
        2952: 'Үзіліс',
        2953: '27-ші партия',
        2954: 'Үзіліс',
        2955: '28-ші партия',
        2956: 'Үзіліс',
        2957: '29-шы партия',
        2958: 'Үзіліс',
        2959: '30-шы партия',
        2960: 'Үзіліс',
        2961: '31-ші партия',
        2962: 'Үзіліс',
        2963: '32-ші партия',
        2922: 'Үзіліс',
        2923: '12-ші партия',
        2924: 'Үзіліс',
        2925: '13-ші партия',
        2926: 'Үзіліс',
        2927: '14-ші партия',
        2928: 'Үзіліс',
        2929: '15-ші партия',
        2930: 'Үзіліс',
        2931: '16-шы партия',
        2932: 'Үзіліс',
        2933: '17-ші партия',
        2934: 'Үзіліс',
        2935: '18-ші партия',
        2936: 'Үзіліс',
        2937: '19-шы партия',
        2938: 'Үзіліс',
        2939: '20-шы партия',
        2940: 'Үзіліс',
        2941: '21-ші партия',
        2942: 'Үзіліс',
        2900: 'Матч әлі басталған жоқ',
        2901: '1-ші партия',
        2902: 'Үзіліс',
        2903: '2-ші партия',
        2904: 'Үзіліс',
        2905: '3-ші партия',
        2906: 'Үзіліс',
        2907: '4-ші партия',
        2908: 'Үзіліс',
        2909: '5-ші партия',
        2910: 'Үзіліс'
    },
    30: {
        3008: 'Қосымша уақыт аяқталды',
        3007: 'Овертайм',
        3006: 'Негізгі уақыт аяқталды',
        3005: 'Үшінші кезең',
        3004: 'Екінші үзіліс',
        3009: 'Буллеттер',
        3002: 'Бірінші үзіліс',
        3001: 'Бірінші кезең',
        3000: 'Матч әлі басталған жоқ',
        3010: 'Матч аяқталды',
        3003: 'Екінші кезең'
    },
    31: {
        3108: 'Кідірту',
        3107: 'Төртінші ширек',
        3106: 'Кідірту',
        3105: 'Үшінші ширек',
        3104: 'Үзіліс',
        3109: 'Овертайм',
        3102: 'Кідірту',
        3101: 'Бірінші ширек',
        3100: 'Матч әлі басталған жоқ',
        3110: 'Матч аяқталды',
        3103: 'Екінші ширек'
    },
    32: {
        3203: 'Үшінші сет',
        3202: 'Екінші сет',
        3201: 'Бірінші сет',
        3200: 'Матч әлі басталған жоқ',
        3204: 'Матч аяқталды'
    },
    34: {
        3400: 'Матч әлі басталған жоқ',
        3401: 'Бірінші тайм',
        3402: 'Үзіліс',
        3403: 'Екінші тайм',
        3404: 'Негізгі уақыт аяқталды',
        3410: 'Матч аяқталды',
        3406: 'Бірінші қосымша уақыт аяқталады',
        3407: 'Екінші қосымша уақыт',
        3408: 'Екінші қосымша уақыт аяқталады',
        3409: 'Пенальти',
        3405: 'Бірінші қосымша уақыт'
    },
    35: {
        3500: 'Матч әлі басталған жоқ',
        3501: 'Бірінші тайм',
        3502: 'Үзіліс',
        3503: 'Екінші тайм',
        3504: 'Матч аяқталды'
    },
    36: {
        3601: 'Бірінші кезең',
        3602: 'Бірінші үзіліс',
        3603: 'Екінші кезең',
        3604: 'Екінші үзіліс',
        3605: 'Үшінші кезең',
        3600: 'Матч әлі басталған жоқ',
        3607: 'Овертайм',
        3608: 'Қосымша уақыт аяқталды',
        3609: 'Буллеттер',
        3610: 'Матч аяқталды',
        3606: 'Негізгі уақыт аяқталды'
    },
    37: {
        3701: 'Матч аяқталды',
        3700: 'Матч әлі басталған жоқ'
    },
    38: {
        3801: 'Матч аяқталды',
        3800: 'Матч әлі басталған жоқ'
    },
    39: {
        3901: 'Матч аяқталды',
        3900: 'Матч әлі басталған жоқ',
        3902: 'Бірінші раунд',
        3903: 'Екінші тур',
        3904: 'Үшінші раунд',
        3905: 'Төртінші раунд',
        3906: 'Бесінші раунд',
    },
    40: {
        4001: 'Матч аяқталды',
        4000: 'Матч әлі басталған жоқ'
    },
    41: {
        4102: 'Бірінші үзіліс',
        4106: 'Матч аяқталды',
        4105: 'Овертайм',
        4104: 'Екінші үзіліс',
        4103: 'Екінші жартылық',
        4101: 'Бірінші жартылық',
        4100: 'Матч әлі басталған жоқ'
    },
    42: {
        4202: 'Екінші карта',
        4206: 'Матч аяқталды',
        4205: 'Бесінші карта',
        4204: 'Төртінші карта',
        4203: 'Үшінші карта',
        4201: 'Бірінші карта',
        4200: 'Матч әлі басталған жоқ'
    }
};

export function getGroupName(sportId, groupType) {
    if (groupConfig !== undefined &&
        groupConfig[sportId] !== undefined) {
        return groupConfig[sportId][groupType];
    }

    return undefined;
}

export function getSlotName(sportId, match, slot) {
    let func;

    if (slotConfig !== undefined &&
       slotConfig[sportId] !== undefined) {
        func = slotConfig[sportId][slot.type];
    }

    if (func === undefined) {
        return undefined; 
    }

    return func(match, slot);
}


export function getOutcomeName(sportId, outcome, match) {
    let func;

    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }

    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getRateName(sportId, outcome, factorType, match) {
    let func;

    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getMatchInfoText(matchInfoType) {
    switch(matchInfoType) {
        case 1:
            return "Матч басталған жоқ";
        case 2:
            return "Матч аяқталды";
        case 3:
            return "Үзіліс";
        case 4:
            return "Негізгі уақыт аяқталды";
        case 5:
            return "Бірінші қосымша тайм аяқталды";
        case 6:
            return "Пенальти сериясы";
    }
    
    return "";
}

export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return  periodConfig[sportId][periodId];
    }

    return undefined;
}

export function getFoulsText() {
    return "Фолдар";
}

export function getTimeoutText() {
    return "Үзіліс";
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/localization/kk.js